"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.BankCardType = exports.BankCardTier = exports.BankCardTemporaryLockReason = exports.BankCardStatus = exports.BankCardRequestStatus = exports.BankCardRequestReason = exports.BankCardPermanentLockReason = exports.BankCardPaymentProcessor = exports.BankCardOrderVerificationStatus = exports.BankCardOrderStatus = exports.BankCardOrderPrefundVerificationActions = exports.BankCardOrderIdentityVerificationActions = exports.BankCardOrderFundingSourceVerificationPendingReason = exports.BankCardOrderFundingSourceVerificationActions = exports.BankCardOrderFailureReason = exports.BankCardOrderAddressVerificationActions = exports.BankCardLockTypeCode = exports.BankCardLockReason = exports.BankAccountType = exports.BankAccountStatus = exports.BankAccountStateStatus = exports.BankAccountRequirementType = exports.BankAccountRequirementStatus = exports.BankAccountLockReason = exports.BankAccountGoalType = exports.BankAccountClosureReason = exports.BadgeCategory = exports.BackendJobBatchType = exports.BackendJobBatchTimeframe = exports.BackendJobBatchStatus = exports.AutomationErrorCode = exports.AuthType = exports.AddressType = exports.AddressDeliverabilityVerificationErrorFailureReason = exports.ActivityType = exports.ActivitySummaryProduct = exports.ActionType = exports.ActionScreenContext = exports.ActionFeedEventType = exports.ActionFeedEventAction = exports.ActionFeedCtaType = exports.ActionFeedContext = exports.ActionCardStyle = exports.AcornsPartnerStatus = exports.AchievementItem = exports.AccountType = exports.AccountStatus = exports.AccountRequirementType = exports.AccountRequirementStatus = exports.AcceptanceDocumentType = void 0;
exports.CreditReasonCode = exports.CredentialsType = exports.CredentialStatus = exports.ContributionState = exports.ContributionRequiredAction = exports.ConnectionStatus = exports.CollectionMethod = exports.CohortEligibilityScope = exports.ClaimStatus = exports.CitationType = exports.CheckoutCartStatus = exports.CheckPaymentStatus = exports.CheckPaymentFailureReason = exports.ChatFeatures = exports.ChatContext = exports.ChatAuthor = exports.ChallengeTriggers = exports.ChallengePushState = exports.ChallengeDeliveryType = exports.CarouselType = exports.CampaignStatus = exports.CampaignRewardFilterType = exports.CampaignQualificationActionType = exports.CampaignIconType = exports.CampaignFilterType = exports.CampaignBackgroundType = exports.CacheControlScope = exports.BrazeEvent = exports.BillingFrequency = exports.BillingCycleState = exports.BenefitsTrackerProducts = exports.BenefitsProduct = exports.BenefitsPartner = exports.BenefitStatusDetail = exports.BenefitPromotedThrough = exports.BenefitProductStatus = exports.BeneficiaryType = exports.BankingProduct = exports.BankingEligibilityReason = exports.BankingEligibilityFeature = exports.BankType = exports.BankTransactionType = exports.BankTransactionStatus = exports.BankStatementType = exports.BankName = exports.BankFeeType = exports.BankFeeNegotiationStatus = exports.BankFeeNegotiationInternalStatus = exports.BankFeeNegotiationExternalStatus = exports.BankConnectionStatus = void 0;
exports.FundingSourceType = exports.FundingSourceStatusEnum = exports.FundingSourceStatus = exports.FundingSourceRoleEnum = exports.FriendStatusV2 = exports.FriendStatus = exports.FormType = exports.FinancialEducation = exports.FilingType = exports.FeedContext = exports.FeeType = exports.FeeStatusFilter = exports.FeeStatus = exports.FeeExecutionMethod = exports.ExternalUserSource = exports.ExternalSubscriptionType = exports.ExternalSource = exports.EmploymentStatus = exports.Employees = exports.EligibilityScope = exports.EarnRewardType = exports.EarnRewardStatus = exports.EarnRewardInvestType = exports.EarnRewardFulfillmentType = exports.EarnPurchaseMethod = exports.EarnOnboardingMilestoneCtaType = exports.EarnOfferIncentiveType = exports.EarnOfferIncentiveTemplate = exports.EarnOfferIncentiveRate = exports.EarlyInvestmentAccountType = exports.EtfTimescale = exports.DocumentVerificationDecision = exports.DocumentType = exports.DocumentStatus = exports.DocumentQueryType = exports.DiversificationBucketType = exports.DistributionType = exports.DirectDepositVendor = exports.DirectDepositStatus = exports.DirectDepositDistribution = exports.DigitalWalletDeviceType = exports.DeviceType = exports.DepositField = exports.DealType = exports.DayOfWeek = exports.CustomerEarnOnboardingStatus = exports.CustomerAccountStatus = exports.CustomerAccountClosureState = exports.Currency = exports.CtaType = void 0;
exports.LinkProviderType = exports.LinkCustomization = exports.LearnSearchContentType = exports.LearnRangeType = exports.LearnQuestionType = exports.LearnProgressUnit = exports.LearnProductKey = exports.LearnPollType = exports.LearnMediaType = exports.LearnContentViewStatus = exports.LearnContentType = exports.LearnContentSortType = exports.LearnAspectRatioType = exports.LaterWithdrawalType = exports.LaterWithdrawalReason = exports.LaterHistoryItemType = exports.LaterAccountStatus = exports.LaterAccountCodes = exports.KycStatus = exports.JobSearchFilterKey = exports.InvestmentTypes = exports.InvestmentType = exports.InvestmentTransactionType = exports.InvestmentStatusV2 = exports.InvestmentStatus = exports.InvestmentRoundUpType = exports.InvestmentProduct = exports.InvestmentGoal = exports.InvestmentFrequency = exports.InvestmentAllocationType = exports.InvestmentAllocationStatus = exports.InvestmentAccountTypes = exports.InvestmentAccountType = exports.InvestmentAccountStatus = exports.InvestmentAccountReopenRequestState = exports.InvestmentAccountReopenCheck = exports.InvestmentAccountClosureReason = exports.InvestingStrategyFactorKey = exports.InvalidSecurityForAllocationReasonEnum = exports.IntentStatus = exports.IneligibleReasons = exports.ImageType = exports.IdentitySubaccount = exports.IconType = exports.HoldingsTransferType = exports.HelpcenterBannerType = exports.HelpFormType = exports.FunnelName = exports.Funnel = exports.FundsAvailability = void 0;
exports.OfferExpirationPeriod = exports.OfferAvailability = exports.OauthAppType = exports.NetTermsType = exports.NegotiationType = exports.NegotiationMethod = exports.MoneyRulesRuleType = exports.MoneyRulesDistributionUnit = exports.MoneyRulesDepositType = exports.MoneyRulesConditionUnit = exports.MoneyRulesConditionType = exports.MoneyRulesArchetype = exports.MoneyRulesAccountType = exports.MoneyManagerStatus = exports.MoneyManagerState = exports.MoneyManagerRecurringFrequency = exports.MoneyManagerRebalanceSuppressionSource = exports.MoneyManagerRebalanceSouceAccountType = exports.MoneyManagerPeriodUnit = exports.MoneyManagerMoneyAssignmentType = exports.MoneyManagerMoneyAssignmentStatus = exports.MoneyManagerDepositState = exports.MoneyManagerDepositCategory = exports.MoneyManagerCategoryType = exports.MoneyManagerCascadeObjectiveType = exports.MoneyManagerCancelReason = exports.MoneyManagerAutomationTargetType = exports.MoneyManagerAllocationStatus = exports.MoneyManagerAllocationNotEditableReason = exports.MilestoneTheme = exports.MilestoneStatus = exports.MilestoneRuleType = exports.MilestoneRuleArgInput = exports.MilestoneEligibilityScope = exports.MilestoneAchievementActionType = exports.MessageType = exports.MessageStatus = exports.MessageFeedbackReason = exports.MessageCategory = exports.MaritalStatus = exports.ManagePayoutRelationshipResult = exports.ManagePayoutRelationshipAction = exports.MailInDocumentType = exports.LiquidationUnavailableReason = exports.LinkedSubaccountRoleEnum = exports.LinkedSubaccountPaymentEngineEnum = exports.LinkedAccountStatusEnum = exports.LinkedAccountLinkingErrorsEnum = exports.LinkedAccountExternalSourceEnum = exports.LinkSessionLanguage = void 0;
exports.ReferralValueType = exports.ReferralStatus = exports.ReferralRewardUpdateStatus = exports.ReferralRewardStatus = exports.ReferralRelationshipStatus = exports.ReferralPayoutStatus = exports.ReferralEventTypeV2 = exports.ReferralEventType = exports.ReferralEventStatus = exports.ReferralCampaignRewardType = exports.ReferralCampaignRewardTarget = exports.RecurringTransferPathExceptionCase = exports.RecurringTransferFundingSourceType = exports.RecurringTransferDirection = exports.RecurringTransferAccountType = exports.RecurrenceFrequency = exports.PublishedCampaignStatus = exports.ProspectType = exports.PromotionDurationPeriod = exports.PromoCodeStatus = exports.PromoCodeRewardType = exports.PromoCodeQualificationAction = exports.PromoCodeBusinessLine = exports.ProgramAccountType = exports.ProductType = exports.ProductSetupTipType = exports.ProductKey = exports.ProductAccountType = exports.PresentableWithdrawalStatus = exports.PortfolioTheme = exports.PortfolioRiskLevel = exports.PortfolioCustomizationLevel = exports.Platform = exports.PinwheelLinkTokenRequiredJobs = exports.PastItemStatus = exports.PasswordResetErrors = exports.PageName = exports.PackageStatus = exports.Origin = exports.Order = exports.OperationStage = exports.OnboardingType = exports.OnboardingTipType = exports.OnboardingRequirement = exports.OnboardingProducts = exports.OnboardingGroups = exports.OidcProvider = exports.OfferType = exports.OfferPriceType = exports.OfferGroupsType = void 0;
exports.TierSubscriptionCreatedBy = exports.TierKey = exports.TierDowngradeActionKey = exports.TfaType = exports.TfaStatus = exports.TfaNotification = exports.TaxReturnStatus = exports.TaxFormType = exports.TaxApplicationStatus = exports.SwitchType = exports.SwitchStatus = exports.SwitchState = exports.SwitchSource = exports.SwitchMethod = exports.SuitabilityAccountType = exports.SuitabilityAccountSubtype = exports.SubscriptionTransitionAction = exports.SubscriptionPaymentMethod = exports.SubscriptionMigrationWaiverReason = exports.SubmissionStatus = exports.StatementType = exports.StatementPortfolioType = exports.StateCode = exports.SplitDepositTargetAccountType = exports.SplitDepositSettingType = exports.SplitDepositRecurrenceFrequency = exports.SplitDepositNormalizationFrequency = exports.SpendAccountStatus = exports.SignatureType = exports.SessionType = exports.SelfDirectedPortfolioStatus = exports.SecurityType = exports.SecuritiesBySectorOrderBy = exports.SearchTermCategory = exports.SearchSecuritiesOrderBy = exports.ScheduleType = exports.SavingsAccountType = exports.SavingsAccountEligibilityRequirement = exports.SalaryInterval = exports.SsnStorageResult = exports.RoundUpType = exports.RoundUpState = exports.RiskStatus = exports.RevokeAccessReasons = exports.RevenueScheduleType = exports.RetirementPlanAccess = exports.RequestVersions = exports.RejectedReason = exports.ReissueBankCardIneligibleIssue = exports.ReinvestmentReason = void 0;
exports.useValidatePasswordResetTokenLazyQuery = exports.useValidatePasswordResetTokenQuery = exports.ValidatePasswordResetTokenDocument = exports.useResetPasswordWithTokenMutation = exports.ResetPasswordWithTokenDocument = exports.useReinitiateChallengeMutation = exports.ReinitiateChallengeDocument = exports.useChallengeAuthenticateMutation = exports.ChallengeAuthenticateDocument = exports.useEmailAddressValidationLazyQuery = exports.useEmailAddressValidationQuery = exports.EmailAddressValidationDocument = exports.useAuthenticateMutation = exports.AuthenticateDocument = exports.useLogoutMutation = exports.LogoutDocument = exports.useValidateCredentialsMutation = exports.ValidateCredentialsDocument = exports.ReferralStatusDetails = exports.WaiverPromotion_V2 = exports.WaiverPromotion = exports.VerificationStatus = exports.UserMatchStatus = exports.UsStateCodes = exports.Type = exports.TransferableAccountTypeEnum = exports.TransferState = exports.TransferAction = exports.TransactionType = exports.TransactionCategory = exports.TradingSector = exports.TimeFrameFilter = exports.TierSubscriptionStatus = exports.TierSubscriptionDeactivationReason = void 0;
var graphql_tag_1 = require("graphql-tag");
var ApolloReactHooks = require("@apollo/react-hooks");
var defaultOptions = {};
var AcceptanceDocumentType;
(function (AcceptanceDocumentType) {
    /**
     * Required agreement when user is signed up through a referral program or code
     * @deprecated Referral disclosure is no longer required for referred users
     */
    AcceptanceDocumentType["ReferralDisclosure"] = "referralDisclosure";
})(AcceptanceDocumentType = exports.AcceptanceDocumentType || (exports.AcceptanceDocumentType = {}));
var AccountRequirementStatus;
(function (AccountRequirementStatus) {
    AccountRequirementStatus["Completed"] = "COMPLETED";
    AccountRequirementStatus["NotStarted"] = "NOT_STARTED";
    AccountRequirementStatus["Pending"] = "PENDING";
})(AccountRequirementStatus = exports.AccountRequirementStatus || (exports.AccountRequirementStatus = {}));
var AccountRequirementType;
(function (AccountRequirementType) {
    AccountRequirementType["FundingSource"] = "FUNDING_SOURCE";
    AccountRequirementType["Liquidated"] = "LIQUIDATED";
    AccountRequirementType["NoPendingInvestments"] = "NO_PENDING_INVESTMENTS";
    AccountRequirementType["NoTransferringDividends"] = "NO_TRANSFERRING_DIVIDENDS";
    AccountRequirementType["NoTransferringInvestments"] = "NO_TRANSFERRING_INVESTMENTS";
    AccountRequirementType["RecurringDepositsDisabled"] = "RECURRING_DEPOSITS_DISABLED";
    AccountRequirementType["SelfDirectedPortfolioClosed"] = "SELF_DIRECTED_PORTFOLIO_CLOSED";
    AccountRequirementType["VerifiedFundingSource"] = "VERIFIED_FUNDING_SOURCE";
})(AccountRequirementType = exports.AccountRequirementType || (exports.AccountRequirementType = {}));
var AccountStatus;
(function (AccountStatus) {
    /** Account has been closed */
    AccountStatus["Closed"] = "closed";
    /** Account closure is in progress */
    AccountStatus["Inactive"] = "inactive";
    /** Open account ready for use */
    AccountStatus["Open"] = "open";
    /** Account is in process of being opened or verified */
    AccountStatus["Pending"] = "pending";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountType;
(function (AccountType) {
    /** Core basic investment account */
    AccountType["Basic"] = "basic";
    /** Spend LSB checking account */
    AccountType["Checking"] = "checking";
    /** Later ROTH IRA account */
    AccountType["RothIra"] = "rothIra";
    /** Later SEP IRA account */
    AccountType["SepIra"] = "sepIra";
    /** Later traditional IRA account */
    AccountType["TraditionalIra"] = "traditionalIra";
    /** Uniform Gift to Minors Act */
    AccountType["Ugma"] = "ugma";
    /** Uniform Transfers to Minors Act */
    AccountType["Utma"] = "utma";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AchievementItem;
(function (AchievementItem) {
    AchievementItem["AccountValueGte10"] = "accountValueGte10";
    AchievementItem["AccountValueGte100"] = "accountValueGte100";
    AchievementItem["AutomaticInvestmentOn"] = "automaticInvestmentOn";
    AchievementItem["AutomaticRoundupsOn"] = "automaticRoundupsOn";
    AchievementItem["FundingSourceLinked"] = "fundingSourceLinked";
    AchievementItem["MultipleRoundupAccountsLinked"] = "multipleRoundupAccountsLinked";
    AchievementItem["RegistrationComplete"] = "registrationComplete";
    AchievementItem["RoundupAccountLinked"] = "roundupAccountLinked";
})(AchievementItem = exports.AchievementItem || (exports.AchievementItem = {}));
var AcornsPartnerStatus;
(function (AcornsPartnerStatus) {
    AcornsPartnerStatus["Active"] = "ACTIVE";
    AcornsPartnerStatus["Expired"] = "EXPIRED";
    AcornsPartnerStatus["ExpiringSoon"] = "EXPIRING_SOON";
    AcornsPartnerStatus["Inactive"] = "INACTIVE";
    AcornsPartnerStatus["InProgress"] = "IN_PROGRESS";
})(AcornsPartnerStatus = exports.AcornsPartnerStatus || (exports.AcornsPartnerStatus = {}));
var ActionCardStyle;
(function (ActionCardStyle) {
    /** alert */
    ActionCardStyle["Alert"] = "alert";
    /** announcingLater */
    ActionCardStyle["AnnouncingLater"] = "announcingLater";
    /** basic */
    ActionCardStyle["Basic"] = "basic";
    /** basicVideo */
    ActionCardStyle["BasicVideo"] = "basicVideo";
    /** foundMoney */
    ActionCardStyle["FoundMoney"] = "foundMoney";
    /** grow */
    ActionCardStyle["Grow"] = "grow";
    /** snackable */
    ActionCardStyle["Snackable"] = "snackable";
    /** widget */
    ActionCardStyle["Widget"] = "widget";
})(ActionCardStyle = exports.ActionCardStyle || (exports.ActionCardStyle = {}));
var ActionFeedContext;
(function (ActionFeedContext) {
    /** feed context */
    ActionFeedContext["A3Core"] = "a3Core";
    /** feed context */
    ActionFeedContext["A3Later"] = "a3Later";
    /** feed context */
    ActionFeedContext["A3Present"] = "a3Present";
    /** feed context */
    ActionFeedContext["A3Spend"] = "a3Spend";
    /** feed context */
    ActionFeedContext["A4BankingHub"] = "a4BankingHub";
    /** feed context */
    ActionFeedContext["A4CheckingEngagementWizard"] = "a4CheckingEngagementWizard";
    /** feed context */
    ActionFeedContext["A4CheckingHub"] = "a4CheckingHub";
    /** feed context */
    ActionFeedContext["A4Early"] = "a4Early";
    /** feed context */
    ActionFeedContext["A4EarlyDetails"] = "a4EarlyDetails";
    /** feed context */
    ActionFeedContext["A4Home"] = "a4Home";
    /** feed context */
    ActionFeedContext["A4HomeBottomNav"] = "a4HomeBottomNav";
    /** feed context */
    ActionFeedContext["A4Invest"] = "a4Invest";
    /** feed context */
    ActionFeedContext["A4InvestHub"] = "a4InvestHub";
    /** feed context */
    ActionFeedContext["A4Kids"] = "a4Kids";
    /** feed context */
    ActionFeedContext["A4Later"] = "a4Later";
    /** feed context */
    ActionFeedContext["A4LearnHub"] = "a4LearnHub";
    /** feed context */
    ActionFeedContext["A4Savings"] = "a4Savings";
    /** feed context */
    ActionFeedContext["A4Spend"] = "a4Spend";
    /** feed context */
    ActionFeedContext["Later"] = "later";
    /** feed context */
    ActionFeedContext["Present"] = "present";
})(ActionFeedContext = exports.ActionFeedContext || (exports.ActionFeedContext = {}));
var ActionFeedCtaType;
(function (ActionFeedCtaType) {
    /** triggers an email download */
    ActionFeedCtaType["Email"] = "email";
    /** grow article link */
    ActionFeedCtaType["GrowArticle"] = "grow_article";
    /** link */
    ActionFeedCtaType["Link"] = "link";
    /** insights sequence offer */
    ActionFeedCtaType["Offer"] = "offer";
    /** insights sequence spell */
    ActionFeedCtaType["Spell"] = "spell";
    /** customer feedback survey */
    ActionFeedCtaType["Survey"] = "survey";
    /** link to view a video */
    ActionFeedCtaType["Video"] = "video";
    /** insights sequence wizard */
    ActionFeedCtaType["Wizard"] = "wizard";
})(ActionFeedCtaType = exports.ActionFeedCtaType || (exports.ActionFeedCtaType = {}));
var ActionFeedEventAction;
(function (ActionFeedEventAction) {
    /** Completed */
    ActionFeedEventAction["Completed"] = "completed";
    /** Dismissed */
    ActionFeedEventAction["Dismissed"] = "dismissed";
    /** Card Impression */
    ActionFeedEventAction["Impression"] = "impression";
    /** CTA Tapped */
    ActionFeedEventAction["Tapped"] = "tapped";
})(ActionFeedEventAction = exports.ActionFeedEventAction || (exports.ActionFeedEventAction = {}));
var ActionFeedEventType;
(function (ActionFeedEventType) {
    /** Card Event - impression, tapped, dismissed */
    ActionFeedEventType["Card"] = "CARD";
    /** Tip Event - completed, dismissed */
    ActionFeedEventType["Tip"] = "TIP";
})(ActionFeedEventType = exports.ActionFeedEventType || (exports.ActionFeedEventType = {}));
var ActionScreenContext;
(function (ActionScreenContext) {
    /** screen context */
    ActionScreenContext["A4BankingHub"] = "a4BankingHub";
    /** screen context */
    ActionScreenContext["A4CheckingHub"] = "a4CheckingHub";
    /** screen context */
    ActionScreenContext["A4EarlyDetails"] = "a4EarlyDetails";
    /** screen context */
    ActionScreenContext["A4HomeBottomNav"] = "a4HomeBottomNav";
    /** screen context */
    ActionScreenContext["A4Invest"] = "a4Invest";
    /** screen context */
    ActionScreenContext["A4InvestHub"] = "a4InvestHub";
    /** screen context */
    ActionScreenContext["A4Kids"] = "a4Kids";
    /** screen context */
    ActionScreenContext["A4Later"] = "a4Later";
    /** screen context */
    ActionScreenContext["A4LearnHub"] = "a4LearnHub";
    /** screen context */
    ActionScreenContext["A4Savings"] = "a4Savings";
    /** screen context */
    ActionScreenContext["A4Spend"] = "a4Spend";
})(ActionScreenContext = exports.ActionScreenContext || (exports.ActionScreenContext = {}));
var ActionType;
(function (ActionType) {
    ActionType["Choose"] = "CHOOSE";
    ActionType["Continue"] = "CONTINUE";
    ActionType["Direct"] = "DIRECT";
    ActionType["Link"] = "LINK";
    ActionType["Manual"] = "MANUAL";
    ActionType["MoreInfo"] = "MORE_INFO";
    ActionType["Skip"] = "SKIP";
    ActionType["Switch"] = "SWITCH";
    /** Represents when a user switches funnels mid-way through a funnel */
    ActionType["Update"] = "UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ActivitySummaryProduct;
(function (ActivitySummaryProduct) {
    /** Early investment product */
    ActivitySummaryProduct["Early"] = "EARLY";
    /** Core investment product */
    ActivitySummaryProduct["Invest"] = "INVEST";
    /** Later investment product */
    ActivitySummaryProduct["Later"] = "LATER";
})(ActivitySummaryProduct = exports.ActivitySummaryProduct || (exports.ActivitySummaryProduct = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["AchFee"] = "achFee";
    ActivityType["BonusRoundup"] = "bonusRoundup";
    ActivityType["Credit"] = "credit";
    ActivityType["DirectFee"] = "directFee";
    ActivityType["Dividend"] = "dividend";
    ActivityType["EmployeeContribution"] = "employeeContribution";
    ActivityType["Fee"] = "fee";
    ActivityType["FoundMoney"] = "foundMoney";
    ActivityType["GiftCard"] = "giftCard";
    ActivityType["OneTimeInvestment"] = "oneTimeInvestment";
    ActivityType["PartnerReward"] = "partnerReward";
    ActivityType["Rebalance"] = "rebalance";
    ActivityType["RecurringInvestment"] = "recurringInvestment";
    ActivityType["ReferralReward"] = "referralReward";
    ActivityType["RoundUp"] = "roundUp";
    ActivityType["Seeding"] = "seeding";
    ActivityType["Withdrawal"] = "withdrawal";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var AddressDeliverabilityVerificationErrorFailureReason;
(function (AddressDeliverabilityVerificationErrorFailureReason) {
    /** The input address matched to a physical address that does not receive delivery from the USPS */
    AddressDeliverabilityVerificationErrorFailureReason["AddressNotDeliverable"] = "addressNotDeliverable";
    /** The input address is missing or was not found */
    AddressDeliverabilityVerificationErrorFailureReason["AddressNotFound"] = "addressNotFound";
    /** The input matched multiple addresses, needs more info */
    AddressDeliverabilityVerificationErrorFailureReason["AmbiguousAddress"] = "ambiguousAddress";
    /** The input address has an invalid house number */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidAddressPrimaryNumber"] = "invalidAddressPrimaryNumber";
    /** The input address contains an invalid ste, apt, or box number */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidAddressSecondaryNumber"] = "invalidAddressSecondaryNumber";
    /** The input city is missing or invalid */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidCity"] = "invalidCity";
    /** The input address' PO, RR, or HC box number invalid */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidPoBoxNumber"] = "invalidPoBoxNumber";
    /** The input state code is missing or invalid */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidState"] = "invalidState";
    /** The input postal code is missing or invalid */
    AddressDeliverabilityVerificationErrorFailureReason["InvalidZipCode"] = "invalidZipCode";
    /** The input address is missing a house number */
    AddressDeliverabilityVerificationErrorFailureReason["MissingAddressPrimaryNumber"] = "missingAddressPrimaryNumber";
    /** The input address is missing ste, apt, or box number */
    AddressDeliverabilityVerificationErrorFailureReason["MissingAddressSecondaryNumber"] = "missingAddressSecondaryNumber";
    /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
    AddressDeliverabilityVerificationErrorFailureReason["MissingPmbNumber"] = "missingPmbNumber";
    /** The input address is missing PO, RR, or HC box number */
    AddressDeliverabilityVerificationErrorFailureReason["MissingPoBoxNumber"] = "missingPoBoxNumber";
    /** An unknown or unmapped error occurred */
    AddressDeliverabilityVerificationErrorFailureReason["Unknown"] = "unknown";
})(AddressDeliverabilityVerificationErrorFailureReason = exports.AddressDeliverabilityVerificationErrorFailureReason || (exports.AddressDeliverabilityVerificationErrorFailureReason = {}));
var AddressType;
(function (AddressType) {
    /** A billing address */
    AddressType["Billing"] = "billing";
    /** A mailing address */
    AddressType["Mailing"] = "mailing";
    /** A residential address */
    AddressType["Residential"] = "residential";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var AuthType;
(function (AuthType) {
    AuthType["Email"] = "EMAIL";
    AuthType["Phone"] = "PHONE";
    AuthType["Push"] = "PUSH";
})(AuthType = exports.AuthType || (exports.AuthType = {}));
var AutomationErrorCode;
(function (AutomationErrorCode) {
    AutomationErrorCode["CttEx"] = "CTT_EX";
    AutomationErrorCode["LogBlk"] = "LOG_BLK";
    AutomationErrorCode["LogEx"] = "LOG_EX";
    AutomationErrorCode["LogInv"] = "LOG_INV";
    AutomationErrorCode["SttEx"] = "STT_EX";
    AutomationErrorCode["SttRes"] = "STT_RES";
    AutomationErrorCode["TfaInv"] = "TFA_INV";
    AutomationErrorCode["TfaSelInv"] = "TFA_SEL_INV";
    AutomationErrorCode["WfTfa"] = "WF_TFA";
})(AutomationErrorCode = exports.AutomationErrorCode || (exports.AutomationErrorCode = {}));
var BackendJobBatchStatus;
(function (BackendJobBatchStatus) {
    BackendJobBatchStatus["Completed"] = "COMPLETED";
    BackendJobBatchStatus["Failed"] = "FAILED";
    BackendJobBatchStatus["InProgress"] = "IN_PROGRESS";
    BackendJobBatchStatus["Restarted"] = "RESTARTED";
    BackendJobBatchStatus["Started"] = "STARTED";
})(BackendJobBatchStatus = exports.BackendJobBatchStatus || (exports.BackendJobBatchStatus = {}));
var BackendJobBatchTimeframe;
(function (BackendJobBatchTimeframe) {
    BackendJobBatchTimeframe["LastSeven"] = "LAST_SEVEN";
    BackendJobBatchTimeframe["LastThirty"] = "LAST_THIRTY";
    BackendJobBatchTimeframe["Month"] = "MONTH";
    BackendJobBatchTimeframe["Today"] = "TODAY";
    BackendJobBatchTimeframe["Year"] = "YEAR";
    BackendJobBatchTimeframe["Yesterday"] = "YESTERDAY";
})(BackendJobBatchTimeframe = exports.BackendJobBatchTimeframe || (exports.BackendJobBatchTimeframe = {}));
var BackendJobBatchType;
(function (BackendJobBatchType) {
    BackendJobBatchType["AutomatedBuyOrderConfirm"] = "AUTOMATED_BUY_ORDER_CONFIRM";
    BackendJobBatchType["AutomatedBuyOrderLock"] = "AUTOMATED_BUY_ORDER_LOCK";
    BackendJobBatchType["AutomatedSellFeeOrderConfirm"] = "AUTOMATED_SELL_FEE_ORDER_CONFIRM";
    BackendJobBatchType["AutomatedSellFeeOrderLock"] = "AUTOMATED_SELL_FEE_ORDER_LOCK";
    BackendJobBatchType["BuyOrderConfirm"] = "BUY_ORDER_CONFIRM";
    BackendJobBatchType["BuyOrderLock"] = "BUY_ORDER_LOCK";
    BackendJobBatchType["ChargebackOrderLock"] = "CHARGEBACK_ORDER_LOCK";
    BackendJobBatchType["ProfitStarsDeposits"] = "PROFIT_STARS_DEPOSITS";
    BackendJobBatchType["RebalanceBuyOrderConfirm"] = "REBALANCE_BUY_ORDER_CONFIRM";
    BackendJobBatchType["RebalanceBuyOrderLock"] = "REBALANCE_BUY_ORDER_LOCK";
    BackendJobBatchType["RebalanceSellOrderConfirm"] = "REBALANCE_SELL_ORDER_CONFIRM";
    BackendJobBatchType["RebalanceSellOrderLock"] = "REBALANCE_SELL_ORDER_LOCK";
    BackendJobBatchType["SellFeeOrderConfirm"] = "SELL_FEE_ORDER_CONFIRM";
    BackendJobBatchType["SellFeeOrderLock"] = "SELL_FEE_ORDER_LOCK";
    BackendJobBatchType["TransferApproval"] = "TRANSFER_APPROVAL";
})(BackendJobBatchType = exports.BackendJobBatchType || (exports.BackendJobBatchType = {}));
var BadgeCategory;
(function (BadgeCategory) {
    BadgeCategory["NewCustomer"] = "NEW_CUSTOMER";
    BadgeCategory["Travel"] = "TRAVEL";
})(BadgeCategory = exports.BadgeCategory || (exports.BadgeCategory = {}));
var BankAccountClosureReason;
(function (BankAccountClosureReason) {
    /** Going to a competitor */
    BankAccountClosureReason["GoingToACompetitor"] = "GOING_TO_A_COMPETITOR";
    /** Had a bad experience */
    BankAccountClosureReason["HadABadExperience"] = "HAD_A_BAD_EXPERIENCE";
    /** Missing features I expect with a checking account */
    BankAccountClosureReason["MissingFeaturesExpectedWithCheckingAccount"] = "MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT";
    /** Not seeing the value */
    BankAccountClosureReason["NotSeeingTheValue"] = "NOT_SEEING_THE_VALUE";
    /** No longer use */
    BankAccountClosureReason["NoLongerUse"] = "NO_LONGER_USE";
    /** Other */
    BankAccountClosureReason["Other"] = "OTHER";
})(BankAccountClosureReason = exports.BankAccountClosureReason || (exports.BankAccountClosureReason = {}));
var BankAccountGoalType;
(function (BankAccountGoalType) {
    BankAccountGoalType["EmergencySavings"] = "EMERGENCY_SAVINGS";
})(BankAccountGoalType = exports.BankAccountGoalType || (exports.BankAccountGoalType = {}));
var BankAccountLockReason;
(function (BankAccountLockReason) {
    BankAccountLockReason["Administrative"] = "Administrative";
    BankAccountLockReason["CreditsOnly"] = "CreditsOnly";
    BankAccountLockReason["Fraud"] = "Fraud";
    BankAccountLockReason["Frozen"] = "Frozen";
    BankAccountLockReason["Temporary"] = "Temporary";
    BankAccountLockReason["Unknown"] = "Unknown";
})(BankAccountLockReason = exports.BankAccountLockReason || (exports.BankAccountLockReason = {}));
var BankAccountRequirementStatus;
(function (BankAccountRequirementStatus) {
    BankAccountRequirementStatus["ActionsRequired"] = "ACTIONS_REQUIRED";
    BankAccountRequirementStatus["Completed"] = "COMPLETED";
    BankAccountRequirementStatus["NotStarted"] = "NOT_STARTED";
    BankAccountRequirementStatus["Pending"] = "PENDING";
})(BankAccountRequirementStatus = exports.BankAccountRequirementStatus || (exports.BankAccountRequirementStatus = {}));
var BankAccountRequirementType;
(function (BankAccountRequirementType) {
    BankAccountRequirementType["FundingSource"] = "FUNDING_SOURCE";
    BankAccountRequirementType["NoPendingTransfers"] = "NO_PENDING_TRANSFERS";
    BankAccountRequirementType["UnlockedCheckingAccount"] = "UNLOCKED_CHECKING_ACCOUNT";
    BankAccountRequirementType["VerifiedFundingSource"] = "VERIFIED_FUNDING_SOURCE";
})(BankAccountRequirementType = exports.BankAccountRequirementType || (exports.BankAccountRequirementType = {}));
var BankAccountStateStatus;
(function (BankAccountStateStatus) {
    BankAccountStateStatus["Closed"] = "CLOSED";
    BankAccountStateStatus["HardFailure"] = "HARD_FAILURE";
    BankAccountStateStatus["Locked"] = "LOCKED";
    BankAccountStateStatus["NotOpened"] = "NOT_OPENED";
    BankAccountStateStatus["Open"] = "OPEN";
    BankAccountStateStatus["Opening"] = "OPENING";
    BankAccountStateStatus["Reopening"] = "REOPENING";
})(BankAccountStateStatus = exports.BankAccountStateStatus || (exports.BankAccountStateStatus = {}));
var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["Closed"] = "closed";
    BankAccountStatus["Locked"] = "locked";
    BankAccountStatus["Open"] = "open";
})(BankAccountStatus = exports.BankAccountStatus || (exports.BankAccountStatus = {}));
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["Save"] = "save";
    BankAccountType["Spend"] = "spend";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
var BankCardLockReason;
(function (BankCardLockReason) {
    BankCardLockReason["Admin"] = "admin";
    BankCardLockReason["Damage"] = "damage";
    BankCardLockReason["Fraud"] = "fraud";
    BankCardLockReason["Lost"] = "lost";
    BankCardLockReason["PinRetriesExceeded"] = "pinRetriesExceeded";
    BankCardLockReason["Stolen"] = "stolen";
    BankCardLockReason["Temporary"] = "temporary";
    BankCardLockReason["Unknown"] = "unknown";
})(BankCardLockReason = exports.BankCardLockReason || (exports.BankCardLockReason = {}));
var BankCardLockTypeCode;
(function (BankCardLockTypeCode) {
    BankCardLockTypeCode["Customer"] = "customer";
    BankCardLockTypeCode["System"] = "system";
    BankCardLockTypeCode["Unlocked"] = "unlocked";
})(BankCardLockTypeCode = exports.BankCardLockTypeCode || (exports.BankCardLockTypeCode = {}));
var BankCardOrderAddressVerificationActions;
(function (BankCardOrderAddressVerificationActions) {
    BankCardOrderAddressVerificationActions["UploadDocuments"] = "uploadDocuments";
})(BankCardOrderAddressVerificationActions = exports.BankCardOrderAddressVerificationActions || (exports.BankCardOrderAddressVerificationActions = {}));
var BankCardOrderFailureReason;
(function (BankCardOrderFailureReason) {
    BankCardOrderFailureReason["AddressFailure"] = "ADDRESS_FAILURE";
    BankCardOrderFailureReason["Expired"] = "EXPIRED";
    BankCardOrderFailureReason["FundingSourceFailure"] = "FUNDING_SOURCE_FAILURE";
    BankCardOrderFailureReason["IdentityFailure"] = "IDENTITY_FAILURE";
    BankCardOrderFailureReason["PrefundFailure"] = "PREFUND_FAILURE";
})(BankCardOrderFailureReason = exports.BankCardOrderFailureReason || (exports.BankCardOrderFailureReason = {}));
var BankCardOrderFundingSourceVerificationActions;
(function (BankCardOrderFundingSourceVerificationActions) {
    BankCardOrderFundingSourceVerificationActions["HandleFrozenFundingSource"] = "handleFrozenFundingSource";
    BankCardOrderFundingSourceVerificationActions["LinkFundingSource"] = "linkFundingSource";
    BankCardOrderFundingSourceVerificationActions["SubmitRdVs"] = "submitRDVs";
    BankCardOrderFundingSourceVerificationActions["UploadDocuments"] = "uploadDocuments";
})(BankCardOrderFundingSourceVerificationActions = exports.BankCardOrderFundingSourceVerificationActions || (exports.BankCardOrderFundingSourceVerificationActions = {}));
var BankCardOrderFundingSourceVerificationPendingReason;
(function (BankCardOrderFundingSourceVerificationPendingReason) {
    BankCardOrderFundingSourceVerificationPendingReason["DocumentsUnderReview"] = "documentsUnderReview";
    BankCardOrderFundingSourceVerificationPendingReason["RdvsInitiated"] = "rdvsInitiated";
    BankCardOrderFundingSourceVerificationPendingReason["RdvsPending"] = "rdvsPending";
})(BankCardOrderFundingSourceVerificationPendingReason = exports.BankCardOrderFundingSourceVerificationPendingReason || (exports.BankCardOrderFundingSourceVerificationPendingReason = {}));
var BankCardOrderIdentityVerificationActions;
(function (BankCardOrderIdentityVerificationActions) {
    BankCardOrderIdentityVerificationActions["UploadDocuments"] = "uploadDocuments";
})(BankCardOrderIdentityVerificationActions = exports.BankCardOrderIdentityVerificationActions || (exports.BankCardOrderIdentityVerificationActions = {}));
var BankCardOrderPrefundVerificationActions;
(function (BankCardOrderPrefundVerificationActions) {
    BankCardOrderPrefundVerificationActions["CreateBankTransfer"] = "createBankTransfer";
})(BankCardOrderPrefundVerificationActions = exports.BankCardOrderPrefundVerificationActions || (exports.BankCardOrderPrefundVerificationActions = {}));
var BankCardOrderStatus;
(function (BankCardOrderStatus) {
    BankCardOrderStatus["Accepted"] = "accepted";
    BankCardOrderStatus["ActionRequired"] = "actionRequired";
    BankCardOrderStatus["Failure"] = "failure";
    BankCardOrderStatus["NotOrdered"] = "notOrdered";
    BankCardOrderStatus["Pending"] = "pending";
    BankCardOrderStatus["Success"] = "success";
})(BankCardOrderStatus = exports.BankCardOrderStatus || (exports.BankCardOrderStatus = {}));
var BankCardOrderVerificationStatus;
(function (BankCardOrderVerificationStatus) {
    BankCardOrderVerificationStatus["ActionRequired"] = "actionRequired";
    BankCardOrderVerificationStatus["ActionRequiredDueToFailure"] = "actionRequiredDueToFailure";
    BankCardOrderVerificationStatus["Failure"] = "failure";
    BankCardOrderVerificationStatus["Pending"] = "pending";
    BankCardOrderVerificationStatus["Success"] = "success";
})(BankCardOrderVerificationStatus = exports.BankCardOrderVerificationStatus || (exports.BankCardOrderVerificationStatus = {}));
var BankCardPaymentProcessor;
(function (BankCardPaymentProcessor) {
    BankCardPaymentProcessor["Dps"] = "DPS";
    BankCardPaymentProcessor["Shazam"] = "SHAZAM";
})(BankCardPaymentProcessor = exports.BankCardPaymentProcessor || (exports.BankCardPaymentProcessor = {}));
var BankCardPermanentLockReason;
(function (BankCardPermanentLockReason) {
    BankCardPermanentLockReason["Fraud"] = "fraud";
    BankCardPermanentLockReason["Lost"] = "lost";
    BankCardPermanentLockReason["Stolen"] = "stolen";
})(BankCardPermanentLockReason = exports.BankCardPermanentLockReason || (exports.BankCardPermanentLockReason = {}));
var BankCardRequestReason;
(function (BankCardRequestReason) {
    BankCardRequestReason["Damaged"] = "DAMAGED";
    BankCardRequestReason["DeliveryIssue"] = "DELIVERY_ISSUE";
    BankCardRequestReason["Lost"] = "LOST";
    BankCardRequestReason["NewAccount"] = "NEW_ACCOUNT";
    BankCardRequestReason["Other"] = "OTHER";
    BankCardRequestReason["Stolen"] = "STOLEN";
})(BankCardRequestReason = exports.BankCardRequestReason || (exports.BankCardRequestReason = {}));
var BankCardRequestStatus;
(function (BankCardRequestStatus) {
    BankCardRequestStatus["Approved"] = "APPROVED";
    BankCardRequestStatus["Issued"] = "ISSUED";
    BankCardRequestStatus["Pending"] = "PENDING";
    BankCardRequestStatus["Rejected"] = "REJECTED";
    BankCardRequestStatus["Requested"] = "REQUESTED";
})(BankCardRequestStatus = exports.BankCardRequestStatus || (exports.BankCardRequestStatus = {}));
var BankCardStatus;
(function (BankCardStatus) {
    BankCardStatus["Archived"] = "archived";
    BankCardStatus["Denied"] = "denied";
    BankCardStatus["DigitalActivePhysicalInitiated"] = "digitalActivePhysicalInitiated";
    BankCardStatus["DigitalActivePhysicalPending"] = "digitalActivePhysicalPending";
    BankCardStatus["Expired"] = "expired";
    BankCardStatus["Hotlisted"] = "hotlisted";
    BankCardStatus["Initiated"] = "initiated";
    BankCardStatus["Pending"] = "pending";
    BankCardStatus["PendingVerification"] = "pendingVerification";
    BankCardStatus["Reissued"] = "reissued";
    BankCardStatus["Verified"] = "verified";
})(BankCardStatus = exports.BankCardStatus || (exports.BankCardStatus = {}));
var BankCardTemporaryLockReason;
(function (BankCardTemporaryLockReason) {
    BankCardTemporaryLockReason["Damage"] = "damage";
    BankCardTemporaryLockReason["Fraud"] = "fraud";
    BankCardTemporaryLockReason["Temporary"] = "temporary";
    BankCardTemporaryLockReason["Unknown"] = "unknown";
})(BankCardTemporaryLockReason = exports.BankCardTemporaryLockReason || (exports.BankCardTemporaryLockReason = {}));
var BankCardTier;
(function (BankCardTier) {
    BankCardTier["MightyOak"] = "mightyOak";
    BankCardTier["Oak"] = "oak";
    BankCardTier["PremiumOak"] = "premiumOak";
    BankCardTier["VipReissue"] = "vipReissue";
})(BankCardTier = exports.BankCardTier || (exports.BankCardTier = {}));
var BankCardType;
(function (BankCardType) {
    BankCardType["Credit"] = "credit";
    BankCardType["Debit"] = "debit";
})(BankCardType = exports.BankCardType || (exports.BankCardType = {}));
var BankConnectionStatus;
(function (BankConnectionStatus) {
    BankConnectionStatus["Eligible"] = "ELIGIBLE";
    BankConnectionStatus["IneligibleCooldown"] = "INELIGIBLE_COOLDOWN";
    BankConnectionStatus["IneligibleNotsupported"] = "INELIGIBLE_NOTSUPPORTED";
    BankConnectionStatus["IneligibleThreshold"] = "INELIGIBLE_THRESHOLD";
    BankConnectionStatus["Lowertier"] = "LOWERTIER";
    BankConnectionStatus["Pending"] = "PENDING";
})(BankConnectionStatus = exports.BankConnectionStatus || (exports.BankConnectionStatus = {}));
var BankFeeNegotiationExternalStatus;
(function (BankFeeNegotiationExternalStatus) {
    BankFeeNegotiationExternalStatus["ActionrequiredConnectionError"] = "ACTIONREQUIRED_CONNECTION_ERROR";
    BankFeeNegotiationExternalStatus["ActionrequiredReportRefund"] = "ACTIONREQUIRED_REPORT_REFUND";
    BankFeeNegotiationExternalStatus["ActionrequiredScheduleCall"] = "ACTIONREQUIRED_SCHEDULE_CALL";
    BankFeeNegotiationExternalStatus["CallScheduled"] = "CALL_SCHEDULED";
    BankFeeNegotiationExternalStatus["ResolvedNoRefund"] = "RESOLVED_NO_REFUND";
    BankFeeNegotiationExternalStatus["ResolvedRefund"] = "RESOLVED_REFUND";
    BankFeeNegotiationExternalStatus["Submitted"] = "SUBMITTED";
    BankFeeNegotiationExternalStatus["SubmittedSent"] = "SUBMITTED_SENT";
})(BankFeeNegotiationExternalStatus = exports.BankFeeNegotiationExternalStatus || (exports.BankFeeNegotiationExternalStatus = {}));
var BankFeeNegotiationInternalStatus;
(function (BankFeeNegotiationInternalStatus) {
    BankFeeNegotiationInternalStatus["AutofetchCompleted"] = "AUTOFETCH_COMPLETED";
    BankFeeNegotiationInternalStatus["AutoConnectionError"] = "AUTO_CONNECTION_ERROR";
    BankFeeNegotiationInternalStatus["AutoError"] = "AUTO_ERROR";
    BankFeeNegotiationInternalStatus["AutoInProgress"] = "AUTO_IN_PROGRESS";
    BankFeeNegotiationInternalStatus["CallScheduled"] = "CALL_SCHEDULED";
    BankFeeNegotiationInternalStatus["MailInError"] = "MAIL_IN_ERROR";
    BankFeeNegotiationInternalStatus["MailInEscalated"] = "MAIL_IN_ESCALATED";
    BankFeeNegotiationInternalStatus["MailInPending"] = "MAIL_IN_PENDING";
    BankFeeNegotiationInternalStatus["MailInScheduleCall"] = "MAIL_IN_SCHEDULE_CALL";
    BankFeeNegotiationInternalStatus["MailInSent"] = "MAIL_IN_SENT";
    BankFeeNegotiationInternalStatus["Pending"] = "PENDING";
    BankFeeNegotiationInternalStatus["ResolvedNoRefund"] = "RESOLVED_NO_REFUND";
    BankFeeNegotiationInternalStatus["ResolvedRefund"] = "RESOLVED_REFUND";
})(BankFeeNegotiationInternalStatus = exports.BankFeeNegotiationInternalStatus || (exports.BankFeeNegotiationInternalStatus = {}));
var BankFeeNegotiationStatus;
(function (BankFeeNegotiationStatus) {
    BankFeeNegotiationStatus["AutoConnectionError"] = "AUTO_CONNECTION_ERROR";
    BankFeeNegotiationStatus["AutoError"] = "AUTO_ERROR";
    BankFeeNegotiationStatus["AutoInProgress"] = "AUTO_IN_PROGRESS";
    BankFeeNegotiationStatus["CallScheduled"] = "CALL_SCHEDULED";
    BankFeeNegotiationStatus["MailInError"] = "MAIL_IN_ERROR";
    BankFeeNegotiationStatus["MailInEscalated"] = "MAIL_IN_ESCALATED";
    BankFeeNegotiationStatus["MailInPending"] = "MAIL_IN_PENDING";
    BankFeeNegotiationStatus["MailInScheduleCall"] = "MAIL_IN_SCHEDULE_CALL";
    BankFeeNegotiationStatus["MailInSent"] = "MAIL_IN_SENT";
    BankFeeNegotiationStatus["ResolvedNoRefund"] = "RESOLVED_NO_REFUND";
    BankFeeNegotiationStatus["ResolvedRefund"] = "RESOLVED_REFUND";
    BankFeeNegotiationStatus["Submitted"] = "SUBMITTED";
})(BankFeeNegotiationStatus = exports.BankFeeNegotiationStatus || (exports.BankFeeNegotiationStatus = {}));
var BankFeeType;
(function (BankFeeType) {
    BankFeeType["AccountMaintenanceFee"] = "ACCOUNT_MAINTENANCE_FEE";
    BankFeeType["AtmFee"] = "ATM_FEE";
    BankFeeType["BalanceInquiryFee"] = "BALANCE_INQUIRY_FEE";
    BankFeeType["CardSetupFee"] = "CARD_SETUP_FEE";
    BankFeeType["CashAdvance"] = "CASH_ADVANCE";
    BankFeeType["CheckFee"] = "CHECK_FEE";
    BankFeeType["ClosedAccountProcessingFee"] = "CLOSED_ACCOUNT_PROCESSING_FEE";
    BankFeeType["CreditCardInterestCharge"] = "CREDIT_CARD_INTEREST_CHARGE";
    BankFeeType["DormantFee"] = "DORMANT_FEE";
    BankFeeType["EarlyClosureFee"] = "EARLY_CLOSURE_FEE";
    BankFeeType["ExcessFee"] = "EXCESS_FEE";
    BankFeeType["ExternalTransferFee"] = "EXTERNAL_TRANSFER_FEE";
    BankFeeType["ForeignTransactionFee"] = "FOREIGN_TRANSACTION_FEE";
    BankFeeType["LateFee"] = "LATE_FEE";
    BankFeeType["MinimumBalanceFee"] = "MINIMUM_BALANCE_FEE";
    BankFeeType["MonthlyServiceFee"] = "MONTHLY_SERVICE_FEE";
    BankFeeType["NsfFee"] = "NSF_FEE";
    BankFeeType["OverdraftFee"] = "OVERDRAFT_FEE";
    BankFeeType["PaperStatementFee"] = "PAPER_STATEMENT_FEE";
    BankFeeType["StopPaymentFee"] = "STOP_PAYMENT_FEE";
    BankFeeType["WireTransferFee"] = "WIRE_TRANSFER_FEE";
})(BankFeeType = exports.BankFeeType || (exports.BankFeeType = {}));
var BankName;
(function (BankName) {
    BankName["Chase"] = "CHASE";
    BankName["NotApplicable"] = "NOT_APPLICABLE";
    BankName["TestBank"] = "TEST_BANK";
    BankName["WellsFargo"] = "WELLS_FARGO";
})(BankName = exports.BankName || (exports.BankName = {}));
var BankStatementType;
(function (BankStatementType) {
    BankStatementType["Monthly"] = "monthly";
    BankStatementType["Tax"] = "tax";
})(BankStatementType = exports.BankStatementType || (exports.BankStatementType = {}));
var BankTransactionStatus;
(function (BankTransactionStatus) {
    /** Transaction has been created but not yet put into a NACHA file */
    BankTransactionStatus["Initiated"] = "initiated";
    /** Transaction has been created and put into a NACHA file */
    BankTransactionStatus["Pending"] = "pending";
    /** Transaction has been posted to the account */
    BankTransactionStatus["Settled"] = "settled";
    /** Transaction has been voided */
    BankTransactionStatus["Voided"] = "voided";
})(BankTransactionStatus = exports.BankTransactionStatus || (exports.BankTransactionStatus = {}));
var BankTransactionType;
(function (BankTransactionType) {
    BankTransactionType["Credit"] = "CREDIT";
    BankTransactionType["Debit"] = "DEBIT";
})(BankTransactionType = exports.BankTransactionType || (exports.BankTransactionType = {}));
var BankType;
(function (BankType) {
    BankType["Lsb"] = "LSB";
    BankType["Nbkc"] = "NBKC";
})(BankType = exports.BankType || (exports.BankType = {}));
var BankingEligibilityFeature;
(function (BankingEligibilityFeature) {
    BankingEligibilityFeature["ViewPanDetails"] = "VIEW_PAN_DETAILS";
})(BankingEligibilityFeature = exports.BankingEligibilityFeature || (exports.BankingEligibilityFeature = {}));
var BankingEligibilityReason;
(function (BankingEligibilityReason) {
    BankingEligibilityReason["Available"] = "AVAILABLE";
    BankingEligibilityReason["MfaSmsChallengeRequired"] = "MFA_SMS_CHALLENGE_REQUIRED";
    BankingEligibilityReason["MfaSmsSetupRequired"] = "MFA_SMS_SETUP_REQUIRED";
    BankingEligibilityReason["Unavailable"] = "UNAVAILABLE";
})(BankingEligibilityReason = exports.BankingEligibilityReason || (exports.BankingEligibilityReason = {}));
var BankingProduct;
(function (BankingProduct) {
    BankingProduct["EmergencySavings"] = "emergencySavings";
    BankingProduct["MightyOakChecking"] = "mightyOakChecking";
    BankingProduct["MightyOakEmergencyFund"] = "mightyOakEmergencyFund";
    BankingProduct["OakChecking"] = "oakChecking";
    BankingProduct["OakEmergencyFund"] = "oakEmergencyFund";
})(BankingProduct = exports.BankingProduct || (exports.BankingProduct = {}));
var BeneficiaryType;
(function (BeneficiaryType) {
    BeneficiaryType["Entity"] = "entity";
    BeneficiaryType["Individual"] = "individual";
})(BeneficiaryType = exports.BeneficiaryType || (exports.BeneficiaryType = {}));
var BenefitProductStatus;
(function (BenefitProductStatus) {
    BenefitProductStatus["ComingSoon"] = "COMING_SOON";
    BenefitProductStatus["Disabled"] = "DISABLED";
    BenefitProductStatus["DisablingSoon"] = "DISABLING_SOON";
    BenefitProductStatus["Enabled"] = "ENABLED";
    BenefitProductStatus["TemporarilyUnavailable"] = "TEMPORARILY_UNAVAILABLE";
    BenefitProductStatus["UnderMaintenance"] = "UNDER_MAINTENANCE";
})(BenefitProductStatus = exports.BenefitProductStatus || (exports.BenefitProductStatus = {}));
var BenefitPromotedThrough;
(function (BenefitPromotedThrough) {
    BenefitPromotedThrough["MainFeedCard"] = "MAIN_FEED_CARD";
    BenefitPromotedThrough["TourTip"] = "TOUR_TIP";
    BenefitPromotedThrough["Wtdn"] = "WTDN";
})(BenefitPromotedThrough = exports.BenefitPromotedThrough || (exports.BenefitPromotedThrough = {}));
var BenefitStatusDetail;
(function (BenefitStatusDetail) {
    BenefitStatusDetail["IneligibleAge"] = "INELIGIBLE_AGE";
    BenefitStatusDetail["IneligibleLocation"] = "INELIGIBLE_LOCATION";
})(BenefitStatusDetail = exports.BenefitStatusDetail || (exports.BenefitStatusDetail = {}));
var BenefitsPartner;
(function (BenefitsPartner) {
    BenefitsPartner["April"] = "APRIL";
    BenefitsPartner["Avibra"] = "AVIBRA";
    BenefitsPartner["ColumnTax"] = "COLUMN_TAX";
    BenefitsPartner["GoHenry"] = "GO_HENRY";
    BenefitsPartner["TrustAndWill"] = "TRUST_AND_WILL";
})(BenefitsPartner = exports.BenefitsPartner || (exports.BenefitsPartner = {}));
var BenefitsProduct;
(function (BenefitsProduct) {
    BenefitsProduct["BenefitsGohenryStandard"] = "BENEFITS_GOHENRY_STANDARD";
    BenefitsProduct["BenefitsInsuranceBasic"] = "BENEFITS_INSURANCE_BASIC";
    BenefitsProduct["BenefitsInsuranceStandard"] = "BENEFITS_INSURANCE_STANDARD";
    BenefitsProduct["BenefitsTaxfilingStandard"] = "BENEFITS_TAXFILING_STANDARD";
    BenefitsProduct["BenefitsWillStandard"] = "BENEFITS_WILL_STANDARD";
})(BenefitsProduct = exports.BenefitsProduct || (exports.BenefitsProduct = {}));
var BenefitsTrackerProducts;
(function (BenefitsTrackerProducts) {
    BenefitsTrackerProducts["BenefitsFeeNegotiation"] = "BENEFITS_FEE_NEGOTIATION";
    BenefitsTrackerProducts["BenefitsGohenryStandard"] = "BENEFITS_GOHENRY_STANDARD";
    BenefitsTrackerProducts["BenefitsInsuranceStandard"] = "BENEFITS_INSURANCE_STANDARD";
    BenefitsTrackerProducts["BenefitsTaxfilingStandard"] = "BENEFITS_TAXFILING_STANDARD";
    BenefitsTrackerProducts["BenefitsWillStandard"] = "BENEFITS_WILL_STANDARD";
})(BenefitsTrackerProducts = exports.BenefitsTrackerProducts || (exports.BenefitsTrackerProducts = {}));
var BillingCycleState;
(function (BillingCycleState) {
    /** Assessed billing cycle */
    BillingCycleState["Assessed"] = "ASSESSED";
    /** Billing cycle execution started */
    BillingCycleState["Executed"] = "EXECUTED";
    /** Billing cycle execution failed */
    BillingCycleState["ExecutionFailed"] = "EXECUTION_FAILED";
    /** Failed billing cycle */
    BillingCycleState["Failed"] = "FAILED";
    /** Paid billing cycle */
    BillingCycleState["Paid"] = "PAID";
    /** Partially collected billing cycle */
    BillingCycleState["Partial"] = "PARTIAL";
    /** Initiate refund billing cycle */
    BillingCycleState["PendingRefund"] = "PENDING_REFUND";
    /** Refunded billing cycle */
    BillingCycleState["Refunded"] = "REFUNDED";
    /** Refund failed billing cycle */
    BillingCycleState["RefundFailed"] = "REFUND_FAILED";
    /** Billing cycle pending retry */
    BillingCycleState["RetryPending"] = "RETRY_PENDING";
    /** Unpaid billing cycle */
    BillingCycleState["Unpaid"] = "UNPAID";
})(BillingCycleState = exports.BillingCycleState || (exports.BillingCycleState = {}));
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["Monthly"] = "MONTHLY";
    BillingFrequency["Never"] = "NEVER";
})(BillingFrequency = exports.BillingFrequency || (exports.BillingFrequency = {}));
var BrazeEvent;
(function (BrazeEvent) {
    BrazeEvent["AdvocateReferralLinkClick"] = "AdvocateReferralLinkClick";
    BrazeEvent["FriendInvestCore"] = "FriendInvestCore";
    BrazeEvent["FriendRegistrationStart"] = "FriendRegistrationStart";
    BrazeEvent["FriendUserVerified"] = "FriendUserVerified";
})(BrazeEvent = exports.BrazeEvent || (exports.BrazeEvent = {}));
var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Private"] = "PRIVATE";
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope = exports.CacheControlScope || (exports.CacheControlScope = {}));
var CampaignBackgroundType;
(function (CampaignBackgroundType) {
    CampaignBackgroundType["SquirrelsWithAcorns"] = "SQUIRRELS_WITH_ACORNS";
    CampaignBackgroundType["SquirrelsWithAcornsCloud"] = "SQUIRRELS_WITH_ACORNS_CLOUD";
    CampaignBackgroundType["SquirrelsWithAcornsTransparent"] = "SQUIRRELS_WITH_ACORNS_TRANSPARENT";
    CampaignBackgroundType["SquirrelsWithAcornsUber"] = "SQUIRRELS_WITH_ACORNS_UBER";
})(CampaignBackgroundType = exports.CampaignBackgroundType || (exports.CampaignBackgroundType = {}));
var CampaignFilterType;
(function (CampaignFilterType) {
    CampaignFilterType["Advertised"] = "ADVERTISED";
    CampaignFilterType["Participated"] = "PARTICIPATED";
})(CampaignFilterType = exports.CampaignFilterType || (exports.CampaignFilterType = {}));
var CampaignIconType;
(function (CampaignIconType) {
    CampaignIconType["SquirrelAvatar_1"] = "SQUIRREL_AVATAR_1";
    CampaignIconType["SquirrelAvatar_2"] = "SQUIRREL_AVATAR_2";
    CampaignIconType["SquirrelAvatar_3"] = "SQUIRREL_AVATAR_3";
    CampaignIconType["SquirrelAvatarUber"] = "SQUIRREL_AVATAR_UBER";
})(CampaignIconType = exports.CampaignIconType || (exports.CampaignIconType = {}));
var CampaignQualificationActionType;
(function (CampaignQualificationActionType) {
    CampaignQualificationActionType["InitialInvestment"] = "INITIAL_INVESTMENT";
})(CampaignQualificationActionType = exports.CampaignQualificationActionType || (exports.CampaignQualificationActionType = {}));
var CampaignRewardFilterType;
(function (CampaignRewardFilterType) {
    CampaignRewardFilterType["Burst"] = "BURST";
    CampaignRewardFilterType["Evergreen"] = "EVERGREEN";
})(CampaignRewardFilterType = exports.CampaignRewardFilterType || (exports.CampaignRewardFilterType = {}));
var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["Published"] = "PUBLISHED";
    CampaignStatus["Unpublished"] = "UNPUBLISHED";
})(CampaignStatus = exports.CampaignStatus || (exports.CampaignStatus = {}));
var CarouselType;
(function (CarouselType) {
    CarouselType["Banner"] = "BANNER";
    CarouselType["Standard"] = "STANDARD";
})(CarouselType = exports.CarouselType || (exports.CarouselType = {}));
var ChallengeDeliveryType;
(function (ChallengeDeliveryType) {
    ChallengeDeliveryType["Email"] = "EMAIL";
    ChallengeDeliveryType["Push"] = "PUSH";
    ChallengeDeliveryType["Sms"] = "SMS";
})(ChallengeDeliveryType = exports.ChallengeDeliveryType || (exports.ChallengeDeliveryType = {}));
var ChallengePushState;
(function (ChallengePushState) {
    ChallengePushState["Accepted"] = "ACCEPTED";
    ChallengePushState["Pending"] = "PENDING";
    ChallengePushState["Rejected"] = "REJECTED";
})(ChallengePushState = exports.ChallengePushState || (exports.ChallengePushState = {}));
var ChallengeTriggers;
(function (ChallengeTriggers) {
    ChallengeTriggers["Authenticate"] = "AUTHENTICATE";
    ChallengeTriggers["InitEmail"] = "INIT_EMAIL";
    ChallengeTriggers["InitEmailForAuthenticate"] = "INIT_EMAIL_FOR_AUTHENTICATE";
    ChallengeTriggers["InitPushForVerification"] = "INIT_PUSH_FOR_VERIFICATION";
    ChallengeTriggers["InitSms"] = "INIT_SMS";
    ChallengeTriggers["ReinitChallenge"] = "REINIT_CHALLENGE";
    ChallengeTriggers["StepUpAuthentication"] = "STEP_UP_AUTHENTICATION";
    ChallengeTriggers["SuspendedChallenge"] = "SUSPENDED_CHALLENGE";
    ChallengeTriggers["SuspendedInitEmailForAuthenticate"] = "SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE";
})(ChallengeTriggers = exports.ChallengeTriggers || (exports.ChallengeTriggers = {}));
/** Specifies whether a message was written by a user or is bot generated */
var ChatAuthor;
(function (ChatAuthor) {
    ChatAuthor["Bot"] = "BOT";
    ChatAuthor["User"] = "USER";
})(ChatAuthor = exports.ChatAuthor || (exports.ChatAuthor = {}));
var ChatContext;
(function (ChatContext) {
    ChatContext["BenefitsHub"] = "BENEFITS_HUB";
    ChatContext["LearnHub"] = "LEARN_HUB";
    ChatContext["ReferralsLander"] = "REFERRALS_LANDER";
    ChatContext["Support"] = "SUPPORT";
})(ChatContext = exports.ChatContext || (exports.ChatContext = {}));
var ChatFeatures;
(function (ChatFeatures) {
    ChatFeatures["Basic"] = "BASIC";
    ChatFeatures["ChoiceSelection"] = "CHOICE_SELECTION";
    ChatFeatures["Support"] = "SUPPORT";
})(ChatFeatures = exports.ChatFeatures || (exports.ChatFeatures = {}));
var CheckPaymentFailureReason;
(function (CheckPaymentFailureReason) {
    CheckPaymentFailureReason["InsufficientFunds"] = "insufficientFunds";
})(CheckPaymentFailureReason = exports.CheckPaymentFailureReason || (exports.CheckPaymentFailureReason = {}));
var CheckPaymentStatus;
(function (CheckPaymentStatus) {
    CheckPaymentStatus["Canceled"] = "canceled";
    CheckPaymentStatus["Failed"] = "failed";
    CheckPaymentStatus["Pending"] = "pending";
    CheckPaymentStatus["Shipped"] = "shipped";
})(CheckPaymentStatus = exports.CheckPaymentStatus || (exports.CheckPaymentStatus = {}));
var CheckoutCartStatus;
(function (CheckoutCartStatus) {
    /** Terminal state, canceled payment intent */
    CheckoutCartStatus["Canceled"] = "CANCELED";
    /** State a payment intent is in after actions are handled */
    CheckoutCartStatus["Processing"] = "PROCESSING";
    /** Payment intent needs further action by frontend */
    CheckoutCartStatus["RequiresAction"] = "REQUIRES_ACTION";
    /** Payment intent needs capturing */
    CheckoutCartStatus["RequiresCapture"] = "REQUIRES_CAPTURE";
    /** Payment intent needs confirming */
    CheckoutCartStatus["RequiresConfirmation"] = "REQUIRES_CONFIRMATION";
    /** Initial state, before a payment method is attached */
    CheckoutCartStatus["RequiresPaymentMethod"] = "REQUIRES_PAYMENT_METHOD";
    /** Terminal state, succeeded payment intent */
    CheckoutCartStatus["Succeeded"] = "SUCCEEDED";
})(CheckoutCartStatus = exports.CheckoutCartStatus || (exports.CheckoutCartStatus = {}));
var CitationType;
(function (CitationType) {
    CitationType["LearnHubContent"] = "LEARN_HUB_CONTENT";
    CitationType["Other"] = "OTHER";
    CitationType["SupportFaq"] = "SUPPORT_FAQ";
})(CitationType = exports.CitationType || (exports.CitationType = {}));
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["Claimed"] = "CLAIMED";
    ClaimStatus["Expired"] = "EXPIRED";
    ClaimStatus["ExpiringSoon"] = "EXPIRING_SOON";
    ClaimStatus["Ineligible"] = "INELIGIBLE";
    ClaimStatus["InProgress"] = "IN_PROGRESS";
    ClaimStatus["Unclaimed"] = "UNCLAIMED";
    ClaimStatus["UpgradeRequired"] = "UPGRADE_REQUIRED";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
var CohortEligibilityScope;
(function (CohortEligibilityScope) {
    /** Earn Incentive New User Cohort */
    CohortEligibilityScope["EarnIncentive"] = "EARN_INCENTIVE";
    /** Mobile Remote Deposit Checks Feature Cohort */
    CohortEligibilityScope["Mrdc"] = "MRDC";
    /** Passions Cohort */
    CohortEligibilityScope["PassionsExperience"] = "PASSIONS_EXPERIENCE";
    /** Personalized Found Money on Present Cohort */
    CohortEligibilityScope["PersonalizedFoundMoneyOnPresent"] = "PERSONALIZED_FOUND_MONEY_ON_PRESENT";
    /** Send Check Cohort */
    CohortEligibilityScope["SendCheck"] = "SEND_CHECK";
})(CohortEligibilityScope = exports.CohortEligibilityScope || (exports.CohortEligibilityScope = {}));
var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["Automatic"] = "automatic";
    CollectionMethod["Manual"] = "manual";
})(CollectionMethod = exports.CollectionMethod || (exports.CollectionMethod = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["Authorized"] = "AUTHORIZED";
    ConnectionStatus["TfaRequired"] = "TFA_REQUIRED";
    ConnectionStatus["Unauthorized"] = "UNAUTHORIZED";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
var ContributionRequiredAction;
(function (ContributionRequiredAction) {
    /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
    ContributionRequiredAction["RedirectToUrl"] = "REDIRECT_TO_URL";
    /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
    ContributionRequiredAction["UseStripeSdk"] = "USE_STRIPE_SDK";
})(ContributionRequiredAction = exports.ContributionRequiredAction || (exports.ContributionRequiredAction = {}));
var ContributionState;
(function (ContributionState) {
    /** Terminal state, failed contribution */
    ContributionState["Failed"] = "FAILED";
    /** Initial state, pending contribution */
    ContributionState["Pending"] = "PENDING";
    /** Terminal state, successful contribution */
    ContributionState["Success"] = "SUCCESS";
})(ContributionState = exports.ContributionState || (exports.ContributionState = {}));
var CredentialStatus;
(function (CredentialStatus) {
    CredentialStatus["Invalid"] = "INVALID";
    CredentialStatus["Pending"] = "PENDING";
    CredentialStatus["Valid"] = "VALID";
})(CredentialStatus = exports.CredentialStatus || (exports.CredentialStatus = {}));
/** Possible credentials types */
var CredentialsType;
(function (CredentialsType) {
    /** Apple OIDC credentials */
    CredentialsType["Apple"] = "APPLE";
    /** Google OIDC credentials */
    CredentialsType["Google"] = "GOOGLE";
    /** Native email and password credentials */
    CredentialsType["User"] = "USER";
})(CredentialsType = exports.CredentialsType || (exports.CredentialsType = {}));
var CreditReasonCode;
(function (CreditReasonCode) {
    CreditReasonCode["General"] = "general";
    CreditReasonCode["Promotional"] = "promotional";
    CreditReasonCode["Service"] = "service";
})(CreditReasonCode = exports.CreditReasonCode || (exports.CreditReasonCode = {}));
var CtaType;
(function (CtaType) {
    CtaType["Action"] = "action";
    CtaType["Disclaimer"] = "disclaimer";
    CtaType["GrowArticle"] = "grow_article";
    CtaType["Link"] = "link";
    CtaType["ProtectLink"] = "protect_link";
    CtaType["Video"] = "video";
})(CtaType = exports.CtaType || (exports.CtaType = {}));
/** System of money that is used in a particular country */
var Currency;
(function (Currency) {
    Currency["Usd"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
var CustomerAccountClosureState;
(function (CustomerAccountClosureState) {
    CustomerAccountClosureState["Fulfilled"] = "FULFILLED";
    CustomerAccountClosureState["Initiated"] = "INITIATED";
})(CustomerAccountClosureState = exports.CustomerAccountClosureState || (exports.CustomerAccountClosureState = {}));
var CustomerAccountStatus;
(function (CustomerAccountStatus) {
    /** Account is closed. */
    CustomerAccountStatus["Closed"] = "CLOSED";
    /** Account is open but locked for transfer. */
    CustomerAccountStatus["Locked"] = "LOCKED";
    /** Account is open. */
    CustomerAccountStatus["Open"] = "OPEN";
    /** Account has started the closure process. */
    CustomerAccountStatus["PendingClosure"] = "PENDING_CLOSURE";
    /** Account has started the opening process. */
    CustomerAccountStatus["PendingOpen"] = "PENDING_OPEN";
    /** Account has started the re-opening process. */
    CustomerAccountStatus["PendingReopen"] = "PENDING_REOPEN";
})(CustomerAccountStatus = exports.CustomerAccountStatus || (exports.CustomerAccountStatus = {}));
var CustomerEarnOnboardingStatus;
(function (CustomerEarnOnboardingStatus) {
    CustomerEarnOnboardingStatus["BeforeOpen"] = "BEFORE_OPEN";
    CustomerEarnOnboardingStatus["Closed"] = "CLOSED";
    CustomerEarnOnboardingStatus["Closing"] = "CLOSING";
    CustomerEarnOnboardingStatus["Open"] = "OPEN";
})(CustomerEarnOnboardingStatus = exports.CustomerEarnOnboardingStatus || (exports.CustomerEarnOnboardingStatus = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Fri"] = "FRI";
    DayOfWeek["Mon"] = "MON";
    DayOfWeek["Sat"] = "SAT";
    DayOfWeek["Sun"] = "SUN";
    DayOfWeek["Thu"] = "THU";
    DayOfWeek["Tue"] = "TUE";
    DayOfWeek["Wed"] = "WED";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var DealType;
(function (DealType) {
    DealType["PartnerLink"] = "PARTNER_LINK";
    DealType["SimplySpend"] = "SIMPLY_SPEND";
    DealType["TapAndGet"] = "TAP_AND_GET";
    DealType["UniquePricePoint"] = "UNIQUE_PRICE_POINT";
    DealType["VerifiedReferral"] = "VERIFIED_REFERRAL";
})(DealType = exports.DealType || (exports.DealType = {}));
var DepositField;
(function (DepositField) {
    DepositField["AccountHolderName"] = "accountHolderName";
    DepositField["AccountNumber"] = "accountNumber";
    DepositField["AuxOnUs"] = "auxOnUs";
    DepositField["BackEndorsement"] = "backEndorsement";
    DepositField["BackImage"] = "backImage";
    DepositField["CheckDate"] = "checkDate";
    DepositField["CheckNumber"] = "checkNumber";
    DepositField["Codeline"] = "codeline";
    DepositField["CourtesyAmount"] = "courtesyAmount";
    DepositField["CustomerSuppliedAmount"] = "customerSuppliedAmount";
    DepositField["EncodedAmount"] = "encodedAmount";
    DepositField["Epc"] = "epc";
    DepositField["FractionCode"] = "fractionCode";
    DepositField["FrontImage"] = "frontImage";
    DepositField["FrontSignature"] = "frontSignature";
    DepositField["InstitutionName"] = "institutionName";
    DepositField["InstrumentType"] = "instrumentType";
    DepositField["LegalAmount"] = "legalAmount";
    DepositField["OnUs"] = "onUs";
    DepositField["PayeeName"] = "payeeName";
    DepositField["Routing"] = "routing";
})(DepositField = exports.DepositField || (exports.DepositField = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["Android"] = "ANDROID";
    DeviceType["Ios"] = "IOS";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var DigitalWalletDeviceType;
(function (DigitalWalletDeviceType) {
    DigitalWalletDeviceType["Card"] = "Card";
    DigitalWalletDeviceType["FashionAccessory"] = "FashionAccessory";
    DigitalWalletDeviceType["HomeAppliance"] = "HomeAppliance";
    DigitalWalletDeviceType["KeyFob"] = "KeyFob";
    DigitalWalletDeviceType["MediaOrGamingDevice"] = "MediaOrGamingDevice";
    DigitalWalletDeviceType["MobileDevice"] = "MobileDevice";
    DigitalWalletDeviceType["MobileDeviceAccessory"] = "MobileDeviceAccessory";
    DigitalWalletDeviceType["MobilePhone"] = "MobilePhone";
    DigitalWalletDeviceType["PcOrLaptop"] = "PCOrLaptop";
    DigitalWalletDeviceType["Tablet"] = "Tablet";
    DigitalWalletDeviceType["UnknownOther"] = "UnknownOther";
    DigitalWalletDeviceType["Vehicle"] = "Vehicle";
    DigitalWalletDeviceType["Watch"] = "Watch";
})(DigitalWalletDeviceType = exports.DigitalWalletDeviceType || (exports.DigitalWalletDeviceType = {}));
var DirectDepositDistribution;
(function (DirectDepositDistribution) {
    /** Amount of Paycheck */
    DirectDepositDistribution["FixedAmount"] = "FIXED_AMOUNT";
    /** Entire Paycheck */
    DirectDepositDistribution["FullAmount"] = "FULL_AMOUNT";
    /** Percentage of Paycheck */
    DirectDepositDistribution["PercentageAmount"] = "PERCENTAGE_AMOUNT";
})(DirectDepositDistribution = exports.DirectDepositDistribution || (exports.DirectDepositDistribution = {}));
var DirectDepositStatus;
(function (DirectDepositStatus) {
    /** Downloaded pdf to personal device or got a success status back from Pinwheel */
    DirectDepositStatus["Attempted"] = "Attempted";
    /** SplitDepositSettings Query returns a paycheck has landed */
    DirectDepositStatus["Completed"] = "Completed";
    /** Has not set up DD */
    DirectDepositStatus["NoInteraction"] = "NoInteraction";
    /** Has viewed the pdf or entered the pinwheel flow */
    DirectDepositStatus["Viewed"] = "Viewed";
})(DirectDepositStatus = exports.DirectDepositStatus || (exports.DirectDepositStatus = {}));
var DirectDepositVendor;
(function (DirectDepositVendor) {
    DirectDepositVendor["Pinwheel"] = "Pinwheel";
})(DirectDepositVendor = exports.DirectDepositVendor || (exports.DirectDepositVendor = {}));
var DistributionType;
(function (DistributionType) {
    DistributionType["Balanced"] = "BALANCED";
    DistributionType["LongTerm"] = "LONG_TERM";
    DistributionType["LongWeighted"] = "LONG_WEIGHTED";
    DistributionType["MediumTerm"] = "MEDIUM_TERM";
    DistributionType["MediumWeighted"] = "MEDIUM_WEIGHTED";
})(DistributionType = exports.DistributionType || (exports.DistributionType = {}));
var DiversificationBucketType;
(function (DiversificationBucketType) {
    /** Excellent Diversification Bucket */
    DiversificationBucketType["Excellent"] = "EXCELLENT";
    /** Fair Diversification Bucket */
    DiversificationBucketType["Fair"] = "FAIR";
    /** Poor Diversification Bucket */
    DiversificationBucketType["Poor"] = "POOR";
})(DiversificationBucketType = exports.DiversificationBucketType || (exports.DiversificationBucketType = {}));
var DocumentQueryType;
(function (DocumentQueryType) {
    DocumentQueryType["Address"] = "address";
    DocumentQueryType["All"] = "all";
    DocumentQueryType["BeneficiarySsn"] = "beneficiarySsn";
    DocumentQueryType["BulkSuspendCsv"] = "bulkSuspendCsv";
    DocumentQueryType["CurrentBankStatement"] = "currentBankStatement";
    DocumentQueryType["EarlyQuarantinePromotion"] = "earlyQuarantinePromotion";
    DocumentQueryType["FutureBankStatement"] = "futureBankStatement";
    DocumentQueryType["Id"] = "id";
    DocumentQueryType["MilitaryId"] = "militaryId";
    DocumentQueryType["Miscellaneous"] = "miscellaneous";
    DocumentQueryType["PaypalFundingSource"] = "paypalFundingSource";
    DocumentQueryType["SpendAddress"] = "spendAddress";
    DocumentQueryType["SpendFundingSource"] = "spendFundingSource";
    DocumentQueryType["SpendId"] = "spendId";
    DocumentQueryType["Ssn"] = "ssn";
    DocumentQueryType["TraditionalFundingSource"] = "traditionalFundingSource";
    DocumentQueryType["W9"] = "w9";
})(DocumentQueryType = exports.DocumentQueryType || (exports.DocumentQueryType = {}));
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["Accepted"] = "accepted";
    DocumentStatus["Canceled"] = "canceled";
    DocumentStatus["Rejected"] = "rejected";
    DocumentStatus["Requested"] = "requested";
    DocumentStatus["Uploaded"] = "uploaded";
})(DocumentStatus = exports.DocumentStatus || (exports.DocumentStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["Address"] = "address";
    DocumentType["BeneficiarySsn"] = "beneficiarySsn";
    DocumentType["BulkSuspendCsv"] = "bulkSuspendCsv";
    DocumentType["CurrentBankStatement"] = "currentBankStatement";
    DocumentType["EarlyQuarantinePromotion"] = "earlyQuarantinePromotion";
    DocumentType["FutureBankStatement"] = "futureBankStatement";
    DocumentType["Id"] = "id";
    DocumentType["MilitaryId"] = "militaryId";
    DocumentType["Miscellaneous"] = "miscellaneous";
    DocumentType["PaypalFundingSource"] = "paypalFundingSource";
    DocumentType["SpendAddress"] = "spendAddress";
    DocumentType["SpendFundingSource"] = "spendFundingSource";
    DocumentType["SpendId"] = "spendId";
    DocumentType["Ssn"] = "ssn";
    DocumentType["TraditionalFundingSource"] = "traditionalFundingSource";
    DocumentType["W9"] = "w9";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var DocumentVerificationDecision;
(function (DocumentVerificationDecision) {
    /** Documents were verified and accepted */
    DocumentVerificationDecision["Accepted"] = "ACCEPTED";
    /** Documents were declined due to various reason codes */
    DocumentVerificationDecision["Rejected"] = "REJECTED";
    /** The information submitted was incomplete or missing */
    DocumentVerificationDecision["ResubmissionRequired"] = "RESUBMISSION_REQUIRED";
    /** Manual review is necessary */
    DocumentVerificationDecision["ReviewRequired"] = "REVIEW_REQUIRED";
})(DocumentVerificationDecision = exports.DocumentVerificationDecision || (exports.DocumentVerificationDecision = {}));
var EtfTimescale;
(function (EtfTimescale) {
    EtfTimescale["Day"] = "day";
    EtfTimescale["Month"] = "month";
    EtfTimescale["Week"] = "week";
    EtfTimescale["Year"] = "year";
})(EtfTimescale = exports.EtfTimescale || (exports.EtfTimescale = {}));
var EarlyInvestmentAccountType;
(function (EarlyInvestmentAccountType) {
    /** Uniform Gift to Minors Act Custodial Investment Account */
    EarlyInvestmentAccountType["Ugma"] = "UGMA";
    /** Uniform Transfer to Minors Act Custodial Investment Account */
    EarlyInvestmentAccountType["Utma"] = "UTMA";
})(EarlyInvestmentAccountType = exports.EarlyInvestmentAccountType || (exports.EarlyInvestmentAccountType = {}));
var EarnOfferIncentiveRate;
(function (EarnOfferIncentiveRate) {
    EarnOfferIncentiveRate["Dynamic"] = "DYNAMIC";
    EarnOfferIncentiveRate["Flat"] = "FLAT";
})(EarnOfferIncentiveRate = exports.EarnOfferIncentiveRate || (exports.EarnOfferIncentiveRate = {}));
var EarnOfferIncentiveTemplate;
(function (EarnOfferIncentiveTemplate) {
    EarnOfferIncentiveTemplate["V1"] = "V1";
})(EarnOfferIncentiveTemplate = exports.EarnOfferIncentiveTemplate || (exports.EarnOfferIncentiveTemplate = {}));
var EarnOfferIncentiveType;
(function (EarnOfferIncentiveType) {
    EarnOfferIncentiveType["Fixed"] = "FIXED";
    EarnOfferIncentiveType["Percentage"] = "PERCENTAGE";
})(EarnOfferIncentiveType = exports.EarnOfferIncentiveType || (exports.EarnOfferIncentiveType = {}));
var EarnOnboardingMilestoneCtaType;
(function (EarnOnboardingMilestoneCtaType) {
    EarnOnboardingMilestoneCtaType["DownloadExtension"] = "DOWNLOAD_EXTENSION";
    EarnOnboardingMilestoneCtaType["LinkCard"] = "LINK_CARD";
    EarnOnboardingMilestoneCtaType["SimplySpendOffers"] = "SIMPLY_SPEND_OFFERS";
    EarnOnboardingMilestoneCtaType["TapAndGetOffers"] = "TAP_AND_GET_OFFERS";
})(EarnOnboardingMilestoneCtaType = exports.EarnOnboardingMilestoneCtaType || (exports.EarnOnboardingMilestoneCtaType = {}));
var EarnPurchaseMethod;
(function (EarnPurchaseMethod) {
    EarnPurchaseMethod["Android"] = "ANDROID";
    EarnPurchaseMethod["ChromeExtension"] = "CHROME_EXTENSION";
    EarnPurchaseMethod["EarnRewardEmail"] = "EARN_REWARD_EMAIL";
    EarnPurchaseMethod["InStore"] = "IN_STORE";
    EarnPurchaseMethod["Iphone"] = "IPHONE";
    EarnPurchaseMethod["SafariExtension"] = "SAFARI_EXTENSION";
    EarnPurchaseMethod["WebApp"] = "WEB_APP";
})(EarnPurchaseMethod = exports.EarnPurchaseMethod || (exports.EarnPurchaseMethod = {}));
var EarnRewardFulfillmentType;
(function (EarnRewardFulfillmentType) {
    EarnRewardFulfillmentType["Standard"] = "STANDARD";
    EarnRewardFulfillmentType["Travel"] = "TRAVEL";
})(EarnRewardFulfillmentType = exports.EarnRewardFulfillmentType || (exports.EarnRewardFulfillmentType = {}));
var EarnRewardInvestType;
(function (EarnRewardInvestType) {
    EarnRewardInvestType["EarnReward"] = "EARN_REWARD";
    EarnRewardInvestType["EarnRewardMatch"] = "EARN_REWARD_MATCH";
    EarnRewardInvestType["EarnRoundUpMatch"] = "EARN_ROUND_UP_MATCH";
    EarnRewardInvestType["EmployeeContribution"] = "EMPLOYEE_CONTRIBUTION";
    EarnRewardInvestType["Referral"] = "REFERRAL";
})(EarnRewardInvestType = exports.EarnRewardInvestType || (exports.EarnRewardInvestType = {}));
var EarnRewardStatus;
(function (EarnRewardStatus) {
    EarnRewardStatus["Fulfilled"] = "FULFILLED";
    EarnRewardStatus["Pending"] = "PENDING";
})(EarnRewardStatus = exports.EarnRewardStatus || (exports.EarnRewardStatus = {}));
var EarnRewardType;
(function (EarnRewardType) {
    EarnRewardType["EmployeeBenefit"] = "EMPLOYEE_BENEFIT";
    EarnRewardType["Referral"] = "REFERRAL";
    EarnRewardType["Reward"] = "REWARD";
    EarnRewardType["RewardMatch"] = "REWARD_MATCH";
    EarnRewardType["RoundupMatch"] = "ROUNDUP_MATCH";
})(EarnRewardType = exports.EarnRewardType || (exports.EarnRewardType = {}));
var EligibilityScope;
(function (EligibilityScope) {
    EligibilityScope["FundSpendInActivation"] = "fundSpendInActivation";
    EligibilityScope["Mrdc"] = "mrdc";
    EligibilityScope["RoundUps"] = "roundUps";
    EligibilityScope["SendCheck"] = "sendCheck";
    EligibilityScope["Spend"] = "spend";
    EligibilityScope["SpendRecurringTransfers"] = "spendRecurringTransfers";
})(EligibilityScope = exports.EligibilityScope || (exports.EligibilityScope = {}));
var Employees;
(function (Employees) {
    /** User has full or part time employees under their company */
    Employees["FullOrPart"] = "fullOrPart";
    /** User has no employees under their company */
    Employees["None"] = "none";
})(Employees = exports.Employees || (exports.Employees = {}));
var EmploymentStatus;
(function (EmploymentStatus) {
    /** User is a full time employee or contractor */
    EmploymentStatus["FullTime"] = "fullTime";
    /** User is a part time employee or contractor */
    EmploymentStatus["PartTime"] = "partTime";
    /** User is retired and does not work */
    EmploymentStatus["Retired"] = "retired";
    /** User owns their own business or is self employed */
    EmploymentStatus["SelfEmployed"] = "selfEmployed";
    /** User is enrolled full time in school */
    EmploymentStatus["Student"] = "student";
    /** User currently is not employed */
    EmploymentStatus["Unemployed"] = "unemployed";
})(EmploymentStatus = exports.EmploymentStatus || (exports.EmploymentStatus = {}));
var ExternalSource;
(function (ExternalSource) {
    ExternalSource["DirectBank"] = "direct_bank";
    ExternalSource["Manual"] = "manual";
    ExternalSource["Paypal"] = "paypal";
    ExternalSource["Plaid"] = "plaid";
    ExternalSource["Spend"] = "spend";
})(ExternalSource = exports.ExternalSource || (exports.ExternalSource = {}));
var ExternalSubscriptionType;
(function (ExternalSubscriptionType) {
    /** Legacy highest tier */
    ExternalSubscriptionType["LegacyPremium"] = "LEGACY_PREMIUM";
    /** Highest tier */
    ExternalSubscriptionType["Premium"] = "PREMIUM";
})(ExternalSubscriptionType = exports.ExternalSubscriptionType || (exports.ExternalSubscriptionType = {}));
var ExternalUserSource;
(function (ExternalUserSource) {
    ExternalUserSource["UserExternalSourceGoHenry"] = "USER_EXTERNAL_SOURCE_GO_HENRY";
    ExternalUserSource["UserExternalSourceInvalid"] = "USER_EXTERNAL_SOURCE_INVALID";
})(ExternalUserSource = exports.ExternalUserSource || (exports.ExternalUserSource = {}));
var FeeExecutionMethod;
(function (FeeExecutionMethod) {
    /** Executed fee by direct ACH */
    FeeExecutionMethod["Direct"] = "DIRECT";
    /** Executed fee by selling shares */
    FeeExecutionMethod["LiquidateSecurities"] = "LIQUIDATE_SECURITIES";
    /** Pre-emptively failed execution due to a known failure reason */
    FeeExecutionMethod["PreemptiveFailure"] = "PREEMPTIVE_FAILURE";
    /** Skipped fee execution */
    FeeExecutionMethod["Skip"] = "SKIP";
    /** Executed by direct ACH from Spend funding source */
    FeeExecutionMethod["SpendDirect"] = "SPEND_DIRECT";
    /** Waived fee execution */
    FeeExecutionMethod["Waive"] = "WAIVE";
})(FeeExecutionMethod = exports.FeeExecutionMethod || (exports.FeeExecutionMethod = {}));
var FeeStatus;
(function (FeeStatus) {
    FeeStatus["Negotiable"] = "NEGOTIABLE";
    FeeStatus["Negotiated"] = "NEGOTIATED";
    FeeStatus["Processing"] = "PROCESSING";
    FeeStatus["Unnegotiable"] = "UNNEGOTIABLE";
})(FeeStatus = exports.FeeStatus || (exports.FeeStatus = {}));
var FeeStatusFilter;
(function (FeeStatusFilter) {
    FeeStatusFilter["Negotiable"] = "NEGOTIABLE";
    FeeStatusFilter["Negotiated"] = "NEGOTIATED";
    FeeStatusFilter["Processing"] = "PROCESSING";
    FeeStatusFilter["Unnegotiable"] = "UNNEGOTIABLE";
})(FeeStatusFilter = exports.FeeStatusFilter || (exports.FeeStatusFilter = {}));
var FeeType;
(function (FeeType) {
    /** ADVISORY fee */
    FeeType["Advisory"] = "ADVISORY";
    /** SUBSCRIPTION fee */
    FeeType["Subscription"] = "SUBSCRIPTION";
})(FeeType = exports.FeeType || (exports.FeeType = {}));
var FeedContext;
(function (FeedContext) {
    /** a4 banking hub */
    FeedContext["A4BankingHub"] = "a4_banking_hub";
    /** a4 checking engagement wizard */
    FeedContext["A4CheckingEngagementWizard"] = "a4_checking_engagement_wizard";
    /** a4 checking hub */
    FeedContext["A4CheckingHub"] = "a4_checking_hub";
    /** a4 early */
    FeedContext["A4Early"] = "a4_early";
    /** a4 early details */
    FeedContext["A4EarlyDetails"] = "a4_early_details";
    /** a4 home/present */
    FeedContext["A4Home"] = "a4_home";
    /** a4 home bottom nav */
    FeedContext["A4HomeBottomNav"] = "a4_home_bottom_nav";
    /** a4 invest */
    FeedContext["A4Invest"] = "a4_invest";
    /** invest hub */
    FeedContext["A4InvestHub"] = "a4_invest_hub";
    /** a4 kids */
    FeedContext["A4Kids"] = "a4_kids";
    /** a4 later */
    FeedContext["A4Later"] = "a4_later";
    /** a4 learn hub */
    FeedContext["A4LearnHub"] = "a4_learn_hub";
    /** a4 savings */
    FeedContext["A4Savings"] = "a4_savings";
    /** a4 spend */
    FeedContext["A4Spend"] = "a4_spend";
})(FeedContext = exports.FeedContext || (exports.FeedContext = {}));
var FilingType;
(function (FilingType) {
    /** User files taxes with their spouse */
    FilingType["Joint"] = "joint";
    /** User files taxes living with spouse part of the year */
    FilingType["SeparatePartYear"] = "separatePartYear";
    /** User files taxes living apart from spouse all year */
    FilingType["SeparateWholeYear"] = "separateWholeYear";
})(FilingType = exports.FilingType || (exports.FilingType = {}));
var FinancialEducation;
(function (FinancialEducation) {
    /** User has little to no experience with financial education */
    FinancialEducation["Beginner"] = "BEGINNER";
    /** User has a lot of experience with financial education */
    FinancialEducation["Expert"] = "EXPERT";
    /** User has some experience with financial education */
    FinancialEducation["Moderate"] = "MODERATE";
})(FinancialEducation = exports.FinancialEducation || (exports.FinancialEducation = {}));
var FormType;
(function (FormType) {
    FormType["Form1099"] = "form1099";
    FormType["Form1099Bdiv"] = "form1099BDIV";
    FormType["Form1099Misc"] = "form1099MISC";
    FormType["Form1099R"] = "form1099R";
    FormType["Form1099R1"] = "form1099R1";
    FormType["Form1099R2"] = "form1099R2";
    FormType["Form1099R4"] = "form1099R4";
    FormType["Form1099R7"] = "form1099R7";
    FormType["Form1099R8"] = "form1099R8";
    FormType["Form1099Re"] = "form1099RE";
    FormType["Form1099Rj"] = "form1099RJ";
    FormType["Form1099Rq"] = "form1099RQ";
    FormType["Form1099Rt"] = "form1099RT";
    FormType["Form5498"] = "form5498";
    FormType["Other"] = "other";
})(FormType = exports.FormType || (exports.FormType = {}));
/** Status of friend */
var FriendStatus;
(function (FriendStatus) {
    /** Friend has finished required steps to qualify for reward */
    FriendStatus["Complete"] = "COMPLETE";
    /** Friend did not complete required steps in allotted time frame */
    FriendStatus["Expired"] = "EXPIRED";
    /** Reward has been given to Friend/Advocate */
    FriendStatus["Fulfilled"] = "FULFILLED";
    /** Friend has registered */
    FriendStatus["Pending"] = "PENDING";
    /** Advocate sent invite but user has not completed any steps */
    FriendStatus["Sent"] = "SENT";
})(FriendStatus = exports.FriendStatus || (exports.FriendStatus = {}));
/** Status of friend */
var FriendStatusV2;
(function (FriendStatusV2) {
    /** Friend has finished required steps to qualify for reward */
    FriendStatusV2["Complete"] = "COMPLETE";
    /** Friend has invested */
    FriendStatusV2["ConfirmingEligibility"] = "CONFIRMING_ELIGIBILITY";
    /** Friend is ineligible for reward */
    FriendStatusV2["Ineligible"] = "INELIGIBLE";
    /** Friend has signed up or created first investment */
    FriendStatusV2["InProgress"] = "IN_PROGRESS";
})(FriendStatusV2 = exports.FriendStatusV2 || (exports.FriendStatusV2 = {}));
var FundingSourceRoleEnum;
(function (FundingSourceRoleEnum) {
    /** The subaccount is the primary funding source of the user */
    FundingSourceRoleEnum["PrimaryFunding"] = "primaryFunding";
    /** The subaccount is the secondary funding source of the user */
    FundingSourceRoleEnum["SecondaryFunding"] = "secondaryFunding";
})(FundingSourceRoleEnum = exports.FundingSourceRoleEnum || (exports.FundingSourceRoleEnum = {}));
var FundingSourceStatus;
(function (FundingSourceStatus) {
    /** Documents have been requested to verify the funding source. */
    FundingSourceStatus["DocsRequired"] = "docsRequired";
    /** RDV verification attempts exhausted. */
    FundingSourceStatus["Frozen"] = "frozen";
    /** Funding Source is waiting on RDV triggers. */
    FundingSourceStatus["Pending"] = "pending";
    /** RDVs have been sent and are awaiting settlement. */
    FundingSourceStatus["RdvsInitiated"] = "rdvsInitiated";
    /** RDVs have settled in the user's funding source. User must verify amounts. */
    FundingSourceStatus["RdvsSettled"] = "rdvsSettled";
    /** Funding Source is verified. No user action is required. */
    FundingSourceStatus["Success"] = "success";
    /** Awaiting admin approval. No user action is required. */
    FundingSourceStatus["Unapproved"] = "unapproved";
})(FundingSourceStatus = exports.FundingSourceStatus || (exports.FundingSourceStatus = {}));
var FundingSourceStatusEnum;
(function (FundingSourceStatusEnum) {
    /** Documents have been requested to verify the funding source. */
    FundingSourceStatusEnum["DocsRequired"] = "docsRequired";
    /** RDV verification attempts exhausted. */
    FundingSourceStatusEnum["Frozen"] = "frozen";
    /** Funding Source is waiting on RDV triggers. */
    FundingSourceStatusEnum["Pending"] = "pending";
    /** RDVs have been sent and are awaiting settlement. */
    FundingSourceStatusEnum["RdvsInitiated"] = "rdvsInitiated";
    /** RDVs have settled in the user's funding source. User must verify amounts. */
    FundingSourceStatusEnum["RdvsSettled"] = "rdvsSettled";
    /** Funding Source is verified. No user action is required. */
    FundingSourceStatusEnum["Success"] = "success";
    /** Awaiting admin approval. No user action is required. */
    FundingSourceStatusEnum["Unapproved"] = "unapproved";
})(FundingSourceStatusEnum = exports.FundingSourceStatusEnum || (exports.FundingSourceStatusEnum = {}));
var FundingSourceType;
(function (FundingSourceType) {
    FundingSourceType["Ach"] = "ach";
    FundingSourceType["Paypal"] = "paypal";
    FundingSourceType["Spend"] = "spend";
})(FundingSourceType = exports.FundingSourceType || (exports.FundingSourceType = {}));
var FundsAvailability;
(function (FundsAvailability) {
    /** User wants easy access to cash in an emergency */
    FundsAvailability["Emergency"] = "emergency";
    /** User is planning to save and not withdraw until retirement */
    FundsAvailability["Retirement"] = "retirement";
})(FundsAvailability = exports.FundsAvailability || (exports.FundsAvailability = {}));
var Funnel;
(function (Funnel) {
    /** Core funnel */
    Funnel["Core"] = "core";
    /** Direct to mobile funnel */
    Funnel["DirectToMobile"] = "direct_to_mobile";
    /** Early funnel */
    Funnel["Early"] = "early";
    /** Later funnel */
    Funnel["Later"] = "later";
    /** Simple registration funnel */
    Funnel["SimpleReg"] = "simple_reg";
    /** Spend funnel */
    Funnel["Spend"] = "spend";
    /** Tiered registration funnel */
    Funnel["TieredReg"] = "tiered_reg";
})(Funnel = exports.Funnel || (exports.Funnel = {}));
var FunnelName;
(function (FunnelName) {
    FunnelName["Default"] = "DEFAULT";
    FunnelName["MightyOakCard"] = "MIGHTY_OAK_CARD";
    FunnelName["Referrals"] = "REFERRALS";
})(FunnelName = exports.FunnelName || (exports.FunnelName = {}));
var HelpFormType;
(function (HelpFormType) {
    HelpFormType["Contact"] = "CONTACT";
    HelpFormType["EarnMissingCredit"] = "EARN_MISSING_CREDIT";
    HelpFormType["SpendDispute"] = "SPEND_DISPUTE";
})(HelpFormType = exports.HelpFormType || (exports.HelpFormType = {}));
var HelpcenterBannerType;
(function (HelpcenterBannerType) {
    HelpcenterBannerType["Error"] = "ERROR";
    HelpcenterBannerType["Success"] = "SUCCESS";
    HelpcenterBannerType["Warning"] = "WARNING";
})(HelpcenterBannerType = exports.HelpcenterBannerType || (exports.HelpcenterBannerType = {}));
/** Defines the different types of holdings transfers. */
var HoldingsTransferType;
(function (HoldingsTransferType) {
    HoldingsTransferType["BeneficiaryTransfer"] = "BENEFICIARY_TRANSFER";
    HoldingsTransferType["ExternalTransfer"] = "EXTERNAL_TRANSFER";
    HoldingsTransferType["ExternalTransferReversed"] = "EXTERNAL_TRANSFER_REVERSED";
})(HoldingsTransferType = exports.HoldingsTransferType || (exports.HoldingsTransferType = {}));
var IconType;
(function (IconType) {
    IconType["IconAddGoal"] = "ICON_ADD_GOAL";
    IconType["IconAlert"] = "ICON_ALERT";
    IconType["IconAlertGrey"] = "ICON_ALERT_GREY";
    IconType["IconAlertPause"] = "ICON_ALERT_PAUSE";
    IconType["IconAlertPending"] = "ICON_ALERT_PENDING";
    IconType["IconAlertRed"] = "ICON_ALERT_RED";
    IconType["IconAlertYellow"] = "ICON_ALERT_YELLOW";
    IconType["IconArrow"] = "ICON_ARROW";
    IconType["IconArticle"] = "ICON_ARTICLE";
    IconType["IconArticle12"] = "ICON_ARTICLE12";
    IconType["IconAudio"] = "ICON_AUDIO";
    IconType["IconBabyKids"] = "ICON_BABY_KIDS";
    IconType["IconCard"] = "ICON_CARD";
    IconType["IconCategoryBaby"] = "ICON_CATEGORY_BABY";
    IconType["IconCategoryBeauty"] = "ICON_CATEGORY_BEAUTY";
    IconType["IconCategoryCar"] = "ICON_CATEGORY_CAR";
    IconType["IconCategoryClothing"] = "ICON_CATEGORY_CLOTHING";
    IconType["IconCategoryCollege"] = "ICON_CATEGORY_COLLEGE";
    IconType["IconCategoryEntertainment"] = "ICON_CATEGORY_ENTERTAINMENT";
    IconType["IconCategoryFlowers"] = "ICON_CATEGORY_FLOWERS";
    IconType["IconCategoryFood"] = "ICON_CATEGORY_FOOD";
    IconType["IconCategoryFootball"] = "ICON_CATEGORY_FOOTBALL";
    IconType["IconCategoryHealth"] = "ICON_CATEGORY_HEALTH";
    IconType["IconCategoryHome"] = "ICON_CATEGORY_HOME";
    IconType["IconCategoryPet"] = "ICON_CATEGORY_PET";
    IconType["IconCategoryPhone"] = "ICON_CATEGORY_PHONE";
    IconType["IconCategoryShoe"] = "ICON_CATEGORY_SHOE";
    IconType["IconCheckHub"] = "ICON_CHECK_HUB";
    IconType["IconCheckIn"] = "ICON_CHECK_IN";
    IconType["IconCircleCheck"] = "ICON_CIRCLE_CHECK";
    IconType["IconCircleClock"] = "ICON_CIRCLE_CLOCK";
    IconType["IconCircleInfo"] = "ICON_CIRCLE_INFO";
    IconType["IconCirclePause"] = "ICON_CIRCLE_PAUSE";
    IconType["IconCircleX"] = "ICON_CIRCLE_X";
    IconType["IconClose"] = "ICON_CLOSE";
    IconType["IconClothing"] = "ICON_CLOTHING";
    IconType["IconDepositCheck"] = "ICON_DEPOSIT_CHECK";
    IconType["IconDirectDeposit"] = "ICON_DIRECT_DEPOSIT";
    IconType["IconDisclosureRight"] = "ICON_DISCLOSURE_RIGHT";
    IconType["IconDropPin"] = "ICON_DROP_PIN";
    IconType["IconEarnJobs"] = "ICON_EARN_JOBS";
    IconType["IconElectronics"] = "ICON_ELECTRONICS";
    IconType["IconEntertainment"] = "ICON_ENTERTAINMENT";
    IconType["IconExpand"] = "ICON_EXPAND";
    IconType["IconFastQuote"] = "ICON_FAST_QUOTE";
    IconType["IconFavorites"] = "ICON_FAVORITES";
    IconType["IconFinancialWellness"] = "ICON_FINANCIAL_WELLNESS";
    IconType["IconFlowersGifts"] = "ICON_FLOWERS_GIFTS";
    IconType["IconFoodGourmet"] = "ICON_FOOD_GOURMET";
    IconType["IconGradCap"] = "ICON_GRAD_CAP";
    IconType["IconHealthBeauty"] = "ICON_HEALTH_BEAUTY";
    IconType["IconHealthWellness"] = "ICON_HEALTH_WELLNESS";
    IconType["IconHistory"] = "ICON_HISTORY";
    IconType["IconHomeDecor"] = "ICON_HOME_DECOR";
    IconType["IconInstant"] = "ICON_INSTANT";
    IconType["IconInterstitialAchievements"] = "ICON_INTERSTITIAL_ACHIEVEMENTS";
    IconType["IconInterstitialAdd"] = "ICON_INTERSTITIAL_ADD";
    IconType["IconInterstitialApy"] = "ICON_INTERSTITIAL_APY";
    IconType["IconInterstitialAutoRefill"] = "ICON_INTERSTITIAL_AUTO_REFILL";
    IconType["IconInterstitialBank"] = "ICON_INTERSTITIAL_BANK";
    IconType["IconInterstitialCalculator"] = "ICON_INTERSTITIAL_CALCULATOR";
    IconType["IconInterstitialCalendar"] = "ICON_INTERSTITIAL_CALENDAR";
    IconType["IconInterstitialCheck"] = "ICON_INTERSTITIAL_CHECK";
    IconType["IconInterstitialCheckActive"] = "ICON_INTERSTITIAL_CHECK_ACTIVE";
    IconType["IconInterstitialConfident"] = "ICON_INTERSTITIAL_CONFIDENT";
    IconType["IconInterstitialCreditCard"] = "ICON_INTERSTITIAL_CREDIT_CARD";
    IconType["IconInterstitialDeposit"] = "ICON_INTERSTITIAL_DEPOSIT";
    IconType["IconInterstitialDocuments"] = "ICON_INTERSTITIAL_DOCUMENTS";
    IconType["IconInterstitialDollar"] = "ICON_INTERSTITIAL_DOLLAR";
    IconType["IconInterstitialDollarSign"] = "ICON_INTERSTITIAL_DOLLAR_SIGN";
    IconType["IconInterstitialEarnJobs"] = "ICON_INTERSTITIAL_EARN_JOBS";
    IconType["IconInterstitialEntries"] = "ICON_INTERSTITIAL_ENTRIES";
    IconType["IconInterstitialFastQuote"] = "ICON_INTERSTITIAL_FAST_QUOTE";
    IconType["IconInterstitialFeelingGood"] = "ICON_INTERSTITIAL_FEELING_GOOD";
    IconType["IconInterstitialGettingStarted1"] = "ICON_INTERSTITIAL_GETTING_STARTED1";
    IconType["IconInterstitialGettingStarted2"] = "ICON_INTERSTITIAL_GETTING_STARTED2";
    IconType["IconInterstitialHealthAdd"] = "ICON_INTERSTITIAL_HEALTH_ADD";
    IconType["IconInterstitialLearn"] = "ICON_INTERSTITIAL_LEARN";
    IconType["IconInterstitialMatch"] = "ICON_INTERSTITIAL_MATCH";
    IconType["IconInterstitialNextDay"] = "ICON_INTERSTITIAL_NEXT_DAY";
    IconType["IconInterstitialNumber"] = "ICON_INTERSTITIAL_NUMBER";
    IconType["IconInterstitialOffers"] = "ICON_INTERSTITIAL_OFFERS";
    IconType["IconInterstitialPie"] = "ICON_INTERSTITIAL_PIE";
    IconType["IconInterstitialPin"] = "ICON_INTERSTITIAL_PIN";
    IconType["IconInterstitialProfile"] = "ICON_INTERSTITIAL_PROFILE";
    IconType["IconInterstitialRecurring"] = "ICON_INTERSTITIAL_RECURRING";
    IconType["IconInterstitialRenters"] = "ICON_INTERSTITIAL_RENTERS";
    IconType["IconInterstitialRoundUp"] = "ICON_INTERSTITIAL_ROUND_UP";
    IconType["IconInterstitialRoundUps"] = "ICON_INTERSTITIAL_ROUND_UPS";
    IconType["IconInterstitialRoundUpBill"] = "ICON_INTERSTITIAL_ROUND_UP_BILL";
    IconType["IconInterstitialSave"] = "ICON_INTERSTITIAL_SAVE";
    IconType["IconInterstitialSendCheck"] = "ICON_INTERSTITIAL_SEND_CHECK";
    IconType["IconInterstitialShipping"] = "ICON_INTERSTITIAL_SHIPPING";
    IconType["IconInterstitialSideHustles"] = "ICON_INTERSTITIAL_SIDE_HUSTLES";
    IconType["IconInterstitialSimplySpend"] = "ICON_INTERSTITIAL_SIMPLY_SPEND";
    IconType["IconInterstitialSmartDeposit"] = "ICON_INTERSTITIAL_SMART_DEPOSIT";
    IconType["IconInterstitialSmartDepositActive"] = "ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE";
    IconType["IconInterstitialTimer"] = "ICON_INTERSTITIAL_TIMER";
    IconType["IconInterstitialTree"] = "ICON_INTERSTITIAL_TREE";
    IconType["IconInterstitialTwoFactorAuth"] = "ICON_INTERSTITIAL_TWO_FACTOR_AUTH";
    IconType["IconInterstitialWallet"] = "ICON_INTERSTITIAL_WALLET";
    IconType["IconInvest"] = "ICON_INVEST";
    IconType["IconLearningCenter"] = "ICON_LEARNING_CENTER";
    IconType["IconLightningBolt"] = "ICON_LIGHTNING_BOLT";
    IconType["IconLive"] = "ICON_LIVE";
    IconType["IconLocalOffers"] = "ICON_LOCAL_OFFERS";
    IconType["IconLocation"] = "ICON_LOCATION";
    IconType["IconLock"] = "ICON_LOCK";
    IconType["IconLockSolid"] = "ICON_LOCK_SOLID";
    IconType["IconMiniArrowLrgDown"] = "ICON_MINI_ARROW_LRG_DOWN";
    IconType["IconMiniArrowLrgUp"] = "ICON_MINI_ARROW_LRG_UP";
    IconType["IconMiniArrowSmDown"] = "ICON_MINI_ARROW_SM_DOWN";
    IconType["IconMiniArrowSmUp"] = "ICON_MINI_ARROW_SM_UP";
    IconType["IconMiniArticle"] = "ICON_MINI_ARTICLE";
    IconType["IconMiniAudio"] = "ICON_MINI_AUDIO";
    IconType["IconMiniCheckmark"] = "ICON_MINI_CHECKMARK";
    IconType["IconMiniIndicatorTriangle"] = "ICON_MINI_INDICATOR_TRIANGLE";
    IconType["IconMiniLightningBolt"] = "ICON_MINI_LIGHTNING_BOLT";
    IconType["IconMiniLock"] = "ICON_MINI_LOCK";
    IconType["IconMiniNew"] = "ICON_MINI_NEW";
    IconType["IconMiniPlay"] = "ICON_MINI_PLAY";
    IconType["IconMiniSelectionCheck"] = "ICON_MINI_SELECTION_CHECK";
    IconType["IconMinus"] = "ICON_MINUS";
    IconType["IconNew"] = "ICON_NEW";
    IconType["IconOneTime"] = "ICON_ONE_TIME";
    IconType["IconPets"] = "ICON_PETS";
    IconType["IconPlane"] = "ICON_PLANE";
    IconType["IconPlayMini"] = "ICON_PLAY_MINI";
    IconType["IconPlayVideo"] = "ICON_PLAY_VIDEO";
    IconType["IconPlus"] = "ICON_PLUS";
    IconType["IconProductBanking"] = "ICON_PRODUCT_BANKING";
    IconType["IconProductBenefits"] = "ICON_PRODUCT_BENEFITS";
    IconType["IconProductColorAchievements"] = "ICON_PRODUCT_COLOR_ACHIEVEMENTS";
    IconType["IconProductColorEarly"] = "ICON_PRODUCT_COLOR_EARLY";
    IconType["IconProductColorEarn"] = "ICON_PRODUCT_COLOR_EARN";
    IconType["IconProductColorEmergencyFund"] = "ICON_PRODUCT_COLOR_EMERGENCY_FUND";
    IconType["IconProductColorGrow"] = "ICON_PRODUCT_COLOR_GROW";
    IconType["IconProductColorInvest"] = "ICON_PRODUCT_COLOR_INVEST";
    IconType["IconProductColorInvite"] = "ICON_PRODUCT_COLOR_INVITE";
    IconType["IconProductColorLater"] = "ICON_PRODUCT_COLOR_LATER";
    IconType["IconProductColorLocalFoundMoney"] = "ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY";
    IconType["IconProductColorProtect"] = "ICON_PRODUCT_COLOR_PROTECT";
    IconType["IconProductColorSave"] = "ICON_PRODUCT_COLOR_SAVE";
    IconType["IconProductColorSpend"] = "ICON_PRODUCT_COLOR_SPEND";
    IconType["IconProductEarly"] = "ICON_PRODUCT_EARLY";
    IconType["IconProductEarn"] = "ICON_PRODUCT_EARN";
    IconType["IconProductEmergency"] = "ICON_PRODUCT_EMERGENCY";
    IconType["IconProductGoHenry"] = "ICON_PRODUCT_GO_HENRY";
    IconType["IconProductGrow"] = "ICON_PRODUCT_GROW";
    IconType["IconProductInvest"] = "ICON_PRODUCT_INVEST";
    IconType["IconProductInvestHub"] = "ICON_PRODUCT_INVEST_HUB";
    IconType["IconProductInvestProduct"] = "ICON_PRODUCT_INVEST_PRODUCT";
    IconType["IconProductLater"] = "ICON_PRODUCT_LATER";
    IconType["IconProductProtect"] = "ICON_PRODUCT_PROTECT";
    IconType["IconProductSave"] = "ICON_PRODUCT_SAVE";
    IconType["IconProductSpend"] = "ICON_PRODUCT_SPEND";
    IconType["IconProtected"] = "ICON_PROTECTED";
    IconType["IconReversal"] = "ICON_REVERSAL";
    IconType["IconRoundUps"] = "ICON_ROUND_UPS";
    IconType["IconScooter"] = "ICON_SCOOTER";
    IconType["IconSearch"] = "ICON_SEARCH";
    IconType["IconSendCheck"] = "ICON_SEND_CHECK";
    IconType["IconSendMoneyInstant"] = "ICON_SEND_MONEY_INSTANT";
    IconType["IconShare"] = "ICON_SHARE";
    IconType["IconShoesAccessories"] = "ICON_SHOES_ACCESSORIES";
    IconType["IconSideHustles"] = "ICON_SIDE_HUSTLES";
    IconType["IconSimplySpend"] = "ICON_SIMPLY_SPEND";
    IconType["IconSportsOutdoors"] = "ICON_SPORTS_OUTDOORS";
    IconType["IconTimer"] = "ICON_TIMER";
    IconType["IconTransactionAcorns"] = "ICON_TRANSACTION_ACORNS";
    IconType["IconTransactionAtm"] = "ICON_TRANSACTION_ATM";
    IconType["IconTransactionBankFee"] = "ICON_TRANSACTION_BANK_FEE";
    IconType["IconTransactionCheck"] = "ICON_TRANSACTION_CHECK";
    IconType["IconTransactionCheckDeposit"] = "ICON_TRANSACTION_CHECK_DEPOSIT";
    IconType["IconTransactionDirectDeposit"] = "ICON_TRANSACTION_DIRECT_DEPOSIT";
    IconType["IconTransactionDistribution"] = "ICON_TRANSACTION_DISTRIBUTION";
    IconType["IconTransactionDividend"] = "ICON_TRANSACTION_DIVIDEND";
    IconType["IconTransactionEarnReward"] = "ICON_TRANSACTION_EARN_REWARD";
    IconType["IconTransactionEarnRewardsMatch"] = "ICON_TRANSACTION_EARN_REWARDS_MATCH";
    IconType["IconTransactionGift"] = "ICON_TRANSACTION_GIFT";
    IconType["IconTransactionGoHenry"] = "ICON_TRANSACTION_GO_HENRY";
    IconType["IconTransactionHamburger"] = "ICON_TRANSACTION_HAMBURGER";
    IconType["IconTransactionId"] = "ICON_TRANSACTION_ID";
    IconType["IconTransactionInstantRoundUp"] = "ICON_TRANSACTION_INSTANT_ROUND_UP";
    IconType["IconTransactionOneTime"] = "ICON_TRANSACTION_ONE_TIME";
    IconType["IconTransactionOriginalTransaction"] = "ICON_TRANSACTION_ORIGINAL_TRANSACTION";
    IconType["IconTransactionRebalance"] = "ICON_TRANSACTION_REBALANCE";
    IconType["IconTransactionRecurringDeposit"] = "ICON_TRANSACTION_RECURRING_DEPOSIT";
    IconType["IconTransactionRefund"] = "ICON_TRANSACTION_REFUND";
    IconType["IconTransactionRoundUp"] = "ICON_TRANSACTION_ROUND_UP";
    IconType["IconTransactionSpendCard"] = "ICON_TRANSACTION_SPEND_CARD";
    IconType["IconTransactionStatus"] = "ICON_TRANSACTION_STATUS";
    IconType["IconTransactionTransferIn"] = "ICON_TRANSACTION_TRANSFER_IN";
    IconType["IconTransactionTransferInOut"] = "ICON_TRANSACTION_TRANSFER_IN_OUT";
    IconType["IconTransactionTransferOut"] = "ICON_TRANSACTION_TRANSFER_OUT";
    IconType["IconTransactionType"] = "ICON_TRANSACTION_TYPE";
    IconType["IconTransfer"] = "ICON_TRANSFER";
    IconType["IconTravelTransportation"] = "ICON_TRAVEL_TRANSPORTATION";
    IconType["IconTrustedPartners"] = "ICON_TRUSTED_PARTNERS";
    IconType["IconUtilityAccessibility"] = "ICON_UTILITY_ACCESSIBILITY";
    IconType["IconUtilityAccountDetails"] = "ICON_UTILITY_ACCOUNT_DETAILS";
    IconType["IconUtilityAchievement"] = "ICON_UTILITY_ACHIEVEMENT";
    IconType["IconUtilityAcorn"] = "ICON_UTILITY_ACORN";
    IconType["IconUtilityAdd"] = "ICON_UTILITY_ADD";
    IconType["IconUtilityAi"] = "ICON_UTILITY_AI";
    IconType["IconUtilityAlert"] = "ICON_UTILITY_ALERT";
    IconType["IconUtilityApy"] = "ICON_UTILITY_APY";
    IconType["IconUtilityArrowLeft"] = "ICON_UTILITY_ARROW_LEFT";
    IconType["IconUtilityArrowRight"] = "ICON_UTILITY_ARROW_RIGHT";
    IconType["IconUtilityArExperience"] = "ICON_UTILITY_AR_EXPERIENCE";
    IconType["IconUtilityBackupCodes"] = "ICON_UTILITY_BACKUP_CODES";
    IconType["IconUtilityBag"] = "ICON_UTILITY_BAG";
    IconType["IconUtilityBank"] = "ICON_UTILITY_BANK";
    IconType["IconUtilityBankAdd"] = "ICON_UTILITY_BANK_ADD";
    IconType["IconUtilityBankFees"] = "ICON_UTILITY_BANK_FEES";
    IconType["IconUtilityBell"] = "ICON_UTILITY_BELL";
    IconType["IconUtilityBellFilled"] = "ICON_UTILITY_BELL_FILLED";
    IconType["IconUtilityBeneficiaries"] = "ICON_UTILITY_BENEFICIARIES";
    IconType["IconUtilityBinoculars"] = "ICON_UTILITY_BINOCULARS";
    IconType["IconUtilityBirthday"] = "ICON_UTILITY_BIRTHDAY";
    IconType["IconUtilityBonds"] = "ICON_UTILITY_BONDS";
    IconType["IconUtilityBook"] = "ICON_UTILITY_BOOK";
    IconType["IconUtilityBookmark"] = "ICON_UTILITY_BOOKMARK";
    IconType["IconUtilityBookmarkFilled"] = "ICON_UTILITY_BOOKMARK_FILLED";
    IconType["IconUtilityBox"] = "ICON_UTILITY_BOX";
    IconType["IconUtilityBudgeting"] = "ICON_UTILITY_BUDGETING";
    IconType["IconUtilityCalendar"] = "ICON_UTILITY_CALENDAR";
    IconType["IconUtilityCamera"] = "ICON_UTILITY_CAMERA";
    IconType["IconUtilityCancel"] = "ICON_UTILITY_CANCEL";
    IconType["IconUtilityCar"] = "ICON_UTILITY_CAR";
    IconType["IconUtilityCashOwed"] = "ICON_UTILITY_CASH_OWED";
    IconType["IconUtilityCellTower"] = "ICON_UTILITY_CELL_TOWER";
    IconType["IconUtilityChatBubble"] = "ICON_UTILITY_CHAT_BUBBLE";
    IconType["IconUtilityCheckmark"] = "ICON_UTILITY_CHECKMARK";
    IconType["IconUtilityClose"] = "ICON_UTILITY_CLOSE";
    IconType["IconUtilityCoin"] = "ICON_UTILITY_COIN";
    IconType["IconUtilityCollapseMenu"] = "ICON_UTILITY_COLLAPSE_MENU";
    IconType["IconUtilityCompanyBuilding"] = "ICON_UTILITY_COMPANY_BUILDING";
    IconType["IconUtilityController"] = "ICON_UTILITY_CONTROLLER";
    IconType["IconUtilityCopy"] = "ICON_UTILITY_COPY";
    IconType["IconUtilityCrane"] = "ICON_UTILITY_CRANE";
    IconType["IconUtilityCredit"] = "ICON_UTILITY_CREDIT";
    IconType["IconUtilityCrypto"] = "ICON_UTILITY_CRYPTO";
    IconType["IconUtilityCurrentLocation"] = "ICON_UTILITY_CURRENT_LOCATION";
    IconType["IconUtilityCustomize"] = "ICON_UTILITY_CUSTOMIZE";
    IconType["IconUtilityCustomStocks"] = "ICON_UTILITY_CUSTOM_STOCKS";
    IconType["IconUtilityCyberSecurity"] = "ICON_UTILITY_CYBER_SECURITY";
    IconType["IconUtilityDelete"] = "ICON_UTILITY_DELETE";
    IconType["IconUtilityDocuments"] = "ICON_UTILITY_DOCUMENTS";
    IconType["IconUtilityDocumentDownload"] = "ICON_UTILITY_DOCUMENT_DOWNLOAD";
    IconType["IconUtilityDocumentUpload"] = "ICON_UTILITY_DOCUMENT_UPLOAD";
    IconType["IconUtilityDots"] = "ICON_UTILITY_DOTS";
    IconType["IconUtilityDown"] = "ICON_UTILITY_DOWN";
    IconType["IconUtilityDownFilled"] = "ICON_UTILITY_DOWN_FILLED";
    IconType["IconUtilityEarnJobs"] = "ICON_UTILITY_EARN_JOBS";
    IconType["IconUtilityEdit"] = "ICON_UTILITY_EDIT";
    IconType["IconUtilityEntries"] = "ICON_UTILITY_ENTRIES";
    IconType["IconUtilityEth"] = "ICON_UTILITY_ETH";
    IconType["IconUtilityExpand"] = "ICON_UTILITY_EXPAND";
    IconType["IconUtilityExpandMenu"] = "ICON_UTILITY_EXPAND_MENU";
    IconType["IconUtilityFace"] = "ICON_UTILITY_FACE";
    IconType["IconUtilityFaceId"] = "ICON_UTILITY_FACE_ID";
    IconType["IconUtilityFastQuote"] = "ICON_UTILITY_FAST_QUOTE";
    IconType["IconUtilityFilter"] = "ICON_UTILITY_FILTER";
    IconType["IconUtilityFlame"] = "ICON_UTILITY_FLAME";
    IconType["IconUtilityFlashOff"] = "ICON_UTILITY_FLASH_OFF";
    IconType["IconUtilityFlashOn"] = "ICON_UTILITY_FLASH_ON";
    IconType["IconUtilityFlexible"] = "ICON_UTILITY_FLEXIBLE";
    IconType["IconUtilityGift"] = "ICON_UTILITY_GIFT";
    IconType["IconUtilityGoal"] = "ICON_UTILITY_GOAL";
    IconType["IconUtilityGovernment"] = "ICON_UTILITY_GOVERNMENT";
    IconType["IconUtilityGradCap"] = "ICON_UTILITY_GRAD_CAP";
    IconType["IconUtilityHamburgerMenu"] = "ICON_UTILITY_HAMBURGER_MENU";
    IconType["IconUtilityHealth"] = "ICON_UTILITY_HEALTH";
    IconType["IconUtilityHeart"] = "ICON_UTILITY_HEART";
    IconType["IconUtilityHeartAdd"] = "ICON_UTILITY_HEART_ADD";
    IconType["IconUtilityHeartFilled"] = "ICON_UTILITY_HEART_FILLED";
    IconType["IconUtilityHelp"] = "ICON_UTILITY_HELP";
    IconType["IconUtilityHide"] = "ICON_UTILITY_HIDE";
    IconType["IconUtilityHistory"] = "ICON_UTILITY_HISTORY";
    IconType["IconUtilityHome"] = "ICON_UTILITY_HOME";
    IconType["IconUtilityInfo"] = "ICON_UTILITY_INFO";
    IconType["IconUtilityInvestorProfile"] = "ICON_UTILITY_INVESTOR_PROFILE";
    IconType["IconUtilityInvite"] = "ICON_UTILITY_INVITE";
    IconType["IconUtilityJobAlerts"] = "ICON_UTILITY_JOB_ALERTS";
    IconType["IconUtilityKeypad"] = "ICON_UTILITY_KEYPAD";
    IconType["IconUtilityLaptop"] = "ICON_UTILITY_LAPTOP";
    IconType["IconUtilityLargeCheckmark"] = "ICON_UTILITY_LARGE_CHECKMARK";
    IconType["IconUtilityLargePlus"] = "ICON_UTILITY_LARGE_PLUS";
    IconType["IconUtilityLeaf"] = "ICON_UTILITY_LEAF";
    IconType["IconUtilityLibrary"] = "ICON_UTILITY_LIBRARY";
    IconType["IconUtilityLightbulb"] = "ICON_UTILITY_LIGHTBULB";
    IconType["IconUtilityLocalOffers"] = "ICON_UTILITY_LOCAL_OFFERS";
    IconType["IconUtilityLoginActivity"] = "ICON_UTILITY_LOGIN_ACTIVITY";
    IconType["IconUtilityLogOut"] = "ICON_UTILITY_LOG_OUT";
    IconType["IconUtilityMail"] = "ICON_UTILITY_MAIL";
    IconType["IconUtilityManualLinking"] = "ICON_UTILITY_MANUAL_LINKING";
    IconType["IconUtilityMapPin"] = "ICON_UTILITY_MAP_PIN";
    IconType["IconUtilityMatch"] = "ICON_UTILITY_MATCH";
    IconType["IconUtilityMedia"] = "ICON_UTILITY_MEDIA";
    IconType["IconUtilityMenu"] = "ICON_UTILITY_MENU";
    IconType["IconUtilityMobilePhone"] = "ICON_UTILITY_MOBILE_PHONE";
    IconType["IconUtilityMorning"] = "ICON_UTILITY_MORNING";
    IconType["IconUtilityNew"] = "ICON_UTILITY_NEW";
    IconType["IconUtilityNight"] = "ICON_UTILITY_NIGHT";
    IconType["IconUtilityNotifications"] = "ICON_UTILITY_NOTIFICATIONS";
    IconType["IconUtilityOneTime"] = "ICON_UTILITY_ONE_TIME";
    IconType["IconUtilityPassword"] = "ICON_UTILITY_PASSWORD";
    IconType["IconUtilityPause"] = "ICON_UTILITY_PAUSE";
    IconType["IconUtilityPet"] = "ICON_UTILITY_PET";
    IconType["IconUtilityPhone"] = "ICON_UTILITY_PHONE";
    IconType["IconUtilityPin"] = "ICON_UTILITY_PIN";
    IconType["IconUtilityPlane"] = "ICON_UTILITY_PLANE";
    IconType["IconUtilityPlug"] = "ICON_UTILITY_PLUG";
    IconType["IconUtilityPointer"] = "ICON_UTILITY_POINTER";
    IconType["IconUtilityPortfolioType"] = "ICON_UTILITY_PORTFOLIO_TYPE";
    IconType["IconUtilityPotential"] = "ICON_UTILITY_POTENTIAL";
    IconType["IconUtilityPreferences"] = "ICON_UTILITY_PREFERENCES";
    IconType["IconUtilityProfile"] = "ICON_UTILITY_PROFILE";
    IconType["IconUtilityQr"] = "ICON_UTILITY_QR";
    IconType["IconUtilityQuestionnaire"] = "ICON_UTILITY_QUESTIONNAIRE";
    IconType["IconUtilityQuestionMark"] = "ICON_UTILITY_QUESTION_MARK";
    IconType["IconUtilityQuickWithdraw"] = "ICON_UTILITY_QUICK_WITHDRAW";
    IconType["IconUtilityReload"] = "ICON_UTILITY_RELOAD";
    IconType["IconUtilityRenters"] = "ICON_UTILITY_RENTERS";
    IconType["IconUtilityRisk"] = "ICON_UTILITY_RISK";
    IconType["IconUtilityRocket"] = "ICON_UTILITY_ROCKET";
    IconType["IconUtilityRoundUpsRealTime"] = "ICON_UTILITY_ROUND_UPS_REAL_TIME";
    IconType["IconUtilitySafari"] = "ICON_UTILITY_SAFARI";
    IconType["IconUtilityScales"] = "ICON_UTILITY_SCALES";
    IconType["IconUtilityScience"] = "ICON_UTILITY_SCIENCE";
    IconType["IconUtilityScooter"] = "ICON_UTILITY_SCOOTER";
    IconType["IconUtilitySearch"] = "ICON_UTILITY_SEARCH";
    IconType["IconUtilitySettings"] = "ICON_UTILITY_SETTINGS";
    IconType["IconUtilityShareAndroid"] = "ICON_UTILITY_SHARE_ANDROID";
    IconType["IconUtilityShareIos"] = "ICON_UTILITY_SHARE_IOS";
    IconType["IconUtilityShareLink"] = "ICON_UTILITY_SHARE_LINK";
    IconType["IconUtilityShieldCheck"] = "ICON_UTILITY_SHIELD_CHECK";
    IconType["IconUtilityShipping"] = "ICON_UTILITY_SHIPPING";
    IconType["IconUtilityShow"] = "ICON_UTILITY_SHOW";
    IconType["IconUtilitySilverware"] = "ICON_UTILITY_SILVERWARE";
    IconType["IconUtilitySingleCoin"] = "ICON_UTILITY_SINGLE_COIN";
    IconType["IconUtilitySmartDepositShine"] = "ICON_UTILITY_SMART_DEPOSIT_SHINE";
    IconType["IconUtilitySort"] = "ICON_UTILITY_SORT";
    IconType["IconUtilitySpace"] = "ICON_UTILITY_SPACE";
    IconType["IconUtilitySpendCardDispute"] = "ICON_UTILITY_SPEND_CARD_DISPUTE";
    IconType["IconUtilitySpendCardLocked"] = "ICON_UTILITY_SPEND_CARD_LOCKED";
    IconType["IconUtilitySprayBottle"] = "ICON_UTILITY_SPRAY_BOTTLE";
    IconType["IconUtilitySprout"] = "ICON_UTILITY_SPROUT";
    IconType["IconUtilityStackedCoins"] = "ICON_UTILITY_STACKED_COINS";
    IconType["IconUtilityStar"] = "ICON_UTILITY_STAR";
    IconType["IconUtilityStocks"] = "ICON_UTILITY_STOCKS";
    IconType["IconUtilitySubscription"] = "ICON_UTILITY_SUBSCRIPTION";
    IconType["IconUtilitySun"] = "ICON_UTILITY_SUN";
    IconType["IconUtilityTax"] = "ICON_UTILITY_TAX";
    IconType["IconUtilityTextMessage"] = "ICON_UTILITY_TEXT_MESSAGE";
    IconType["IconUtilityThematicInvestments"] = "ICON_UTILITY_THEMATIC_INVESTMENTS";
    IconType["IconUtilityTimer"] = "ICON_UTILITY_TIMER";
    IconType["IconUtilityTouchId"] = "ICON_UTILITY_TOUCH_ID";
    IconType["IconUtilityTrash"] = "ICON_UTILITY_TRASH";
    IconType["IconUtilityTree"] = "ICON_UTILITY_TREE";
    IconType["IconUtilityTwoFactorAuth"] = "ICON_UTILITY_TWO_FACTOR_AUTH";
    IconType["IconUtilityUp"] = "ICON_UTILITY_UP";
    IconType["IconUtilityUpFilled"] = "ICON_UTILITY_UP_FILLED";
    IconType["IconUtilityWand"] = "ICON_UTILITY_WAND";
    IconType["IconUtilityWithdraw"] = "ICON_UTILITY_WITHDRAW";
    IconType["IconVideo"] = "ICON_VIDEO";
    IconType["IconVideo12"] = "ICON_VIDEO12";
    IconType["IconVideoControls_10SForward"] = "ICON_VIDEO_CONTROLS_10S_FORWARD";
    IconType["IconVideoControls_10SRewind"] = "ICON_VIDEO_CONTROLS_10S_REWIND";
    IconType["IconVideoControlsMuted"] = "ICON_VIDEO_CONTROLS_MUTED";
    IconType["IconVideoControlsPause"] = "ICON_VIDEO_CONTROLS_PAUSE";
    IconType["IconVideoControlsPlay"] = "ICON_VIDEO_CONTROLS_PLAY";
    IconType["IconVideoControlsReplay"] = "ICON_VIDEO_CONTROLS_REPLAY";
    IconType["IconVideoControlsSoundOn"] = "ICON_VIDEO_CONTROLS_SOUND_ON";
    IconType["IconViews"] = "ICON_VIEWS";
    IconType["IconWithdraw"] = "ICON_WITHDRAW";
})(IconType = exports.IconType || (exports.IconType = {}));
var IdentitySubaccount;
(function (IdentitySubaccount) {
    IdentitySubaccount["Bank"] = "BANK";
    IdentitySubaccount["Invest"] = "INVEST";
})(IdentitySubaccount = exports.IdentitySubaccount || (exports.IdentitySubaccount = {}));
var ImageType;
(function (ImageType) {
    ImageType["Back"] = "back";
    ImageType["Front"] = "front";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
var IneligibleReasons;
(function (IneligibleReasons) {
    IneligibleReasons["RequiredAccountsNotOpen"] = "REQUIRED_ACCOUNTS_NOT_OPEN";
    IneligibleReasons["SubscriptionTierIneligible"] = "SUBSCRIPTION_TIER_INELIGIBLE";
})(IneligibleReasons = exports.IneligibleReasons || (exports.IneligibleReasons = {}));
var IntentStatus;
(function (IntentStatus) {
    IntentStatus["Canceled"] = "CANCELED";
    IntentStatus["Canceling"] = "CANCELING";
    IntentStatus["Complete"] = "COMPLETE";
    IntentStatus["Failed"] = "FAILED";
    IntentStatus["Pending"] = "PENDING";
    IntentStatus["Reversed"] = "REVERSED";
    IntentStatus["Reversing"] = "REVERSING";
    IntentStatus["Submitted"] = "SUBMITTED";
})(IntentStatus = exports.IntentStatus || (exports.IntentStatus = {}));
var InvalidSecurityForAllocationReasonEnum;
(function (InvalidSecurityForAllocationReasonEnum) {
    InvalidSecurityForAllocationReasonEnum["SecurityDeactivated"] = "SECURITY_DEACTIVATED";
})(InvalidSecurityForAllocationReasonEnum = exports.InvalidSecurityForAllocationReasonEnum || (exports.InvalidSecurityForAllocationReasonEnum = {}));
/** Enum for valid keys in Investing Strategy Factors */
var InvestingStrategyFactorKey;
(function (InvestingStrategyFactorKey) {
    InvestingStrategyFactorKey["Age"] = "AGE";
    InvestingStrategyFactorKey["AnnualIncome"] = "ANNUAL_INCOME";
    InvestingStrategyFactorKey["CombinedAnnualIncome"] = "COMBINED_ANNUAL_INCOME";
    InvestingStrategyFactorKey["Employees"] = "EMPLOYEES";
    InvestingStrategyFactorKey["EmploymentStatus"] = "EMPLOYMENT_STATUS";
    InvestingStrategyFactorKey["FilingType"] = "FILING_TYPE";
    InvestingStrategyFactorKey["FinancialEducation"] = "FINANCIAL_EDUCATION";
    InvestingStrategyFactorKey["InvestmentGoal"] = "INVESTMENT_GOAL";
    InvestingStrategyFactorKey["MaritalStatus"] = "MARITAL_STATUS";
    InvestingStrategyFactorKey["NetWorth"] = "NET_WORTH";
    InvestingStrategyFactorKey["NetWorthEstimate"] = "NET_WORTH_ESTIMATE";
    InvestingStrategyFactorKey["SelfEmployedIncome"] = "SELF_EMPLOYED_INCOME";
    InvestingStrategyFactorKey["Theme"] = "THEME";
})(InvestingStrategyFactorKey = exports.InvestingStrategyFactorKey || (exports.InvestingStrategyFactorKey = {}));
var InvestmentAccountClosureReason;
(function (InvestmentAccountClosureReason) {
    /** Can't afford at this time */
    InvestmentAccountClosureReason["CantAffordAtThisTime"] = "CANT_AFFORD_AT_THIS_TIME";
    /** Change age of transfer */
    InvestmentAccountClosureReason["ChangeAgeOfTransfer"] = "CHANGE_AGE_OF_TRANSFER";
    /** Going to a competitor */
    InvestmentAccountClosureReason["GoingToACompetitor"] = "GOING_TO_A_COMPETITOR";
    /** Had a bad experience */
    InvestmentAccountClosureReason["HadABadExperience"] = "HAD_A_BAD_EXPERIENCE";
    /** Not seeing the value */
    InvestmentAccountClosureReason["NotSeeingTheValue"] = "NOT_SEEING_THE_VALUE";
    /** No longer use */
    InvestmentAccountClosureReason["NoLongerUse"] = "NO_LONGER_USE";
    /** Other */
    InvestmentAccountClosureReason["Other"] = "OTHER";
    /** Rolling over to another ira */
    InvestmentAccountClosureReason["RollingOverToAnotherIra"] = "ROLLING_OVER_TO_ANOTHER_IRA";
    /** Switching to another savings plan */
    InvestmentAccountClosureReason["SwitchingToAnotherSavingsPlan"] = "SWITCHING_TO_ANOTHER_SAVINGS_PLAN";
    /** Using funds for another purpose */
    InvestmentAccountClosureReason["UsingFundsForAnotherPurpose"] = "USING_FUNDS_FOR_ANOTHER_PURPOSE";
    /** Using funds for the good of the child */
    InvestmentAccountClosureReason["WithdrawalForChild"] = "WITHDRAWAL_FOR_CHILD";
})(InvestmentAccountClosureReason = exports.InvestmentAccountClosureReason || (exports.InvestmentAccountClosureReason = {}));
var InvestmentAccountReopenCheck;
(function (InvestmentAccountReopenCheck) {
    /** Account locked check */
    InvestmentAccountReopenCheck["AccountLockedCheck"] = "ACCOUNT_LOCKED_CHECK";
    /** Account suspended check */
    InvestmentAccountReopenCheck["AccountSuspendedCheck"] = "ACCOUNT_SUSPENDED_CHECK";
    /** Backup withholding check */
    InvestmentAccountReopenCheck["BackupWithholdingCheck"] = "BACKUP_WITHHOLDING_CHECK";
    /** Investment collections check */
    InvestmentAccountReopenCheck["InvestmentCollectionsCheck"] = "INVESTMENT_COLLECTIONS_CHECK";
    /** Spend collections check */
    InvestmentAccountReopenCheck["SpendCollectionsCheck"] = "SPEND_COLLECTIONS_CHECK";
    /** Underage check */
    InvestmentAccountReopenCheck["UnderageCheck"] = "UNDERAGE_CHECK";
})(InvestmentAccountReopenCheck = exports.InvestmentAccountReopenCheck || (exports.InvestmentAccountReopenCheck = {}));
var InvestmentAccountReopenRequestState;
(function (InvestmentAccountReopenRequestState) {
    /** Indicates that the request has been approved */
    InvestmentAccountReopenRequestState["Approved"] = "APPROVED";
    /** Indicates that the request must be reviewed by invest ops */
    InvestmentAccountReopenRequestState["PendingReview"] = "PENDING_REVIEW";
    /** Indicates that the request is pending user action */
    InvestmentAccountReopenRequestState["PendingUserAction"] = "PENDING_USER_ACTION";
    /** Indicates that the request has been rejected */
    InvestmentAccountReopenRequestState["Rejected"] = "REJECTED";
    /** Indicates that the request has been made but not yet processed */
    InvestmentAccountReopenRequestState["Requested"] = "REQUESTED";
})(InvestmentAccountReopenRequestState = exports.InvestmentAccountReopenRequestState || (exports.InvestmentAccountReopenRequestState = {}));
var InvestmentAccountStatus;
(function (InvestmentAccountStatus) {
    /** Investment account is closed */
    InvestmentAccountStatus["Closed"] = "CLOSED";
    /** Investment account has reached transfer age */
    InvestmentAccountStatus["LockedForTransfer"] = "LOCKED_FOR_TRANSFER";
    /** Investment account is open */
    InvestmentAccountStatus["Open"] = "OPEN";
    /** Account has started account closure process */
    InvestmentAccountStatus["PendingClosure"] = "PENDING_CLOSURE";
    /** Account has been created but is not fully activated/open */
    InvestmentAccountStatus["PendingOpen"] = "PENDING_OPEN";
    /** Account has started account reopen process */
    InvestmentAccountStatus["PendingReopen"] = "PENDING_REOPEN";
})(InvestmentAccountStatus = exports.InvestmentAccountStatus || (exports.InvestmentAccountStatus = {}));
var InvestmentAccountType;
(function (InvestmentAccountType) {
    /** Basic investment account */
    InvestmentAccountType["BasicInvestment"] = "BASIC_INVESTMENT";
    /** Roth IRA investment account */
    InvestmentAccountType["RothIra"] = "ROTH_IRA";
    /** Simplified Employee Pension investment account */
    InvestmentAccountType["SimplifiedEmployeePension"] = "SIMPLIFIED_EMPLOYEE_PENSION";
    /** Traditional IRA investment account */
    InvestmentAccountType["TraditionalIra"] = "TRADITIONAL_IRA";
    /** Uniform Gift to Minors Act Custodial Investment Account */
    InvestmentAccountType["Ugma"] = "UGMA";
    /** Uniform Transfer to Minors Act Custodial Investment Account */
    InvestmentAccountType["Utma"] = "UTMA";
    /** @deprecated Use BASIC_INVESTMENT. */
    InvestmentAccountType["AcornsInvestingAccount"] = "acornsInvestingAccount";
    /** @deprecated Use ROTH_IRA */
    /** @deprecated Use SIMPLIFIED_EMPLOYEE_PENSION */
    /** @deprecated Use TRADITIONAL_IRA. */
})(InvestmentAccountType = exports.InvestmentAccountType || (exports.InvestmentAccountType = {}));
var InvestmentAccountTypes;
(function (InvestmentAccountTypes) {
    InvestmentAccountTypes["RothIra"] = "RothIRA";
    InvestmentAccountTypes["SimplifiedEmployeePension"] = "SimplifiedEmployeePension";
    InvestmentAccountTypes["TraditionalIra"] = "TraditionalIRA";
})(InvestmentAccountTypes = exports.InvestmentAccountTypes || (exports.InvestmentAccountTypes = {}));
var InvestmentAllocationStatus;
(function (InvestmentAllocationStatus) {
    /** Shares that have been returned due to a declined funding transfer. */
    InvestmentAllocationStatus["Chargeback"] = "CHARGEBACK";
    /** Shares that have been bought or sold but are not yet settled to the account. */
    InvestmentAllocationStatus["Pending"] = "PENDING";
    /** Shares that have settled in the account. */
    InvestmentAllocationStatus["Settled"] = "SETTLED";
})(InvestmentAllocationStatus = exports.InvestmentAllocationStatus || (exports.InvestmentAllocationStatus = {}));
var InvestmentAllocationType;
(function (InvestmentAllocationType) {
    InvestmentAllocationType["Buy"] = "BUY";
    InvestmentAllocationType["Sell"] = "SELL";
})(InvestmentAllocationType = exports.InvestmentAllocationType || (exports.InvestmentAllocationType = {}));
var InvestmentFrequency;
(function (InvestmentFrequency) {
    InvestmentFrequency["Daily"] = "daily";
    InvestmentFrequency["Monthly"] = "monthly";
    InvestmentFrequency["Weekly"] = "weekly";
})(InvestmentFrequency = exports.InvestmentFrequency || (exports.InvestmentFrequency = {}));
var InvestmentGoal;
(function (InvestmentGoal) {
    /** User is looking for a balanced portfolio */
    InvestmentGoal["Balanced"] = "BALANCED";
    /** User is looking for conservative growth in their investments */
    InvestmentGoal["Conservative"] = "CONSERVATIVE";
    /** User is looking for exponential growth in their investments */
    InvestmentGoal["ExponentialGrowth"] = "EXPONENTIAL_GROWTH";
    /** User is looking for moderate growth in their investments */
    InvestmentGoal["ModerateGrowth"] = "MODERATE_GROWTH";
    /** User is looking to reduce risk in their investments */
    InvestmentGoal["ReducedRisk"] = "REDUCED_RISK";
})(InvestmentGoal = exports.InvestmentGoal || (exports.InvestmentGoal = {}));
var InvestmentProduct;
(function (InvestmentProduct) {
    /** Early investment product */
    InvestmentProduct["Early"] = "EARLY";
    /** Invest investment product */
    InvestmentProduct["Invest"] = "INVEST";
    /** Later investment product */
    InvestmentProduct["Later"] = "LATER";
})(InvestmentProduct = exports.InvestmentProduct || (exports.InvestmentProduct = {}));
var InvestmentRoundUpType;
(function (InvestmentRoundUpType) {
    InvestmentRoundUpType["Automatic"] = "AUTOMATIC";
    InvestmentRoundUpType["RealTime"] = "REAL_TIME";
})(InvestmentRoundUpType = exports.InvestmentRoundUpType || (exports.InvestmentRoundUpType = {}));
var InvestmentStatus;
(function (InvestmentStatus) {
    InvestmentStatus["All"] = "all";
    InvestmentStatus["Finished"] = "finished";
    InvestmentStatus["Unfinished"] = "unfinished";
})(InvestmentStatus = exports.InvestmentStatus || (exports.InvestmentStatus = {}));
/** Investment statuses that are used by frontend clients and external queries */
var InvestmentStatusV2;
(function (InvestmentStatusV2) {
    /** Investment not translated */
    InvestmentStatusV2["NotTranslated"] = "NOT_TRANSLATED";
    /** Investment pending authorization */
    InvestmentStatusV2["Pending"] = "PENDING";
    /** Investment refunded */
    InvestmentStatusV2["Refunded"] = "REFUNDED";
    /** Investment returned */
    InvestmentStatusV2["Returned"] = "RETURNED";
    /** Investment reversed */
    InvestmentStatusV2["Reversed"] = "REVERSED";
    /** Investment revoked */
    InvestmentStatusV2["Revoked"] = "REVOKED";
    /** Investment settled */
    InvestmentStatusV2["Settled"] = "SETTLED";
    /** Investment transferred */
    InvestmentStatusV2["Transferring"] = "TRANSFERRING";
})(InvestmentStatusV2 = exports.InvestmentStatusV2 || (exports.InvestmentStatusV2 = {}));
var InvestmentTransactionType;
(function (InvestmentTransactionType) {
    InvestmentTransactionType["Credit"] = "CREDIT";
    InvestmentTransactionType["Debit"] = "DEBIT";
})(InvestmentTransactionType = exports.InvestmentTransactionType || (exports.InvestmentTransactionType = {}));
/** All investment types */
var InvestmentType;
(function (InvestmentType) {
    InvestmentType["AutomatedRebalance"] = "AUTOMATED_REBALANCE";
    InvestmentType["CashOwedCollection"] = "CASH_OWED_COLLECTION";
    InvestmentType["CashReinvestment"] = "CASH_REINVESTMENT";
    InvestmentType["DirectDepositSplit"] = "DIRECT_DEPOSIT_SPLIT";
    InvestmentType["Dividend"] = "DIVIDEND";
    InvestmentType["EarlyGift"] = "EARLY_GIFT";
    InvestmentType["EarnReward"] = "EARN_REWARD";
    InvestmentType["Fee"] = "FEE";
    InvestmentType["GiftCard"] = "GIFT_CARD";
    InvestmentType["HoldingsTransfer"] = "HOLDINGS_TRANSFER";
    InvestmentType["IraTransfer"] = "IRA_TRANSFER";
    InvestmentType["Match"] = "MATCH";
    InvestmentType["MatchRemoval"] = "MATCH_REMOVAL";
    InvestmentType["OneTimeInvestment"] = "ONE_TIME_INVESTMENT";
    InvestmentType["RecurringInvestment"] = "RECURRING_INVESTMENT";
    InvestmentType["Refund"] = "REFUND";
    InvestmentType["Reversal"] = "REVERSAL";
    InvestmentType["RoundUp"] = "ROUND_UP";
    InvestmentType["SecurityLiquidation"] = "SECURITY_LIQUIDATION";
    InvestmentType["Withdrawal"] = "WITHDRAWAL";
})(InvestmentType = exports.InvestmentType || (exports.InvestmentType = {}));
/** Types of investments available */
var InvestmentTypes;
(function (InvestmentTypes) {
    /** Credit investment (lump sum deposit) */
    InvestmentTypes["Credit"] = "credit";
    /** Debit investment (withdrawal) */
    InvestmentTypes["Debit"] = "debit";
})(InvestmentTypes = exports.InvestmentTypes || (exports.InvestmentTypes = {}));
/** Supported types of search criteria */
var JobSearchFilterKey;
(function (JobSearchFilterKey) {
    /** finds jobs with exact match for company name */
    JobSearchFilterKey["Company"] = "COMPANY";
    /** finds jobs that have metadata matching this phrase */
    JobSearchFilterKey["KeyPhrase"] = "KEY_PHRASE";
})(JobSearchFilterKey = exports.JobSearchFilterKey || (exports.JobSearchFilterKey = {}));
var KycStatus;
(function (KycStatus) {
    KycStatus["Accepted"] = "accepted";
    KycStatus["ActionRequired"] = "actionRequired";
    KycStatus["Failure"] = "failure";
    KycStatus["Pending"] = "pending";
})(KycStatus = exports.KycStatus || (exports.KycStatus = {}));
/** All later account codes */
var LaterAccountCodes;
(function (LaterAccountCodes) {
    LaterAccountCodes["Roth"] = "ROTH";
    LaterAccountCodes["Sep"] = "SEP";
    LaterAccountCodes["Traditional"] = "TRADITIONAL";
})(LaterAccountCodes = exports.LaterAccountCodes || (exports.LaterAccountCodes = {}));
/** All later account statuses */
var LaterAccountStatus;
(function (LaterAccountStatus) {
    LaterAccountStatus["Active"] = "ACTIVE";
    LaterAccountStatus["Closed"] = "CLOSED";
    LaterAccountStatus["FailedToCreate"] = "FAILED_TO_CREATE";
    LaterAccountStatus["Hidden"] = "HIDDEN";
    LaterAccountStatus["Inactive"] = "INACTIVE";
    LaterAccountStatus["Pending"] = "PENDING";
})(LaterAccountStatus = exports.LaterAccountStatus || (exports.LaterAccountStatus = {}));
var LaterHistoryItemType;
(function (LaterHistoryItemType) {
    LaterHistoryItemType["Deposit"] = "deposit";
    LaterHistoryItemType["Rollover"] = "rollover";
    LaterHistoryItemType["Transfer"] = "transfer";
    LaterHistoryItemType["Withdrawal"] = "withdrawal";
})(LaterHistoryItemType = exports.LaterHistoryItemType || (exports.LaterHistoryItemType = {}));
/** Reason for withdrawing from a later account */
var LaterWithdrawalReason;
(function (LaterWithdrawalReason) {
    LaterWithdrawalReason["DirectTransfer"] = "direct_transfer";
    LaterWithdrawalReason["EarlyWithdrawal"] = "early_withdrawal";
    LaterWithdrawalReason["OverContribution"] = "over_contribution";
    LaterWithdrawalReason["Retirement"] = "retirement";
    LaterWithdrawalReason["Rollover"] = "rollover";
})(LaterWithdrawalReason = exports.LaterWithdrawalReason || (exports.LaterWithdrawalReason = {}));
/** Reason for withdrawing from a later account Deprecated - this can be derived from the LaterWithdrawalReason below */
var LaterWithdrawalType;
(function (LaterWithdrawalType) {
    LaterWithdrawalType["EarlyDistribution"] = "EarlyDistribution";
    LaterWithdrawalType["IneligibleContribution"] = "IneligibleContribution";
    LaterWithdrawalType["NormalDistribution"] = "NormalDistribution";
})(LaterWithdrawalType = exports.LaterWithdrawalType || (exports.LaterWithdrawalType = {}));
var LearnAspectRatioType;
(function (LearnAspectRatioType) {
    LearnAspectRatioType["Landscape"] = "LANDSCAPE";
    LearnAspectRatioType["Portrait"] = "PORTRAIT";
})(LearnAspectRatioType = exports.LearnAspectRatioType || (exports.LearnAspectRatioType = {}));
var LearnContentSortType;
(function (LearnContentSortType) {
    LearnContentSortType["Duration"] = "DURATION";
    LearnContentSortType["MostRecent"] = "MOST_RECENT";
    LearnContentSortType["MostRelevant"] = "MOST_RELEVANT";
    LearnContentSortType["MostViewed"] = "MOST_VIEWED";
    LearnContentSortType["Trending"] = "TRENDING";
})(LearnContentSortType = exports.LearnContentSortType || (exports.LearnContentSortType = {}));
var LearnContentType;
(function (LearnContentType) {
    LearnContentType["Article"] = "ARTICLE";
    LearnContentType["Course"] = "COURSE";
    LearnContentType["Lesson"] = "LESSON";
    LearnContentType["MediaArticle"] = "MEDIA_ARTICLE";
    LearnContentType["Poll"] = "POLL";
    LearnContentType["Quiz"] = "QUIZ";
})(LearnContentType = exports.LearnContentType || (exports.LearnContentType = {}));
var LearnContentViewStatus;
(function (LearnContentViewStatus) {
    LearnContentViewStatus["Unviewed"] = "UNVIEWED";
    LearnContentViewStatus["Viewed"] = "VIEWED";
})(LearnContentViewStatus = exports.LearnContentViewStatus || (exports.LearnContentViewStatus = {}));
var LearnMediaType;
(function (LearnMediaType) {
    LearnMediaType["Audio"] = "AUDIO";
    LearnMediaType["LiveVideo"] = "LIVE_VIDEO";
    LearnMediaType["Video"] = "VIDEO";
})(LearnMediaType = exports.LearnMediaType || (exports.LearnMediaType = {}));
var LearnPollType;
(function (LearnPollType) {
    LearnPollType["Emoji"] = "EMOJI";
    LearnPollType["Option"] = "OPTION";
    LearnPollType["YesNo"] = "YES_NO";
})(LearnPollType = exports.LearnPollType || (exports.LearnPollType = {}));
var LearnProductKey;
(function (LearnProductKey) {
    LearnProductKey["Learn"] = "LEARN";
    LearnProductKey["LearnPremium"] = "LEARN_PREMIUM";
})(LearnProductKey = exports.LearnProductKey || (exports.LearnProductKey = {}));
var LearnProgressUnit;
(function (LearnProgressUnit) {
    LearnProgressUnit["Percents"] = "PERCENTS";
    LearnProgressUnit["Seconds"] = "SECONDS";
    LearnProgressUnit["Stages"] = "STAGES";
})(LearnProgressUnit = exports.LearnProgressUnit || (exports.LearnProgressUnit = {}));
var LearnQuestionType;
(function (LearnQuestionType) {
    LearnQuestionType["FillInTheBlank"] = "FILL_IN_THE_BLANK";
    LearnQuestionType["MultiSelect"] = "MULTI_SELECT";
    LearnQuestionType["NumericRange"] = "NUMERIC_RANGE";
    LearnQuestionType["SingleSelect"] = "SINGLE_SELECT";
    LearnQuestionType["TwoOptions"] = "TWO_OPTIONS";
})(LearnQuestionType = exports.LearnQuestionType || (exports.LearnQuestionType = {}));
var LearnRangeType;
(function (LearnRangeType) {
    LearnRangeType["Dial"] = "DIAL";
    LearnRangeType["Slider"] = "SLIDER";
})(LearnRangeType = exports.LearnRangeType || (exports.LearnRangeType = {}));
var LearnSearchContentType;
(function (LearnSearchContentType) {
    LearnSearchContentType["Article"] = "ARTICLE";
    LearnSearchContentType["Audio"] = "AUDIO";
    LearnSearchContentType["Course"] = "COURSE";
    LearnSearchContentType["Video"] = "VIDEO";
})(LearnSearchContentType = exports.LearnSearchContentType || (exports.LearnSearchContentType = {}));
var LinkCustomization;
(function (LinkCustomization) {
    /** A link customization for optionally accessing the users ssn. */
    LinkCustomization["CardLink"] = "CARD_LINK";
    /** The standard link customization. */
    LinkCustomization["Default"] = "DEFAULT";
    /** A link customization for only accessing funding source information. */
    LinkCustomization["FundingSourceLink"] = "FUNDING_SOURCE_LINK";
    /** A link customization for not requiring the users name. */
    LinkCustomization["SansNameLink"] = "SANS_NAME_LINK";
})(LinkCustomization = exports.LinkCustomization || (exports.LinkCustomization = {}));
var LinkProviderType;
(function (LinkProviderType) {
    /** Direct bank provider type. */
    LinkProviderType["DirectBank"] = "DIRECT_BANK";
    /** Plaid provider type */
    LinkProviderType["Plaid"] = "PLAID";
    /** Spend provider type. */
    LinkProviderType["Spend"] = "SPEND";
})(LinkProviderType = exports.LinkProviderType || (exports.LinkProviderType = {}));
var LinkSessionLanguage;
(function (LinkSessionLanguage) {
    /** English */
    LinkSessionLanguage["En"] = "EN";
    /** Spanish */
    LinkSessionLanguage["Es"] = "ES";
    /** French */
    LinkSessionLanguage["Fr"] = "FR";
    /** Dutch */
    LinkSessionLanguage["Nl"] = "NL";
})(LinkSessionLanguage = exports.LinkSessionLanguage || (exports.LinkSessionLanguage = {}));
var LinkedAccountExternalSourceEnum;
(function (LinkedAccountExternalSourceEnum) {
    /** The link was created directly between the corresponding bank's API and Acorns */
    LinkedAccountExternalSourceEnum["DirectBank"] = "direct_bank";
    /** The user linked by manually entering an account & routing number */
    LinkedAccountExternalSourceEnum["Manual"] = "manual";
    /** PayPal direct connection was used to link this account */
    LinkedAccountExternalSourceEnum["Paypal"] = "paypal";
    /** The link was created through Plaid and represents an external financial institution */
    LinkedAccountExternalSourceEnum["Plaid"] = "plaid";
    /** This account has an internal Acorns spend account associated with it */
    LinkedAccountExternalSourceEnum["Spend"] = "spend";
})(LinkedAccountExternalSourceEnum = exports.LinkedAccountExternalSourceEnum || (exports.LinkedAccountExternalSourceEnum = {}));
var LinkedAccountLinkingErrorsEnum;
(function (LinkedAccountLinkingErrorsEnum) {
    /** Online banking system is down */
    LinkedAccountLinkingErrorsEnum["InstitutionDown"] = "INSTITUTION_DOWN";
    /** Online banking system is unresponsive */
    LinkedAccountLinkingErrorsEnum["InstitutionNotAvailable"] = "INSTITUTION_NOT_AVAILABLE";
    /** Online banking system is unresponsive */
    LinkedAccountLinkingErrorsEnum["InstitutionNotResponding"] = "INSTITUTION_NOT_RESPONDING";
    /** Online banking system is not supported anymore */
    LinkedAccountLinkingErrorsEnum["InstitutionNoLongerSupported"] = "INSTITUTION_NO_LONGER_SUPPORTED";
    /** Server error */
    LinkedAccountLinkingErrorsEnum["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    /** Error with incorrect institution security questions */
    LinkedAccountLinkingErrorsEnum["InvalidMfa"] = "INVALID_MFA";
    /** Online banking credentials have been updated */
    LinkedAccountLinkingErrorsEnum["InvalidUpdatedUsername"] = "INVALID_UPDATED_USERNAME";
    /** Online banking account is locked */
    LinkedAccountLinkingErrorsEnum["ItemLocked"] = "ITEM_LOCKED";
    /** Error with institution security settings */
    LinkedAccountLinkingErrorsEnum["ItemNotSupported"] = "ITEM_NOT_SUPPORTED";
    /** Error with institution security questions */
    LinkedAccountLinkingErrorsEnum["MfaNotSupported"] = "MFA_NOT_SUPPORTED";
    /** Online banking account is not fully set up */
    LinkedAccountLinkingErrorsEnum["UserSetupRequired"] = "USER_SETUP_REQUIRED";
})(LinkedAccountLinkingErrorsEnum = exports.LinkedAccountLinkingErrorsEnum || (exports.LinkedAccountLinkingErrorsEnum = {}));
var LinkedAccountStatusEnum;
(function (LinkedAccountStatusEnum) {
    /** The user must take action with their financial institution to fix the issue */
    LinkedAccountStatusEnum["ExternalAction"] = "externalAction";
    /** The user must relink and update their linked account to continue functioning */
    LinkedAccountStatusEnum["Relink"] = "relink";
    /** The linked account is working and requires no action */
    LinkedAccountStatusEnum["Success"] = "success";
    /** The linked account or financial institution is no longer supported and can be unlinked */
    LinkedAccountStatusEnum["Unsupported"] = "unsupported";
})(LinkedAccountStatusEnum = exports.LinkedAccountStatusEnum || (exports.LinkedAccountStatusEnum = {}));
var LinkedSubaccountPaymentEngineEnum;
(function (LinkedSubaccountPaymentEngineEnum) {
    /** The linked subaccount is linked in ProfitStars */
    LinkedSubaccountPaymentEngineEnum["ProfitStars"] = "profitStars";
})(LinkedSubaccountPaymentEngineEnum = exports.LinkedSubaccountPaymentEngineEnum || (exports.LinkedSubaccountPaymentEngineEnum = {}));
var LinkedSubaccountRoleEnum;
(function (LinkedSubaccountRoleEnum) {
    /** The subaccount is the primary funding source of the user */
    LinkedSubaccountRoleEnum["PrimaryFunding"] = "primaryFunding";
    /** The subaccount is the secondary funding source of the user */
    LinkedSubaccountRoleEnum["SecondaryFunding"] = "secondaryFunding";
})(LinkedSubaccountRoleEnum = exports.LinkedSubaccountRoleEnum || (exports.LinkedSubaccountRoleEnum = {}));
var LiquidationUnavailableReason;
(function (LiquidationUnavailableReason) {
    /** The funding source is frozen. */
    LiquidationUnavailableReason["FundingSourceFrozen"] = "FUNDING_SOURCE_FROZEN";
    /** The associated funding source requires RDV. */
    LiquidationUnavailableReason["FundingSourceRdvRequired"] = "FUNDING_SOURCE_RDV_REQUIRED";
    /** No funding source exists for the investment account. */
    LiquidationUnavailableReason["FundingSourceRequired"] = "FUNDING_SOURCE_REQUIRED";
})(LiquidationUnavailableReason = exports.LiquidationUnavailableReason || (exports.LiquidationUnavailableReason = {}));
var MailInDocumentType;
(function (MailInDocumentType) {
    MailInDocumentType["BillNegotiation"] = "BILL_NEGOTIATION";
    MailInDocumentType["FeeNegotiation"] = "FEE_NEGOTIATION";
})(MailInDocumentType = exports.MailInDocumentType || (exports.MailInDocumentType = {}));
var ManagePayoutRelationshipAction;
(function (ManagePayoutRelationshipAction) {
    ManagePayoutRelationshipAction["Add"] = "ADD";
    ManagePayoutRelationshipAction["Remove"] = "REMOVE";
})(ManagePayoutRelationshipAction = exports.ManagePayoutRelationshipAction || (exports.ManagePayoutRelationshipAction = {}));
var ManagePayoutRelationshipResult;
(function (ManagePayoutRelationshipResult) {
    ManagePayoutRelationshipResult["Fail"] = "FAIL";
    ManagePayoutRelationshipResult["Success"] = "SUCCESS";
})(ManagePayoutRelationshipResult = exports.ManagePayoutRelationshipResult || (exports.ManagePayoutRelationshipResult = {}));
var MaritalStatus;
(function (MaritalStatus) {
    /** User is currently in a civil union */
    MaritalStatus["CivilUnion"] = "civil_union";
    /** User is no longer married due to legal separation */
    MaritalStatus["Divorced"] = "divorced";
    /** User is married currently */
    MaritalStatus["Married"] = "married";
    /** User has never been married */
    MaritalStatus["Single"] = "single";
    /** User is no longer married due to death of spouse */
    MaritalStatus["Widowed"] = "widowed";
})(MaritalStatus = exports.MaritalStatus || (exports.MaritalStatus = {}));
var MessageCategory;
(function (MessageCategory) {
    MessageCategory["Account"] = "ACCOUNT";
    MessageCategory["Banking"] = "BANKING";
    MessageCategory["BenefitsHub"] = "BENEFITS_HUB";
    MessageCategory["Braze"] = "BRAZE";
    MessageCategory["Earn"] = "EARN";
    MessageCategory["Invest"] = "INVEST";
    MessageCategory["Later"] = "LATER";
    MessageCategory["Milestone"] = "MILESTONE";
    MessageCategory["Onboarding"] = "ONBOARDING";
})(MessageCategory = exports.MessageCategory || (exports.MessageCategory = {}));
var MessageFeedbackReason;
(function (MessageFeedbackReason) {
    MessageFeedbackReason["InaccurateInformation"] = "INACCURATE_INFORMATION";
    MessageFeedbackReason["NotHelpful"] = "NOT_HELPFUL";
    MessageFeedbackReason["Offensive"] = "OFFENSIVE";
    MessageFeedbackReason["Other"] = "OTHER";
})(MessageFeedbackReason = exports.MessageFeedbackReason || (exports.MessageFeedbackReason = {}));
var MessageStatus;
(function (MessageStatus) {
    MessageStatus["Dismissed"] = "DISMISSED";
    MessageStatus["Read"] = "READ";
})(MessageStatus = exports.MessageStatus || (exports.MessageStatus = {}));
var MessageType;
(function (MessageType) {
    MessageType["Alert"] = "ALERT";
    MessageType["Notification"] = "NOTIFICATION";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var MilestoneAchievementActionType;
(function (MilestoneAchievementActionType) {
    MilestoneAchievementActionType["AnalyticsEvent"] = "ANALYTICS_EVENT";
    MilestoneAchievementActionType["NativeNotification"] = "NATIVE_NOTIFICATION";
})(MilestoneAchievementActionType = exports.MilestoneAchievementActionType || (exports.MilestoneAchievementActionType = {}));
var MilestoneEligibilityScope;
(function (MilestoneEligibilityScope) {
    MilestoneEligibilityScope["AccountSetupComplete"] = "ACCOUNT_SETUP_COMPLETE";
    /** @deprecated this value was only used for the AccountSetup feature experiment that is now over */
    MilestoneEligibilityScope["AccountSetupExp"] = "ACCOUNT_SETUP_EXP";
})(MilestoneEligibilityScope = exports.MilestoneEligibilityScope || (exports.MilestoneEligibilityScope = {}));
var MilestoneRuleArgInput;
(function (MilestoneRuleArgInput) {
    MilestoneRuleArgInput["Datetime"] = "DATETIME";
    MilestoneRuleArgInput["Int"] = "INT";
    MilestoneRuleArgInput["None"] = "NONE";
})(MilestoneRuleArgInput = exports.MilestoneRuleArgInput || (exports.MilestoneRuleArgInput = {}));
var MilestoneRuleType;
(function (MilestoneRuleType) {
    MilestoneRuleType["ActiveCustomer"] = "ACTIVE_CUSTOMER";
    MilestoneRuleType["BalanceReached"] = "BALANCE_REACHED";
    MilestoneRuleType["CardActivation"] = "CARD_ACTIVATION";
    /** @deprecated Use CREATE_ACORNS_ACCOUNT instead */
    MilestoneRuleType["CompleteRegistration"] = "COMPLETE_REGISTRATION";
    MilestoneRuleType["CreateAcornsAccount"] = "CREATE_ACORNS_ACCOUNT";
    MilestoneRuleType["FirstInvestment"] = "FIRST_INVESTMENT";
    MilestoneRuleType["FundingSourceLinked"] = "FUNDING_SOURCE_LINKED";
    MilestoneRuleType["RealtimeRoundup"] = "REALTIME_ROUNDUP";
    MilestoneRuleType["RecurringInvestmentMonthly"] = "RECURRING_INVESTMENT_MONTHLY";
    MilestoneRuleType["RewardCreated"] = "REWARD_CREATED";
    MilestoneRuleType["Roundup"] = "ROUNDUP";
    MilestoneRuleType["Signup"] = "SIGNUP";
    MilestoneRuleType["SmartDepositCompleted"] = "SMART_DEPOSIT_COMPLETED";
    MilestoneRuleType["Verified"] = "VERIFIED";
})(MilestoneRuleType = exports.MilestoneRuleType || (exports.MilestoneRuleType = {}));
var MilestoneStatus;
(function (MilestoneStatus) {
    MilestoneStatus["Completed"] = "COMPLETED";
    MilestoneStatus["InProgress"] = "IN_PROGRESS";
    MilestoneStatus["Locked"] = "LOCKED";
    MilestoneStatus["NotStarted"] = "NOT_STARTED";
    MilestoneStatus["Pending"] = "PENDING";
})(MilestoneStatus = exports.MilestoneStatus || (exports.MilestoneStatus = {}));
var MilestoneTheme;
(function (MilestoneTheme) {
    MilestoneTheme["AccountSetup"] = "ACCOUNT_SETUP";
    MilestoneTheme["Acorns"] = "ACORNS";
    MilestoneTheme["Early"] = "EARLY";
    MilestoneTheme["Earn"] = "EARN";
    MilestoneTheme["Invest"] = "INVEST";
    MilestoneTheme["Later"] = "LATER";
    MilestoneTheme["Spend"] = "SPEND";
})(MilestoneTheme = exports.MilestoneTheme || (exports.MilestoneTheme = {}));
var MoneyManagerAllocationNotEditableReason;
(function (MoneyManagerAllocationNotEditableReason) {
    MoneyManagerAllocationNotEditableReason["LaterLimitReached"] = "LATER_LIMIT_REACHED";
    MoneyManagerAllocationNotEditableReason["NoPercentageRemaining"] = "NO_PERCENTAGE_REMAINING";
})(MoneyManagerAllocationNotEditableReason = exports.MoneyManagerAllocationNotEditableReason || (exports.MoneyManagerAllocationNotEditableReason = {}));
var MoneyManagerAllocationStatus;
(function (MoneyManagerAllocationStatus) {
    MoneyManagerAllocationStatus["Complete"] = "COMPLETE";
    MoneyManagerAllocationStatus["Failed"] = "FAILED";
    MoneyManagerAllocationStatus["Pending"] = "PENDING";
})(MoneyManagerAllocationStatus = exports.MoneyManagerAllocationStatus || (exports.MoneyManagerAllocationStatus = {}));
var MoneyManagerAutomationTargetType;
(function (MoneyManagerAutomationTargetType) {
    MoneyManagerAutomationTargetType["Checking"] = "CHECKING";
    MoneyManagerAutomationTargetType["Savings"] = "SAVINGS";
})(MoneyManagerAutomationTargetType = exports.MoneyManagerAutomationTargetType || (exports.MoneyManagerAutomationTargetType = {}));
var MoneyManagerCancelReason;
(function (MoneyManagerCancelReason) {
    MoneyManagerCancelReason["ClosedAccount"] = "CLOSED_ACCOUNT";
    MoneyManagerCancelReason["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    MoneyManagerCancelReason["SubscriptionStatus"] = "SUBSCRIPTION_STATUS";
    MoneyManagerCancelReason["ValidationError"] = "VALIDATION_ERROR";
})(MoneyManagerCancelReason = exports.MoneyManagerCancelReason || (exports.MoneyManagerCancelReason = {}));
var MoneyManagerCascadeObjectiveType;
(function (MoneyManagerCascadeObjectiveType) {
    MoneyManagerCascadeObjectiveType["Balance"] = "BALANCE";
    MoneyManagerCascadeObjectiveType["Overflow"] = "OVERFLOW";
})(MoneyManagerCascadeObjectiveType = exports.MoneyManagerCascadeObjectiveType || (exports.MoneyManagerCascadeObjectiveType = {}));
var MoneyManagerCategoryType;
(function (MoneyManagerCategoryType) {
    MoneyManagerCategoryType["Giving"] = "GIVING";
    MoneyManagerCategoryType["Investing"] = "INVESTING";
    MoneyManagerCategoryType["Kids"] = "KIDS";
    MoneyManagerCategoryType["Saving"] = "SAVING";
    MoneyManagerCategoryType["Spending"] = "SPENDING";
})(MoneyManagerCategoryType = exports.MoneyManagerCategoryType || (exports.MoneyManagerCategoryType = {}));
var MoneyManagerDepositCategory;
(function (MoneyManagerDepositCategory) {
    MoneyManagerDepositCategory["OneTime"] = "ONE_TIME";
    MoneyManagerDepositCategory["Other"] = "OTHER";
    MoneyManagerDepositCategory["Paycheck"] = "PAYCHECK";
    MoneyManagerDepositCategory["Recurring"] = "RECURRING";
})(MoneyManagerDepositCategory = exports.MoneyManagerDepositCategory || (exports.MoneyManagerDepositCategory = {}));
var MoneyManagerDepositState;
(function (MoneyManagerDepositState) {
    /** The customer has never had the Money Manager process a deposit and is waiting for the first deposit to arrive */
    MoneyManagerDepositState["AwaitingFirstDeposit"] = "AWAITING_FIRST_DEPOSIT";
    /** The most recent deposit has arrived and has been split and waiting for the next deposit */
    MoneyManagerDepositState["AwaitingNextDeposit"] = "AWAITING_NEXT_DEPOSIT";
    /** The current deposit has arrived and is pending */
    MoneyManagerDepositState["DepositArrived"] = "DEPOSIT_ARRIVED";
})(MoneyManagerDepositState = exports.MoneyManagerDepositState || (exports.MoneyManagerDepositState = {}));
var MoneyManagerMoneyAssignmentStatus;
(function (MoneyManagerMoneyAssignmentStatus) {
    MoneyManagerMoneyAssignmentStatus["Canceled"] = "CANCELED";
    MoneyManagerMoneyAssignmentStatus["Complete"] = "COMPLETE";
    MoneyManagerMoneyAssignmentStatus["Pending"] = "PENDING";
    MoneyManagerMoneyAssignmentStatus["Skipped"] = "SKIPPED";
    MoneyManagerMoneyAssignmentStatus["Transferring"] = "TRANSFERRING";
})(MoneyManagerMoneyAssignmentStatus = exports.MoneyManagerMoneyAssignmentStatus || (exports.MoneyManagerMoneyAssignmentStatus = {}));
var MoneyManagerMoneyAssignmentType;
(function (MoneyManagerMoneyAssignmentType) {
    MoneyManagerMoneyAssignmentType["Deposit"] = "DEPOSIT";
    MoneyManagerMoneyAssignmentType["Rebalance"] = "REBALANCE";
})(MoneyManagerMoneyAssignmentType = exports.MoneyManagerMoneyAssignmentType || (exports.MoneyManagerMoneyAssignmentType = {}));
var MoneyManagerPeriodUnit;
(function (MoneyManagerPeriodUnit) {
    MoneyManagerPeriodUnit["Month"] = "MONTH";
    MoneyManagerPeriodUnit["Week"] = "WEEK";
})(MoneyManagerPeriodUnit = exports.MoneyManagerPeriodUnit || (exports.MoneyManagerPeriodUnit = {}));
var MoneyManagerRebalanceSouceAccountType;
(function (MoneyManagerRebalanceSouceAccountType) {
    MoneyManagerRebalanceSouceAccountType["Checking"] = "CHECKING";
    MoneyManagerRebalanceSouceAccountType["Savings"] = "SAVINGS";
})(MoneyManagerRebalanceSouceAccountType = exports.MoneyManagerRebalanceSouceAccountType || (exports.MoneyManagerRebalanceSouceAccountType = {}));
var MoneyManagerRebalanceSuppressionSource;
(function (MoneyManagerRebalanceSuppressionSource) {
    MoneyManagerRebalanceSuppressionSource["ClientHome"] = "CLIENT_HOME";
    MoneyManagerRebalanceSuppressionSource["MoneyManagerLander"] = "MONEY_MANAGER_LANDER";
    MoneyManagerRebalanceSuppressionSource["MoneyManagerRebalanceFlow"] = "MONEY_MANAGER_REBALANCE_FLOW";
})(MoneyManagerRebalanceSuppressionSource = exports.MoneyManagerRebalanceSuppressionSource || (exports.MoneyManagerRebalanceSuppressionSource = {}));
var MoneyManagerRecurringFrequency;
(function (MoneyManagerRecurringFrequency) {
    MoneyManagerRecurringFrequency["Monthly"] = "MONTHLY";
    MoneyManagerRecurringFrequency["Weekly"] = "WEEKLY";
})(MoneyManagerRecurringFrequency = exports.MoneyManagerRecurringFrequency || (exports.MoneyManagerRecurringFrequency = {}));
var MoneyManagerState;
(function (MoneyManagerState) {
    /** The customer has never had the Money Manager turned on */
    MoneyManagerState["NotSetup"] = "NOT_SETUP";
    /** The Money Manager is turned off */
    MoneyManagerState["Off"] = "OFF";
    /** The Money Manager is turned on */
    MoneyManagerState["On"] = "ON";
})(MoneyManagerState = exports.MoneyManagerState || (exports.MoneyManagerState = {}));
var MoneyManagerStatus;
(function (MoneyManagerStatus) {
    MoneyManagerStatus["NotSetup"] = "NOT_SETUP";
    MoneyManagerStatus["Off"] = "OFF";
    MoneyManagerStatus["On"] = "ON";
})(MoneyManagerStatus = exports.MoneyManagerStatus || (exports.MoneyManagerStatus = {}));
var MoneyRulesAccountType;
(function (MoneyRulesAccountType) {
    MoneyRulesAccountType["Checking"] = "CHECKING";
    MoneyRulesAccountType["Early"] = "EARLY";
    MoneyRulesAccountType["Invest"] = "INVEST";
    MoneyRulesAccountType["Later"] = "LATER";
    MoneyRulesAccountType["Savings"] = "SAVINGS";
})(MoneyRulesAccountType = exports.MoneyRulesAccountType || (exports.MoneyRulesAccountType = {}));
var MoneyRulesArchetype;
(function (MoneyRulesArchetype) {
    MoneyRulesArchetype["DebtFocused"] = "DEBT_FOCUSED";
    MoneyRulesArchetype["Default"] = "DEFAULT";
    MoneyRulesArchetype["DefaultRebalance"] = "DEFAULT_REBALANCE";
    MoneyRulesArchetype["GivingFocused"] = "GIVING_FOCUSED";
})(MoneyRulesArchetype = exports.MoneyRulesArchetype || (exports.MoneyRulesArchetype = {}));
var MoneyRulesConditionType;
(function (MoneyRulesConditionType) {
    MoneyRulesConditionType["DebtExists"] = "DEBT_EXISTS";
    MoneyRulesConditionType["HighInterestDebtExists"] = "HIGH_INTEREST_DEBT_EXISTS";
    MoneyRulesConditionType["SourceAmountAtLeast"] = "SOURCE_AMOUNT_AT_LEAST";
})(MoneyRulesConditionType = exports.MoneyRulesConditionType || (exports.MoneyRulesConditionType = {}));
var MoneyRulesConditionUnit;
(function (MoneyRulesConditionUnit) {
    MoneyRulesConditionUnit["Currency"] = "CURRENCY";
})(MoneyRulesConditionUnit = exports.MoneyRulesConditionUnit || (exports.MoneyRulesConditionUnit = {}));
var MoneyRulesDepositType;
(function (MoneyRulesDepositType) {
    MoneyRulesDepositType["OneTime"] = "ONE_TIME";
    MoneyRulesDepositType["Paycheck"] = "PAYCHECK";
    MoneyRulesDepositType["Recurring"] = "RECURRING";
})(MoneyRulesDepositType = exports.MoneyRulesDepositType || (exports.MoneyRulesDepositType = {}));
var MoneyRulesDistributionUnit;
(function (MoneyRulesDistributionUnit) {
    MoneyRulesDistributionUnit["FixedAmount"] = "FIXED_AMOUNT";
    MoneyRulesDistributionUnit["Percentage"] = "PERCENTAGE";
})(MoneyRulesDistributionUnit = exports.MoneyRulesDistributionUnit || (exports.MoneyRulesDistributionUnit = {}));
var MoneyRulesRuleType;
(function (MoneyRulesRuleType) {
    MoneyRulesRuleType["FlatPct"] = "FLAT_PCT";
    MoneyRulesRuleType["FlatPctUpToLaterGoal"] = "FLAT_PCT_UP_TO_LATER_GOAL";
    MoneyRulesRuleType["FlatValue"] = "FLAT_VALUE";
    MoneyRulesRuleType["FullRemainder"] = "FULL_REMAINDER";
    MoneyRulesRuleType["UpToCheckingGoal"] = "UP_TO_CHECKING_GOAL";
    MoneyRulesRuleType["UpToSavingsGoal"] = "UP_TO_SAVINGS_GOAL";
})(MoneyRulesRuleType = exports.MoneyRulesRuleType || (exports.MoneyRulesRuleType = {}));
var NegotiationMethod;
(function (NegotiationMethod) {
    NegotiationMethod["Automatic"] = "AUTOMATIC";
    NegotiationMethod["Letter"] = "LETTER";
})(NegotiationMethod = exports.NegotiationMethod || (exports.NegotiationMethod = {}));
var NegotiationType;
(function (NegotiationType) {
    NegotiationType["AutomatedNegotiation"] = "AUTOMATED_NEGOTIATION";
    NegotiationType["MailInNegotiation"] = "MAIL_IN_NEGOTIATION";
})(NegotiationType = exports.NegotiationType || (exports.NegotiationType = {}));
var NetTermsType;
(function (NetTermsType) {
    NetTermsType["Eom"] = "eom";
    NetTermsType["Net"] = "net";
})(NetTermsType = exports.NetTermsType || (exports.NetTermsType = {}));
var OauthAppType;
(function (OauthAppType) {
    OauthAppType["Aggregator"] = "AGGREGATOR";
    OauthAppType["Partner"] = "PARTNER";
})(OauthAppType = exports.OauthAppType || (exports.OauthAppType = {}));
var OfferAvailability;
(function (OfferAvailability) {
    OfferAvailability["All"] = "ALL";
    OfferAvailability["Cancelled"] = "CANCELLED";
    OfferAvailability["Existing"] = "EXISTING";
    OfferAvailability["New"] = "NEW";
    OfferAvailability["None"] = "NONE";
})(OfferAvailability = exports.OfferAvailability || (exports.OfferAvailability = {}));
var OfferExpirationPeriod;
(function (OfferExpirationPeriod) {
    OfferExpirationPeriod["Month"] = "MONTH";
})(OfferExpirationPeriod = exports.OfferExpirationPeriod || (exports.OfferExpirationPeriod = {}));
var OfferGroupsType;
(function (OfferGroupsType) {
    OfferGroupsType["Category"] = "CATEGORY";
    OfferGroupsType["Ranked"] = "RANKED";
})(OfferGroupsType = exports.OfferGroupsType || (exports.OfferGroupsType = {}));
var OfferPriceType;
(function (OfferPriceType) {
    OfferPriceType["Free"] = "FREE";
    OfferPriceType["Monthly"] = "MONTHLY";
})(OfferPriceType = exports.OfferPriceType || (exports.OfferPriceType = {}));
var OfferType;
(function (OfferType) {
    OfferType["Promotional"] = "PROMOTIONAL";
    OfferType["Standard"] = "STANDARD";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var OidcProvider;
(function (OidcProvider) {
    OidcProvider["Apple"] = "APPLE";
    OidcProvider["Google"] = "GOOGLE";
})(OidcProvider = exports.OidcProvider || (exports.OidcProvider = {}));
var OnboardingGroups;
(function (OnboardingGroups) {
    OnboardingGroups["Family"] = "FAMILY";
    OnboardingGroups["Featured"] = "FEATURED";
    OnboardingGroups["Future"] = "FUTURE";
    OnboardingGroups["Security"] = "SECURITY";
})(OnboardingGroups = exports.OnboardingGroups || (exports.OnboardingGroups = {}));
var OnboardingProducts;
(function (OnboardingProducts) {
    OnboardingProducts["BenefitsGohenryStandard"] = "BENEFITS_GOHENRY_STANDARD";
    OnboardingProducts["BenefitsInsuranceStandard"] = "BENEFITS_INSURANCE_STANDARD";
    OnboardingProducts["BenefitsTaxfilingStandard"] = "BENEFITS_TAXFILING_STANDARD";
    OnboardingProducts["BenefitsWillStandard"] = "BENEFITS_WILL_STANDARD";
    OnboardingProducts["Early"] = "EARLY";
    OnboardingProducts["Earn"] = "EARN";
    OnboardingProducts["EarnChoice"] = "EARN_CHOICE";
    OnboardingProducts["EarnPrime"] = "EARN_PRIME";
    OnboardingProducts["EmergencyFund"] = "EMERGENCY_FUND";
    OnboardingProducts["Invest"] = "INVEST";
    OnboardingProducts["Later"] = "LATER";
    OnboardingProducts["LaterMatch"] = "LATER_MATCH";
    OnboardingProducts["SelfDirectedInvest"] = "SELF_DIRECTED_INVEST";
    OnboardingProducts["Spend"] = "SPEND";
})(OnboardingProducts = exports.OnboardingProducts || (exports.OnboardingProducts = {}));
var OnboardingRequirement;
(function (OnboardingRequirement) {
    OnboardingRequirement["AffiliatedWithBrokerDealer"] = "AFFILIATED_WITH_BROKER_DEALER";
    OnboardingRequirement["AnnualIncome"] = "ANNUAL_INCOME";
    OnboardingRequirement["CheckingSignature"] = "CHECKING_SIGNATURE";
    OnboardingRequirement["CombinedAnnualIncome"] = "COMBINED_ANNUAL_INCOME";
    OnboardingRequirement["DateOfBirth"] = "DATE_OF_BIRTH";
    OnboardingRequirement["Ecbsv"] = "ECBSV";
    OnboardingRequirement["Employees"] = "EMPLOYEES";
    OnboardingRequirement["EmploymentStatus"] = "EMPLOYMENT_STATUS";
    OnboardingRequirement["FilingType"] = "FILING_TYPE";
    OnboardingRequirement["FinancialEducation"] = "FINANCIAL_EDUCATION";
    OnboardingRequirement["FirstName"] = "FIRST_NAME";
    OnboardingRequirement["IntroInvestmentAccounts"] = "INTRO_INVESTMENT_ACCOUNTS";
    OnboardingRequirement["InvestmentGoal"] = "INVESTMENT_GOAL";
    OnboardingRequirement["LandingCheckingAccount"] = "LANDING_CHECKING_ACCOUNT";
    OnboardingRequirement["LastName"] = "LAST_NAME";
    OnboardingRequirement["LinkedFundingSource"] = "LINKED_FUNDING_SOURCE";
    OnboardingRequirement["MailingAddress"] = "MAILING_ADDRESS";
    OnboardingRequirement["MaritalStatus"] = "MARITAL_STATUS";
    OnboardingRequirement["NetWorth"] = "NET_WORTH";
    OnboardingRequirement["Occupation"] = "OCCUPATION";
    OnboardingRequirement["PhoneNumber"] = "PHONE_NUMBER";
    OnboardingRequirement["ResidentialAddress"] = "RESIDENTIAL_ADDRESS";
    OnboardingRequirement["ReviewSavingsAccount"] = "REVIEW_SAVINGS_ACCOUNT";
    OnboardingRequirement["ReviewSummary"] = "REVIEW_SUMMARY";
    OnboardingRequirement["SelfEmployedIncome"] = "SELF_EMPLOYED_INCOME";
    OnboardingRequirement["ShareholderOrDirector"] = "SHAREHOLDER_OR_DIRECTOR";
    OnboardingRequirement["SocialSecurityNumber"] = "SOCIAL_SECURITY_NUMBER";
    OnboardingRequirement["SubjectToBackupWithholding"] = "SUBJECT_TO_BACKUP_WITHHOLDING";
    OnboardingRequirement["Subscription"] = "SUBSCRIPTION";
    OnboardingRequirement["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
})(OnboardingRequirement = exports.OnboardingRequirement || (exports.OnboardingRequirement = {}));
var OnboardingTipType;
(function (OnboardingTipType) {
    /** feature */
    OnboardingTipType["Feature"] = "feature";
    /** introduction */
    OnboardingTipType["Intro"] = "intro";
})(OnboardingTipType = exports.OnboardingTipType || (exports.OnboardingTipType = {}));
var OnboardingType;
(function (OnboardingType) {
    OnboardingType["Checking"] = "CHECKING";
    OnboardingType["Early"] = "EARLY";
    OnboardingType["EmergencySavings"] = "EMERGENCY_SAVINGS";
    OnboardingType["Invest"] = "INVEST";
    OnboardingType["Later"] = "LATER";
    OnboardingType["MoneyManager"] = "MONEY_MANAGER";
})(OnboardingType = exports.OnboardingType || (exports.OnboardingType = {}));
var OperationStage;
(function (OperationStage) {
    OperationStage["AuthCompleted"] = "AUTH_COMPLETED";
    OperationStage["AuthFailed"] = "AUTH_FAILED";
    OperationStage["AwaitingTfaCode"] = "AWAITING_TFA_CODE";
    OperationStage["AwaitingTfaOption"] = "AWAITING_TFA_OPTION";
    OperationStage["ProcessingCredentials"] = "PROCESSING_CREDENTIALS";
    OperationStage["ProcessingTfaCode"] = "PROCESSING_TFA_CODE";
    OperationStage["ProcessingTfaOption"] = "PROCESSING_TFA_OPTION";
})(OperationStage = exports.OperationStage || (exports.OperationStage = {}));
var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order = exports.Order || (exports.Order = {}));
var Origin;
(function (Origin) {
    Origin["ExternalGiftCard"] = "external_gift_card";
    Origin["Prepayment"] = "prepayment";
})(Origin = exports.Origin || (exports.Origin = {}));
var PackageStatus;
(function (PackageStatus) {
    /** Available for Pickup */
    PackageStatus["AvailableForPickup"] = "availableForPickup";
    /** Customer Recall */
    PackageStatus["CustomerRecall"] = "customerRecall";
    /** Dead Letter */
    PackageStatus["DeadLetter"] = "deadLetter";
    /** Delivered */
    PackageStatus["Delivered"] = "delivered";
    /** Delivery Status Not Updated */
    PackageStatus["DeliveryStatusNotUpdated"] = "deliveryStatusNotUpdated";
    /** Forwarded to New Address */
    PackageStatus["ForwardedToNewAddress"] = "forwardedToNewAddress";
    /** Logged at USPS */
    PackageStatus["LoggedAtUsps"] = "loggedAtUSPS";
    /** New Item */
    PackageStatus["NewItem"] = "newItem";
    /** Found – No Status */
    PackageStatus["NoStatus"] = "noStatus";
    /** Not Found */
    PackageStatus["NotFound"] = "notFound";
    /** Notice Left for Recipient */
    PackageStatus["NoticeLeftForRecipient"] = "noticeLeftForRecipient";
    /** Other */
    PackageStatus["Other"] = "other";
    /** Out for Delivery */
    PackageStatus["OutForDelivery"] = "outForDelivery";
    /** Returned to Sender */
    PackageStatus["ReturnedToSender"] = "returnedToSender";
    /** Scanned in Route */
    PackageStatus["ScannedInRoute"] = "scannedInRoute";
    /** Undeliverable */
    PackageStatus["Undeliverable"] = "undeliverable";
})(PackageStatus = exports.PackageStatus || (exports.PackageStatus = {}));
var PageName;
(function (PageName) {
    PageName["AboutPortfolio"] = "ABOUT_PORTFOLIO";
    PageName["AddressEdit"] = "ADDRESS_EDIT";
    PageName["AddressInvalid"] = "ADDRESS_INVALID";
    PageName["AddressPreview"] = "ADDRESS_PREVIEW";
    PageName["AddressSuggestion"] = "ADDRESS_SUGGESTION";
    /** @deprecated Animation removed as a page in the web funnel */
    PageName["Analyzing"] = "ANALYZING";
    PageName["BankLinkSuccess"] = "BANK_LINK_SUCCESS";
    PageName["CardOrderReview"] = "CARD_ORDER_REVIEW";
    PageName["CardSignature"] = "CARD_SIGNATURE";
    PageName["ChooseFundingSource"] = "CHOOSE_FUNDING_SOURCE";
    PageName["ContactInfo"] = "CONTACT_INFO";
    PageName["CryptoLander"] = "CRYPTO_LANDER";
    PageName["DateOfBirth"] = "DATE_OF_BIRTH";
    PageName["DirectBankIntegration"] = "DIRECT_BANK_INTEGRATION";
    PageName["DirectBankIntegrationRedirect"] = "DIRECT_BANK_INTEGRATION_REDIRECT";
    PageName["DirectToMobile"] = "DIRECT_TO_MOBILE";
    /** @deprecated Page removed from funnel */
    PageName["EsgDetails"] = "ESG_DETAILS";
    /** @deprecated Page removed from funnel */
    PageName["EsgEducation"] = "ESG_EDUCATION";
    PageName["Funding"] = "FUNDING";
    PageName["Hdyhau"] = "HDYHAU";
    PageName["Institutions"] = "INSTITUTIONS";
    PageName["InvestorQuestions"] = "INVESTOR_QUESTIONS";
    PageName["InvestInterstitial"] = "INVEST_INTERSTITIAL";
    PageName["LaterInterstitial"] = "LATER_INTERSTITIAL";
    PageName["ManualFundingSource"] = "MANUAL_FUNDING_SOURCE";
    PageName["MfaSetUp"] = "MFA_SET_UP";
    PageName["MocReferralReminder"] = "MOC_REFERRAL_REMINDER";
    PageName["MocRoutingInterstitial"] = "MOC_ROUTING_INTERSTITIAL";
    PageName["MocSuccess"] = "MOC_SUCCESS";
    PageName["Occupation"] = "OCCUPATION";
    PageName["OneTimeDeposit"] = "ONE_TIME_DEPOSIT";
    PageName["OneTimeInvestment"] = "ONE_TIME_INVESTMENT";
    PageName["PersonalInfo"] = "PERSONAL_INFO";
    PageName["PhoneNumber"] = "PHONE_NUMBER";
    PageName["PlaidLinkRedirect"] = "PLAID_LINK_REDIRECT";
    PageName["PortfolioDetails"] = "PORTFOLIO_DETAILS";
    PageName["PreviewPortfolio"] = "PREVIEW_PORTFOLIO";
    PageName["PricingInterstitial"] = "PRICING_INTERSTITIAL";
    PageName["ProductOnboarding"] = "PRODUCT_ONBOARDING";
    PageName["ProgressScreen_1"] = "PROGRESS_SCREEN_1";
    PageName["ProgressScreen_2"] = "PROGRESS_SCREEN_2";
    PageName["ProgressScreen_3"] = "PROGRESS_SCREEN_3";
    PageName["RecurringDeposit"] = "RECURRING_DEPOSIT";
    PageName["RecurringInvestment"] = "RECURRING_INVESTMENT";
    /** @deprecated Page removed from funnel */
    PageName["ReferralDisclosure"] = "REFERRAL_DISCLOSURE";
    /** @deprecated Page removed from funnel */
    PageName["ReferralReward"] = "REFERRAL_REWARD";
    PageName["RoundUpsFunding"] = "ROUND_UPS_FUNDING";
    PageName["RoundUpsInterstitial"] = "ROUND_UPS_INTERSTITIAL";
    PageName["RoundUpsPast"] = "ROUND_UPS_PAST";
    PageName["RoundUpsSetUp"] = "ROUND_UPS_SET_UP";
    PageName["SecondChanceBankLink"] = "SECOND_CHANCE_BANK_LINK";
    PageName["SecondChanceInstitutions"] = "SECOND_CHANCE_INSTITUTIONS";
    /** @deprecated Page removed from funnel */
    PageName["SelectPortfolioTheme"] = "SELECT_PORTFOLIO_THEME";
    /** @deprecated Page removed from funnel */
    PageName["SelectTier"] = "SELECT_TIER";
    /** @deprecated The shipping address page was originally rolled out with multiple components combined in one. This has been replaced with ADDRESS_EDIT, ADDRESS_INVALID, ADDRESS_PREVIEW, and ADDRESS_SUGGESTION. */
    PageName["ShippingAddress"] = "SHIPPING_ADDRESS";
    PageName["Signup"] = "SIGNUP";
    PageName["Ssn"] = "SSN";
    PageName["SubscriptionActive"] = "SUBSCRIPTION_ACTIVE";
    PageName["Success"] = "SUCCESS";
    PageName["SuitabilityQuestions"] = "SUITABILITY_QUESTIONS";
})(PageName = exports.PageName || (exports.PageName = {}));
var PasswordResetErrors;
(function (PasswordResetErrors) {
    PasswordResetErrors["InvalidPasswordLength"] = "INVALID_PASSWORD_LENGTH";
    PasswordResetErrors["InvalidPasswordMissingLowerCase"] = "INVALID_PASSWORD_MISSING_LOWER_CASE";
    PasswordResetErrors["InvalidPasswordMissingNumber"] = "INVALID_PASSWORD_MISSING_NUMBER";
    PasswordResetErrors["InvalidPasswordMissingSpecialCharacter"] = "INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER";
    PasswordResetErrors["InvalidPasswordMissingUpperCase"] = "INVALID_PASSWORD_MISSING_UPPER_CASE";
    PasswordResetErrors["InvalidSsn"] = "INVALID_SSN";
    PasswordResetErrors["NewPasswordMatchesOldPassword"] = "NEW_PASSWORD_MATCHES_OLD_PASSWORD";
    PasswordResetErrors["PasswordsDoNotMatch"] = "PASSWORDS_DO_NOT_MATCH";
})(PasswordResetErrors = exports.PasswordResetErrors || (exports.PasswordResetErrors = {}));
var PastItemStatus;
(function (PastItemStatus) {
    PastItemStatus["Complete"] = "complete";
    PastItemStatus["Pending"] = "pending";
    PastItemStatus["Selling"] = "selling";
    PastItemStatus["Transferring"] = "transferring";
})(PastItemStatus = exports.PastItemStatus || (exports.PastItemStatus = {}));
var PinwheelLinkTokenRequiredJobs;
(function (PinwheelLinkTokenRequiredJobs) {
    PinwheelLinkTokenRequiredJobs["DirectDepositSwitch"] = "DirectDepositSwitch";
})(PinwheelLinkTokenRequiredJobs = exports.PinwheelLinkTokenRequiredJobs || (exports.PinwheelLinkTokenRequiredJobs = {}));
var Platform;
(function (Platform) {
    Platform["Android"] = "ANDROID";
    Platform["Ios"] = "IOS";
    Platform["Undefined"] = "UNDEFINED";
    Platform["Web"] = "WEB";
})(Platform = exports.Platform || (exports.Platform = {}));
var PortfolioCustomizationLevel;
(function (PortfolioCustomizationLevel) {
    /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
    PortfolioCustomizationLevel["Addon"] = "ADDON";
    /** Portfolio holdings and allocation percentages are fully configurable. */
    PortfolioCustomizationLevel["FullyConfigured"] = "FULLY_CONFIGURED";
    /** Portfolio holdings and allocation percentages are pre-set. */
    PortfolioCustomizationLevel["None"] = "NONE";
})(PortfolioCustomizationLevel = exports.PortfolioCustomizationLevel || (exports.PortfolioCustomizationLevel = {}));
var PortfolioRiskLevel;
(function (PortfolioRiskLevel) {
    PortfolioRiskLevel["Aggressive"] = "AGGRESSIVE";
    PortfolioRiskLevel["Conservative"] = "CONSERVATIVE";
    PortfolioRiskLevel["Custom"] = "CUSTOM";
    PortfolioRiskLevel["Moderate"] = "MODERATE";
    PortfolioRiskLevel["ModeratelyAggressive"] = "MODERATELY_AGGRESSIVE";
    PortfolioRiskLevel["ModeratelyConservative"] = "MODERATELY_CONSERVATIVE";
})(PortfolioRiskLevel = exports.PortfolioRiskLevel || (exports.PortfolioRiskLevel = {}));
var PortfolioTheme;
(function (PortfolioTheme) {
    PortfolioTheme["SelfDirected"] = "SELF_DIRECTED";
    PortfolioTheme["Standard"] = "STANDARD";
    PortfolioTheme["Sustainable"] = "SUSTAINABLE";
})(PortfolioTheme = exports.PortfolioTheme || (exports.PortfolioTheme = {}));
var PresentableWithdrawalStatus;
(function (PresentableWithdrawalStatus) {
    PresentableWithdrawalStatus["Canceled"] = "canceled";
    PresentableWithdrawalStatus["Complete"] = "complete";
    PresentableWithdrawalStatus["Failed"] = "failed";
    PresentableWithdrawalStatus["Pending"] = "pending";
    PresentableWithdrawalStatus["Refunded"] = "refunded";
    PresentableWithdrawalStatus["SellingInvestments"] = "sellingInvestments";
    PresentableWithdrawalStatus["Transferring"] = "transferring";
})(PresentableWithdrawalStatus = exports.PresentableWithdrawalStatus || (exports.PresentableWithdrawalStatus = {}));
var ProductAccountType;
(function (ProductAccountType) {
    ProductAccountType["Brokerage"] = "BROKERAGE";
    ProductAccountType["Checking"] = "CHECKING";
    ProductAccountType["Custodial"] = "CUSTODIAL";
    ProductAccountType["Retirement"] = "RETIREMENT";
    ProductAccountType["Savings"] = "SAVINGS";
})(ProductAccountType = exports.ProductAccountType || (exports.ProductAccountType = {}));
/** Ref for product name */
var ProductKey;
(function (ProductKey) {
    ProductKey["BenefitsGohenryStandard"] = "BENEFITS_GOHENRY_STANDARD";
    ProductKey["BenefitsInsuranceStandard"] = "BENEFITS_INSURANCE_STANDARD";
    ProductKey["BenefitsTaxfilingStandard"] = "BENEFITS_TAXFILING_STANDARD";
    ProductKey["BenefitsWillStandard"] = "BENEFITS_WILL_STANDARD";
    ProductKey["Early"] = "EARLY";
    ProductKey["EarlyMatch"] = "EARLY_MATCH";
    ProductKey["EarlyPublishing"] = "EARLY_PUBLISHING";
    ProductKey["EarlySelfDirectedInvest"] = "EARLY_SELF_DIRECTED_INVEST";
    ProductKey["Earn"] = "EARN";
    ProductKey["EarnChoice"] = "EARN_CHOICE";
    ProductKey["EarnPrime"] = "EARN_PRIME";
    ProductKey["EmergencyFund"] = "EMERGENCY_FUND";
    ProductKey["Invest"] = "INVEST";
    ProductKey["Later"] = "LATER";
    ProductKey["LaterMatch"] = "LATER_MATCH";
    ProductKey["Learn"] = "LEARN";
    ProductKey["LearnPremium"] = "LEARN_PREMIUM";
    ProductKey["MightyOakCard"] = "MIGHTY_OAK_CARD";
    ProductKey["MoneyManager"] = "MONEY_MANAGER";
    ProductKey["PremiumEducation"] = "PREMIUM_EDUCATION";
    ProductKey["SelfDirectedInvest"] = "SELF_DIRECTED_INVEST";
    ProductKey["Spend"] = "SPEND";
    ProductKey["StandardBenefitsInsurance"] = "STANDARD_BENEFITS_INSURANCE";
})(ProductKey = exports.ProductKey || (exports.ProductKey = {}));
var ProductSetupTipType;
(function (ProductSetupTipType) {
    /** Banking - setup digital wallet */
    ProductSetupTipType["BankingDigitalWallet"] = "banking_digital_wallet";
    /** Banking - setup direct deposit */
    ProductSetupTipType["BankingMightyOakCardDirectDeposit"] = "banking_mighty_oak_card_direct_deposit";
    /** home - try benefits hub */
    ProductSetupTipType["BenefitsHub"] = "benefits_hub";
    /** checking engagement wizard - activate card */
    ProductSetupTipType["CheckingEngagementWizardActivateCard"] = "checking_engagement_wizard_activate_card";
    /** checking engagement wizard - add to digital wallet */
    ProductSetupTipType["CheckingEngagementWizardDigitalWallet"] = "checking_engagement_wizard_digital_wallet";
    /** checking engagement wizard - direct deposit */
    ProductSetupTipType["CheckingEngagementWizardDirectDeposit"] = "checking_engagement_wizard_direct_deposit";
    /** checking engagement wizard - set up emergency fund */
    ProductSetupTipType["CheckingEngagementWizardEmergencyFund"] = "checking_engagement_wizard_emergency_fund";
    /** checking engagement wizard - go henry account connected */
    ProductSetupTipType["CheckingEngagementWizardGoHenry"] = "checking_engagement_wizard_go_henry";
    /** checking engagement wizard - pay bills */
    ProductSetupTipType["CheckingEngagementWizardPayBills"] = "checking_engagement_wizard_pay_bills";
    /** checking engagement wizard - set auto roundups */
    ProductSetupTipType["CheckingEngagementWizardSetAutoRoundups"] = "checking_engagement_wizard_set_auto_roundups";
    /** early - setup direct deposit */
    ProductSetupTipType["EarlyDirectDeposit"] = "early_direct_deposit";
    /** early - setup recurring transfers */
    ProductSetupTipType["EarlyRecurringTransfer"] = "early_recurring_transfer";
    /** early - try sustainable portfolio */
    ProductSetupTipType["EarlyTrySustainablePortfolio"] = "early_try_sustainable_portfolio";
    /** home - earn android extension */
    ProductSetupTipType["EarnAndroidExtension"] = "earn_android_extension";
    /** home - earn safari extension */
    ProductSetupTipType["EarnSafariExtension"] = "earn_safari_extension";
    /** home - harvest bank fees */
    ProductSetupTipType["HarvestBankFees"] = "harvest_bank_fees";
    /** home - link primary checking */
    ProductSetupTipType["HomeLinkPrimaryChecking"] = "home_link_primary_checking";
    /** home - link roundup cards */
    ProductSetupTipType["HomeLinkRoundupCards"] = "home_link_roundup_cards";
    /** home - set auto roundups */
    ProductSetupTipType["HomeSetAutoRoundups"] = "home_set_auto_roundups";
    /** home - try self-directed portfolio */
    ProductSetupTipType["HomeTrySelfDirectedPortfolio"] = "home_try_self_directed_portfolio";
    /** home - try sustainable portfolio */
    ProductSetupTipType["HomeTrySustainablePortfolio"] = "home_try_sustainable_portfolio";
    /** invest - add bitcoin to diversified portfolio */
    ProductSetupTipType["InvestAddBitcoin"] = "invest_add_bitcoin";
    /** invest hub - link primary checking */
    ProductSetupTipType["InvestHubLinkPrimaryChecking"] = "invest_hub_link_primary_checking";
    /** invest hub - link roundup cards */
    ProductSetupTipType["InvestHubLinkRoundupCards"] = "invest_hub_link_roundup_cards";
    /** invest hub - set auto roundups */
    ProductSetupTipType["InvestHubSetAutoRoundups"] = "invest_hub_set_auto_roundups";
    /** invest hub - try self-directed portfolio */
    ProductSetupTipType["InvestHubTrySelfDirectedPortfolio"] = "invest_hub_try_self_directed_portfolio";
    /** invest - link primary checking */
    ProductSetupTipType["InvestLinkPrimaryChecking"] = "invest_link_primary_checking";
    /** invest - link roundup cards */
    ProductSetupTipType["InvestLinkRoundupCards"] = "invest_link_roundup_cards";
    /** invest - make first investment */
    ProductSetupTipType["InvestMakeFirstInvestment"] = "invest_make_first_investment";
    /** invest - schedule regular deposits */
    ProductSetupTipType["InvestScheduleRegularDeposits"] = "invest_schedule_regular_deposits";
    /** invest - set auto roundups */
    ProductSetupTipType["InvestSetAutoRoundups"] = "invest_set_auto_roundups";
    /** invest - try self-directed portfolio */
    ProductSetupTipType["InvestTrySelfDirectedPortfolio"] = "invest_try_self_directed_portfolio";
    /** invest - try sustainable portfolio */
    ProductSetupTipType["InvestTrySustainablePortfolio"] = "invest_try_sustainable_portfolio";
    /** later - link primary checking */
    ProductSetupTipType["LaterLinkPrimaryChecking"] = "later_link_primary_checking";
    /** later - make first investment */
    ProductSetupTipType["LaterMakeFirstInvestment"] = "later_make_first_investment";
    /** later schedule regular deposits */
    ProductSetupTipType["LaterScheduleRegularDeposits"] = "later_schedule_regular_deposits";
    /** later - set a beneficiary */
    ProductSetupTipType["LaterSetABeneficiary"] = "later_set_a_beneficiary";
    /** later - try sustainable portfolio */
    ProductSetupTipType["LaterTrySustainablePortfolio"] = "later_try_sustainable_portfolio";
    /**
     * all contexts - nps survey
     * @deprecated deprecated tip no longer used on clients
     */
    ProductSetupTipType["NpsSurvey"] = "nps_survey";
    /** home - path to million promotion */
    ProductSetupTipType["PathToMillion"] = "path_to_million";
    /** all contexts - referral promotion */
    ProductSetupTipType["ReferralPromotion"] = "referral_promotion";
    /** spend - setup direct deposit */
    ProductSetupTipType["SpendDirectDeposit"] = "spend_direct_deposit";
    /** spend - incentive to setup direct deposit */
    ProductSetupTipType["SpendDirectDepositIncentive"] = "spend_direct_deposit_incentive";
    /** spend - setup recurring deposit */
    ProductSetupTipType["SpendRecurringDeposit"] = "spend_recurring_deposit";
    /** spend - set spend as primary */
    ProductSetupTipType["SpendSetAsPrimary"] = "spend_set_as_primary";
    /** spend - setup smart deposit */
    ProductSetupTipType["SpendSmartDeposit"] = "spend_smart_deposit";
    /** spend - smart deposit sweepstakes */
    ProductSetupTipType["SpendSmartDepositSweepstakes"] = "spend_smart_deposit_sweepstakes";
    /** home - wildfire chrome extension */
    ProductSetupTipType["WildfireChromeExtension"] = "wildfire_chrome_extension";
})(ProductSetupTipType = exports.ProductSetupTipType || (exports.ProductSetupTipType = {}));
var ProductType;
(function (ProductType) {
    ProductType["Core"] = "core";
    ProductType["Early"] = "early";
    ProductType["Later"] = "later";
    ProductType["Spend"] = "spend";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ProgramAccountType;
(function (ProgramAccountType) {
    ProgramAccountType["Plan"] = "PLAN";
})(ProgramAccountType = exports.ProgramAccountType || (exports.ProgramAccountType = {}));
var PromoCodeBusinessLine;
(function (PromoCodeBusinessLine) {
    PromoCodeBusinessLine["Affiliate"] = "AFFILIATE";
    PromoCodeBusinessLine["Brand"] = "BRAND";
    PromoCodeBusinessLine["Organic"] = "ORGANIC";
    PromoCodeBusinessLine["PaidMedia"] = "PAID_MEDIA";
})(PromoCodeBusinessLine = exports.PromoCodeBusinessLine || (exports.PromoCodeBusinessLine = {}));
var PromoCodeQualificationAction;
(function (PromoCodeQualificationAction) {
    PromoCodeQualificationAction["InitialInvestment"] = "INITIAL_INVESTMENT";
    PromoCodeQualificationAction["InitialRecurringInvestment"] = "INITIAL_RECURRING_INVESTMENT";
    PromoCodeQualificationAction["InitialRoundup"] = "INITIAL_ROUNDUP";
    PromoCodeQualificationAction["InitialSubscriptionPayment"] = "INITIAL_SUBSCRIPTION_PAYMENT";
})(PromoCodeQualificationAction = exports.PromoCodeQualificationAction || (exports.PromoCodeQualificationAction = {}));
var PromoCodeRewardType;
(function (PromoCodeRewardType) {
    PromoCodeRewardType["Investment"] = "INVESTMENT";
    PromoCodeRewardType["Other"] = "OTHER";
})(PromoCodeRewardType = exports.PromoCodeRewardType || (exports.PromoCodeRewardType = {}));
var PromoCodeStatus;
(function (PromoCodeStatus) {
    PromoCodeStatus["Published"] = "PUBLISHED";
    PromoCodeStatus["Unpublished"] = "UNPUBLISHED";
})(PromoCodeStatus = exports.PromoCodeStatus || (exports.PromoCodeStatus = {}));
var PromotionDurationPeriod;
(function (PromotionDurationPeriod) {
    PromotionDurationPeriod["Month"] = "MONTH";
})(PromotionDurationPeriod = exports.PromotionDurationPeriod || (exports.PromotionDurationPeriod = {}));
var ProspectType;
(function (ProspectType) {
    ProspectType["Grow"] = "GROW";
    ProspectType["LaterWaitlist"] = "LATER_WAITLIST";
    ProspectType["OutsideContribution"] = "OUTSIDE_CONTRIBUTION";
})(ProspectType = exports.ProspectType || (exports.ProspectType = {}));
/** Statuses after a campaign is published */
var PublishedCampaignStatus;
(function (PublishedCampaignStatus) {
    PublishedCampaignStatus["Complete"] = "COMPLETE";
    PublishedCampaignStatus["Live"] = "LIVE";
    PublishedCampaignStatus["Pending"] = "PENDING";
    PublishedCampaignStatus["Scheduled"] = "SCHEDULED";
})(PublishedCampaignStatus = exports.PublishedCampaignStatus || (exports.PublishedCampaignStatus = {}));
var RecurrenceFrequency;
(function (RecurrenceFrequency) {
    RecurrenceFrequency["Daily"] = "DAILY";
    RecurrenceFrequency["Monthly"] = "MONTHLY";
    RecurrenceFrequency["Weekly"] = "WEEKLY";
})(RecurrenceFrequency = exports.RecurrenceFrequency || (exports.RecurrenceFrequency = {}));
var RecurringTransferAccountType;
(function (RecurringTransferAccountType) {
    RecurringTransferAccountType["Spend"] = "SPEND";
})(RecurringTransferAccountType = exports.RecurringTransferAccountType || (exports.RecurringTransferAccountType = {}));
var RecurringTransferDirection;
(function (RecurringTransferDirection) {
    RecurringTransferDirection["Deposit"] = "DEPOSIT";
    RecurringTransferDirection["Withdrawal"] = "WITHDRAWAL";
})(RecurringTransferDirection = exports.RecurringTransferDirection || (exports.RecurringTransferDirection = {}));
var RecurringTransferFundingSourceType;
(function (RecurringTransferFundingSourceType) {
    RecurringTransferFundingSourceType["External"] = "EXTERNAL";
    RecurringTransferFundingSourceType["Internal"] = "INTERNAL";
})(RecurringTransferFundingSourceType = exports.RecurringTransferFundingSourceType || (exports.RecurringTransferFundingSourceType = {}));
var RecurringTransferPathExceptionCase;
(function (RecurringTransferPathExceptionCase) {
    RecurringTransferPathExceptionCase["Blank"] = "BLANK";
    RecurringTransferPathExceptionCase["InvalidValue"] = "INVALID_VALUE";
})(RecurringTransferPathExceptionCase = exports.RecurringTransferPathExceptionCase || (exports.RecurringTransferPathExceptionCase = {}));
var ReferralCampaignRewardTarget;
(function (ReferralCampaignRewardTarget) {
    ReferralCampaignRewardTarget["Advocate"] = "ADVOCATE";
    ReferralCampaignRewardTarget["Friend"] = "FRIEND";
})(ReferralCampaignRewardTarget = exports.ReferralCampaignRewardTarget || (exports.ReferralCampaignRewardTarget = {}));
var ReferralCampaignRewardType;
(function (ReferralCampaignRewardType) {
    ReferralCampaignRewardType["Investment"] = "INVESTMENT";
    ReferralCampaignRewardType["Other"] = "OTHER";
})(ReferralCampaignRewardType = exports.ReferralCampaignRewardType || (exports.ReferralCampaignRewardType = {}));
/** Status of referral events */
var ReferralEventStatus;
(function (ReferralEventStatus) {
    /** Friend has completed event */
    ReferralEventStatus["Completed"] = "COMPLETED";
    /** Friend has not started or completed event */
    ReferralEventStatus["NotStarted"] = "NOT_STARTED";
    /** Friend has initiated event but event has not fully processed */
    ReferralEventStatus["Pending"] = "PENDING";
})(ReferralEventStatus = exports.ReferralEventStatus || (exports.ReferralEventStatus = {}));
/** Descriptions of User actions needed to earn reward */
var ReferralEventType;
(function (ReferralEventType) {
    /** User has made a transfer into a Spend Account */
    ReferralEventType["DepositSpend"] = "DEPOSIT_SPEND";
    /** User has opened an Early account */
    ReferralEventType["EarlyAccountOpened"] = "EARLY_ACCOUNT_OPENED";
    /** User has a funding source linked */
    ReferralEventType["FsLinked"] = "FS_LINKED";
    /** User has made initial investment into core account */
    ReferralEventType["InvestCore"] = "INVEST_CORE";
    /** User has made initial investment into early account */
    ReferralEventType["InvestEarly"] = "INVEST_EARLY";
    /** User has made initial investment into later account */
    ReferralEventType["InvestLater"] = "INVEST_LATER";
    /** User has opened a Later account */
    ReferralEventType["LaterAccountOpened"] = "LATER_ACCOUNT_OPENED";
    /** User has signed the referral agreement */
    ReferralEventType["ReferralAgreementSigned"] = "REFERRAL_AGREEMENT_SIGNED";
    /** User has completed registration */
    ReferralEventType["RegistrationCompleted"] = "REGISTRATION_COMPLETED";
    /** User has initialized the registration process */
    ReferralEventType["SignedUp"] = "SIGNED_UP";
    /** User has opened a Spend account */
    ReferralEventType["SpendAccountOpened"] = "SPEND_ACCOUNT_OPENED";
    /** User has paid their subscription */
    ReferralEventType["SubscriptionPaid"] = "SUBSCRIPTION_PAID";
    /** Unknown referral event type */
    ReferralEventType["Unknown"] = "UNKNOWN";
    /** User has been verified */
    ReferralEventType["UserVerified"] = "USER_VERIFIED";
})(ReferralEventType = exports.ReferralEventType || (exports.ReferralEventType = {}));
/** Descriptions of Friend Events */
var ReferralEventTypeV2;
(function (ReferralEventTypeV2) {
    /** User has made initial investment */
    ReferralEventTypeV2["FirstHoldingsCreated"] = "FIRST_HOLDINGS_CREATED";
    /** User has completed registration */
    ReferralEventTypeV2["UserRegistrationCompleted"] = "USER_REGISTRATION_COMPLETED";
})(ReferralEventTypeV2 = exports.ReferralEventTypeV2 || (exports.ReferralEventTypeV2 = {}));
var ReferralPayoutStatus;
(function (ReferralPayoutStatus) {
    /** Only Advocate among multi-targets is rewarded */
    ReferralPayoutStatus["AdvocateOnlyRewarded"] = "ADVOCATE_ONLY_REWARDED";
    /** Payout has met the hurdle in the holdout period */
    ReferralPayoutStatus["Approved"] = "APPROVED";
    /** Payout have been Cancelled or Paid outside the Automated system */
    ReferralPayoutStatus["Cancelled"] = "CANCELLED";
    /** Payout has been disqualified due to validation check fails */
    ReferralPayoutStatus["Disqualified"] = "DISQUALIFIED";
    /** Payout have expired as the eligibility end date passed for disqualified payout */
    ReferralPayoutStatus["Expired"] = "EXPIRED";
    /** Only Friend among multi-targets is rewarded */
    ReferralPayoutStatus["FriendOnlyRewarded"] = "FRIEND_ONLY_REWARDED";
    /** Payout have been sent for fulfillment */
    ReferralPayoutStatus["Fulfilled"] = "FULFILLED";
    /** Payout started the process for fulfillment */
    ReferralPayoutStatus["Fulfilling"] = "FULFILLING";
    /** Payout has been created, but hurdle not met yet */
    ReferralPayoutStatus["Pending"] = "PENDING";
    /** Payout has been rejected manually (not used) */
    ReferralPayoutStatus["Rejected"] = "REJECTED";
    /** All target rewarded are invested */
    ReferralPayoutStatus["Rewarded"] = "REWARDED";
    /** All target rewards failed to be invested */
    ReferralPayoutStatus["RewardFailed"] = "REWARD_FAILED";
})(ReferralPayoutStatus = exports.ReferralPayoutStatus || (exports.ReferralPayoutStatus = {}));
/** Status of referral relationship */
var ReferralRelationshipStatus;
(function (ReferralRelationshipStatus) {
    /** Relationship has been created */
    ReferralRelationshipStatus["Created"] = "CREATED";
    /** Relationship is eligible for payout */
    ReferralRelationshipStatus["Eligible"] = "ELIGIBLE";
    /** Relationship payout has been fulfilled */
    ReferralRelationshipStatus["Fulfilled"] = "FULFILLED";
    /** Relationship is ineligible for payout */
    ReferralRelationshipStatus["Ineligible"] = "INELIGIBLE";
    /** Friend has completed first inevestment */
    ReferralRelationshipStatus["Invested"] = "INVESTED";
    /** Friend has completed registration */
    ReferralRelationshipStatus["Registered"] = "REGISTERED";
    /** Friend should reinvest since old investement do not qualify */
    ReferralRelationshipStatus["ReinvestNeeded"] = "REINVEST_NEEDED";
    /** Friend was rewarded */
    ReferralRelationshipStatus["Rewarded"] = "REWARDED";
    /** Friend reward investment failed - Advocate might have still been rewarded */
    ReferralRelationshipStatus["RewardFailed"] = "REWARD_FAILED";
})(ReferralRelationshipStatus = exports.ReferralRelationshipStatus || (exports.ReferralRelationshipStatus = {}));
/** The current status of a referral reward */
var ReferralRewardStatus;
(function (ReferralRewardStatus) {
    /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
    ReferralRewardStatus["Earned"] = "EARNED";
    /** Reward has been issued by Acorns */
    ReferralRewardStatus["Fulfilled"] = "FULFILLED";
    /** Reward has not been created */
    ReferralRewardStatus["NotCreated"] = "NOT_CREATED";
})(ReferralRewardStatus = exports.ReferralRewardStatus || (exports.ReferralRewardStatus = {}));
var ReferralRewardUpdateStatus;
(function (ReferralRewardUpdateStatus) {
    /** Referral has been cancelled */
    ReferralRewardUpdateStatus["Cancelled"] = "CANCELLED";
    /** User and Friend have been rewarded */
    ReferralRewardUpdateStatus["Rewarded"] = "REWARDED";
})(ReferralRewardUpdateStatus = exports.ReferralRewardUpdateStatus || (exports.ReferralRewardUpdateStatus = {}));
var ReferralStatus;
(function (ReferralStatus) {
    /** Referral has been cancelled */
    ReferralStatus["Cancelled"] = "CANCELLED";
    /** User and Friend have completed referral and should be rewarded */
    ReferralStatus["Completed"] = "COMPLETED";
    /** Referral has expired because events were not finished before campaign end date */
    ReferralStatus["Expired"] = "EXPIRED";
    /** Friend has used referral code but still has events they need to complete */
    ReferralStatus["Pending"] = "PENDING";
    /** User and Friend have been rewarded */
    ReferralStatus["Rewarded"] = "REWARDED";
    /** Referral has been sent to a friend */
    ReferralStatus["Sent"] = "SENT";
})(ReferralStatus = exports.ReferralStatus || (exports.ReferralStatus = {}));
/** Value types of reward associated with completion of a referral */
var ReferralValueType;
(function (ReferralValueType) {
    ReferralValueType["Usd"] = "USD";
})(ReferralValueType = exports.ReferralValueType || (exports.ReferralValueType = {}));
/** The reason why the reinvestment was created */
var ReinvestmentReason;
(function (ReinvestmentReason) {
    /** Reinvestment was created due to a debit overselling than what was requested */
    ReinvestmentReason["Oversell"] = "OVERSELL";
})(ReinvestmentReason = exports.ReinvestmentReason || (exports.ReinvestmentReason = {}));
var ReissueBankCardIneligibleIssue;
(function (ReissueBankCardIneligibleIssue) {
    ReissueBankCardIneligibleIssue["ActiveBankCardRequest"] = "ACTIVE_BANK_CARD_REQUEST";
    ReissueBankCardIneligibleIssue["CardAdminLocked"] = "CARD_ADMIN_LOCKED";
    ReissueBankCardIneligibleIssue["FirstCardNotIssuedYet"] = "FIRST_CARD_NOT_ISSUED_YET";
})(ReissueBankCardIneligibleIssue = exports.ReissueBankCardIneligibleIssue || (exports.ReissueBankCardIneligibleIssue = {}));
var RejectedReason;
(function (RejectedReason) {
    RejectedReason["DocumentExpired"] = "documentExpired";
    RejectedReason["IncorrectDocumentType"] = "incorrectDocumentType";
    RejectedReason["IncorrectName"] = "incorrectName";
    RejectedReason["InvalidResidentialAddress"] = "invalidResidentialAddress";
    RejectedReason["MismatchedName"] = "mismatchedName";
    RejectedReason["MissingName"] = "missingName";
    RejectedReason["NoVisibleDate"] = "noVisibleDate";
    RejectedReason["NotEligibleForPromotion"] = "notEligibleForPromotion";
    RejectedReason["PoorImageQuality"] = "poorImageQuality";
    RejectedReason["SsnAlreadyUsed"] = "ssnAlreadyUsed";
})(RejectedReason = exports.RejectedReason || (exports.RejectedReason = {}));
var RequestVersions;
(function (RequestVersions) {
    RequestVersions["September_2022"] = "SEPTEMBER_2022";
})(RequestVersions = exports.RequestVersions || (exports.RequestVersions = {}));
var RetirementPlanAccess;
(function (RetirementPlanAccess) {
    /** Married user and spouse have access to a retirement plan */
    RetirementPlanAccess["Both"] = "both";
    /** Neither married user nor spouse have access to a retirement plan */
    RetirementPlanAccess["Neither"] = "neither";
    /** Single user has no access to retirement plan */
    RetirementPlanAccess["No"] = "no";
    /** Married user has access to a retirement plan without spouse */
    RetirementPlanAccess["OnlyMe"] = "onlyMe";
    /** Married user does not have access to a retirement plan, but spouse does */
    RetirementPlanAccess["Spouse"] = "spouse";
    /** Single user has access to an employer's retirement plan */
    RetirementPlanAccess["Yes"] = "yes";
})(RetirementPlanAccess = exports.RetirementPlanAccess || (exports.RetirementPlanAccess = {}));
var RevenueScheduleType;
(function (RevenueScheduleType) {
    RevenueScheduleType["AtInvoice"] = "at_invoice";
    RevenueScheduleType["AtRangeEnd"] = "at_range_end";
    RevenueScheduleType["AtRangeStart"] = "at_range_start";
    RevenueScheduleType["Evenly"] = "evenly";
    RevenueScheduleType["Never"] = "never";
})(RevenueScheduleType = exports.RevenueScheduleType || (exports.RevenueScheduleType = {}));
var RevokeAccessReasons;
(function (RevokeAccessReasons) {
    RevokeAccessReasons["CoreAccountReview"] = "CORE_ACCOUNT_REVIEW";
    RevokeAccessReasons["CoreBrokerDealerAssociation"] = "CORE_BROKER_DEALER_ASSOCIATION";
    RevokeAccessReasons["CoreCastleLock"] = "CORE_CASTLE_LOCK";
    RevokeAccessReasons["CoreChargeback"] = "CORE_CHARGEBACK";
    RevokeAccessReasons["CoreCollection"] = "CORE_COLLECTION";
    RevokeAccessReasons["CoreDisputedTransaction"] = "CORE_DISPUTED_TRANSACTION";
    RevokeAccessReasons["CoreLeinLevyLock"] = "CORE_LEIN_LEVY_LOCK";
    RevokeAccessReasons["CorePendingApprovalApplicationWithdrawn"] = "CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN";
    RevokeAccessReasons["CorePotentialAccountTakeover"] = "CORE_POTENTIAL_ACCOUNT_TAKEOVER";
    RevokeAccessReasons["CoreSuspiciousInvestmentActivity"] = "CORE_SUSPICIOUS_INVESTMENT_ACTIVITY";
    RevokeAccessReasons["CoreW9Required"] = "CORE_W9_REQUIRED";
    RevokeAccessReasons["Deceased"] = "DECEASED";
    RevokeAccessReasons["DelayedRiskWithdrawals"] = "DELAYED_RISK_WITHDRAWALS";
    RevokeAccessReasons["DuplicateAccount"] = "DUPLICATE_ACCOUNT";
    RevokeAccessReasons["EarlyTransferInProgress"] = "EARLY_TRANSFER_IN_PROGRESS";
    RevokeAccessReasons["Fraud"] = "FRAUD";
    RevokeAccessReasons["LaterRolloverInProgress"] = "LATER_ROLLOVER_IN_PROGRESS";
    RevokeAccessReasons["OtherNotListed"] = "OTHER_NOT_LISTED";
    RevokeAccessReasons["PlaidMismatch"] = "PLAID_MISMATCH";
    RevokeAccessReasons["ProfitStarsDispute"] = "PROFIT_STARS_DISPUTE";
    RevokeAccessReasons["ReferralPromotionFraud"] = "REFERRAL_PROMOTION_FRAUD";
    RevokeAccessReasons["SpendDisputedIncomingTransferR10"] = "SPEND_DISPUTED_INCOMING_TRANSFER_R10";
    RevokeAccessReasons["SpendGeneralSuspension"] = "SPEND_GENERAL_SUSPENSION";
    RevokeAccessReasons["SpendReturnedTransfer"] = "SPEND_RETURNED_TRANSFER";
    RevokeAccessReasons["SpendSuspiciousTransferActivity"] = "SPEND_SUSPICIOUS_TRANSFER_ACTIVITY";
    RevokeAccessReasons["SuspiciousMrdcContactSpendRisk"] = "SUSPICIOUS_MRDC_CONTACT_SPEND_RISK";
    RevokeAccessReasons["SuspiciousMrdcPendingClosure"] = "SUSPICIOUS_MRDC_PENDING_CLOSURE";
    RevokeAccessReasons["ThreeWayCallRequired"] = "THREE_WAY_CALL_REQUIRED";
    RevokeAccessReasons["Underage"] = "UNDERAGE";
    RevokeAccessReasons["UnsupportedCustomer"] = "UNSUPPORTED_CUSTOMER";
})(RevokeAccessReasons = exports.RevokeAccessReasons || (exports.RevokeAccessReasons = {}));
var RiskStatus;
(function (RiskStatus) {
    RiskStatus["Confirmable"] = "confirmable";
    RiskStatus["Fixable"] = "fixable";
    RiskStatus["HardReject"] = "hard_reject";
})(RiskStatus = exports.RiskStatus || (exports.RiskStatus = {}));
var RoundUpState;
(function (RoundUpState) {
    /**
     * Round ups that will be invested automatically
     * @deprecated Use waiting state instead
     */
    RoundUpState["AutoInvestable"] = "autoInvestable";
    /** Round ups that were canceled, either before or after an investment was created */
    RoundUpState["Canceled"] = "canceled";
    /** Round ups associated with an investment */
    RoundUpState["Invested"] = "invested";
    /** Round ups that have yet to be invested */
    RoundUpState["Pending"] = "pending";
    /** Round ups that requested to be invested but have not been transferred */
    RoundUpState["RoundedUp"] = "roundedUp";
    /** Round ups which are ready to be invested */
    RoundUpState["Waiting"] = "waiting";
})(RoundUpState = exports.RoundUpState || (exports.RoundUpState = {}));
var RoundUpType;
(function (RoundUpType) {
    RoundUpType["Auto"] = "auto";
    RoundUpType["RealTime"] = "realTime";
})(RoundUpType = exports.RoundUpType || (exports.RoundUpType = {}));
var SsnStorageResult;
(function (SsnStorageResult) {
    SsnStorageResult["Exists"] = "EXISTS";
    SsnStorageResult["Invalid"] = "INVALID";
    SsnStorageResult["Success"] = "SUCCESS";
})(SsnStorageResult = exports.SsnStorageResult || (exports.SsnStorageResult = {}));
var SalaryInterval;
(function (SalaryInterval) {
    SalaryInterval["Hour"] = "HOUR";
    SalaryInterval["Month"] = "MONTH";
    SalaryInterval["Week"] = "WEEK";
    SalaryInterval["Year"] = "YEAR";
})(SalaryInterval = exports.SalaryInterval || (exports.SalaryInterval = {}));
var SavingsAccountEligibilityRequirement;
(function (SavingsAccountEligibilityRequirement) {
    SavingsAccountEligibilityRequirement["NeedsCheckingAccount"] = "NEEDS_CHECKING_ACCOUNT";
    SavingsAccountEligibilityRequirement["NeedsDirectDeposit"] = "NEEDS_DIRECT_DEPOSIT";
    SavingsAccountEligibilityRequirement["NeedsOtherBankingPartner"] = "NEEDS_OTHER_BANKING_PARTNER";
})(SavingsAccountEligibilityRequirement = exports.SavingsAccountEligibilityRequirement || (exports.SavingsAccountEligibilityRequirement = {}));
var SavingsAccountType;
(function (SavingsAccountType) {
    SavingsAccountType["EmergencySavings"] = "EMERGENCY_SAVINGS";
})(SavingsAccountType = exports.SavingsAccountType || (exports.SavingsAccountType = {}));
var ScheduleType;
(function (ScheduleType) {
    ScheduleType["Chat"] = "chat";
    ScheduleType["Email"] = "email";
    ScheduleType["Phone"] = "phone";
})(ScheduleType = exports.ScheduleType || (exports.ScheduleType = {}));
var SearchSecuritiesOrderBy;
(function (SearchSecuritiesOrderBy) {
    /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
    SearchSecuritiesOrderBy["BestMatch"] = "BEST_MATCH";
    /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
    SearchSecuritiesOrderBy["MarketCap"] = "MARKET_CAP";
    /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by share price (open_price) in descending order */
    SearchSecuritiesOrderBy["SharePrice"] = "SHARE_PRICE";
})(SearchSecuritiesOrderBy = exports.SearchSecuritiesOrderBy || (exports.SearchSecuritiesOrderBy = {}));
var SearchTermCategory;
(function (SearchTermCategory) {
    SearchTermCategory["BenefitsHub"] = "BENEFITS_HUB";
    SearchTermCategory["Default"] = "DEFAULT";
    SearchTermCategory["ReferralsLander"] = "REFERRALS_LANDER";
})(SearchTermCategory = exports.SearchTermCategory || (exports.SearchTermCategory = {}));
var SecuritiesBySectorOrderBy;
(function (SecuritiesBySectorOrderBy) {
    /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
    SecuritiesBySectorOrderBy["MarketCap"] = "MARKET_CAP";
    /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
    SecuritiesBySectorOrderBy["SharePrice"] = "SHARE_PRICE";
})(SecuritiesBySectorOrderBy = exports.SecuritiesBySectorOrderBy || (exports.SecuritiesBySectorOrderBy = {}));
var SecurityType;
(function (SecurityType) {
    SecurityType["Bond"] = "BOND";
    SecurityType["Etf"] = "ETF";
    SecurityType["Stock"] = "STOCK";
})(SecurityType = exports.SecurityType || (exports.SecurityType = {}));
var SelfDirectedPortfolioStatus;
(function (SelfDirectedPortfolioStatus) {
    /** Self Directed Portfolio has been removed */
    SelfDirectedPortfolioStatus["Closed"] = "CLOSED";
    /** Self Directed Portfolio is open */
    SelfDirectedPortfolioStatus["Open"] = "OPEN";
    /** Self Directed Portfolio has started the closure process */
    SelfDirectedPortfolioStatus["PendingClosure"] = "PENDING_CLOSURE";
})(SelfDirectedPortfolioStatus = exports.SelfDirectedPortfolioStatus || (exports.SelfDirectedPortfolioStatus = {}));
var SessionType;
(function (SessionType) {
    SessionType["Behavioral"] = "BEHAVIORAL";
    SessionType["Default"] = "DEFAULT";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var SignatureType;
(function (SignatureType) {
    /** A signature used for a user's bank fee negotiation */
    SignatureType["BankFeeNegotiation"] = "bankFeeNegotiation";
    /** A signature for the user investment certificate */
    SignatureType["Certificate"] = "certificate";
    /** A signature used for the user spend debit card */
    SignatureType["DebitCard"] = "debitCard";
    /** A signature used for the user direct deposit PDF form */
    SignatureType["DirectDeposit"] = "directDeposit";
    /** A signature used for a user's utility bill negotiation */
    SignatureType["UtilityBillNegotiation"] = "utilityBillNegotiation";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
var SpendAccountStatus;
(function (SpendAccountStatus) {
    SpendAccountStatus["Closed"] = "CLOSED";
    SpendAccountStatus["Locked"] = "LOCKED";
    SpendAccountStatus["NotOpened"] = "NOT_OPENED";
    SpendAccountStatus["Open"] = "OPEN";
    SpendAccountStatus["Opening"] = "OPENING";
    SpendAccountStatus["Reopening"] = "REOPENING";
})(SpendAccountStatus = exports.SpendAccountStatus || (exports.SpendAccountStatus = {}));
var SplitDepositNormalizationFrequency;
(function (SplitDepositNormalizationFrequency) {
    SplitDepositNormalizationFrequency["Daily"] = "DAILY";
    SplitDepositNormalizationFrequency["Monthly"] = "MONTHLY";
    SplitDepositNormalizationFrequency["Weekly"] = "WEEKLY";
    SplitDepositNormalizationFrequency["Yearly"] = "YEARLY";
})(SplitDepositNormalizationFrequency = exports.SplitDepositNormalizationFrequency || (exports.SplitDepositNormalizationFrequency = {}));
var SplitDepositRecurrenceFrequency;
(function (SplitDepositRecurrenceFrequency) {
    SplitDepositRecurrenceFrequency["Daily"] = "DAILY";
    SplitDepositRecurrenceFrequency["Monthly"] = "MONTHLY";
    SplitDepositRecurrenceFrequency["Weekly"] = "WEEKLY";
})(SplitDepositRecurrenceFrequency = exports.SplitDepositRecurrenceFrequency || (exports.SplitDepositRecurrenceFrequency = {}));
var SplitDepositSettingType;
(function (SplitDepositSettingType) {
    SplitDepositSettingType["DirectDeposit"] = "DIRECT_DEPOSIT";
    SplitDepositSettingType["DirectDepositIntent"] = "DIRECT_DEPOSIT_INTENT";
    SplitDepositSettingType["Recurrence"] = "RECURRENCE";
})(SplitDepositSettingType = exports.SplitDepositSettingType || (exports.SplitDepositSettingType = {}));
var SplitDepositTargetAccountType;
(function (SplitDepositTargetAccountType) {
    SplitDepositTargetAccountType["Early"] = "EARLY";
    SplitDepositTargetAccountType["Invest"] = "INVEST";
    SplitDepositTargetAccountType["Later"] = "LATER";
    SplitDepositTargetAccountType["Save"] = "SAVE";
    SplitDepositTargetAccountType["Spend"] = "SPEND";
})(SplitDepositTargetAccountType = exports.SplitDepositTargetAccountType || (exports.SplitDepositTargetAccountType = {}));
var StateCode;
(function (StateCode) {
    StateCode["Ak"] = "AK";
    StateCode["Al"] = "AL";
    StateCode["Ar"] = "AR";
    StateCode["As"] = "AS";
    StateCode["Az"] = "AZ";
    StateCode["Ca"] = "CA";
    StateCode["Co"] = "CO";
    StateCode["Ct"] = "CT";
    StateCode["Dc"] = "DC";
    StateCode["De"] = "DE";
    StateCode["Fl"] = "FL";
    StateCode["Fm"] = "FM";
    StateCode["Ga"] = "GA";
    StateCode["Gu"] = "GU";
    StateCode["Hi"] = "HI";
    StateCode["Ia"] = "IA";
    StateCode["Id"] = "ID";
    StateCode["Il"] = "IL";
    StateCode["In"] = "IN";
    StateCode["Ks"] = "KS";
    StateCode["Ky"] = "KY";
    StateCode["La"] = "LA";
    StateCode["Ma"] = "MA";
    StateCode["Md"] = "MD";
    StateCode["Me"] = "ME";
    StateCode["Mh"] = "MH";
    StateCode["Mi"] = "MI";
    StateCode["Mn"] = "MN";
    StateCode["Mo"] = "MO";
    StateCode["Mp"] = "MP";
    StateCode["Ms"] = "MS";
    StateCode["Mt"] = "MT";
    StateCode["Nc"] = "NC";
    StateCode["Nd"] = "ND";
    StateCode["Ne"] = "NE";
    StateCode["Nh"] = "NH";
    StateCode["Nj"] = "NJ";
    StateCode["Nm"] = "NM";
    StateCode["Nv"] = "NV";
    StateCode["Ny"] = "NY";
    StateCode["Oh"] = "OH";
    StateCode["Ok"] = "OK";
    StateCode["Or"] = "OR";
    StateCode["Pa"] = "PA";
    StateCode["Pr"] = "PR";
    StateCode["Pw"] = "PW";
    StateCode["Ri"] = "RI";
    StateCode["Sc"] = "SC";
    StateCode["Sd"] = "SD";
    StateCode["Tn"] = "TN";
    StateCode["Tx"] = "TX";
    StateCode["Ut"] = "UT";
    StateCode["Va"] = "VA";
    StateCode["Vi"] = "VI";
    StateCode["Vt"] = "VT";
    StateCode["Wa"] = "WA";
    StateCode["Wi"] = "WI";
    StateCode["Wv"] = "WV";
    StateCode["Wy"] = "WY";
})(StateCode = exports.StateCode || (exports.StateCode = {}));
var StatementPortfolioType;
(function (StatementPortfolioType) {
    StatementPortfolioType["Customized"] = "CUSTOMIZED";
    StatementPortfolioType["Managed"] = "MANAGED";
    StatementPortfolioType["SelfDirected"] = "SELF_DIRECTED";
})(StatementPortfolioType = exports.StatementPortfolioType || (exports.StatementPortfolioType = {}));
var StatementType;
(function (StatementType) {
    /** user trade or chargeback confirmation */
    StatementType["DailyUserTradeConfirmation"] = "daily_user_trade_confirmation";
    /** tax statements */
    StatementType["Tax"] = "tax";
    /** monthly statements */
    StatementType["User"] = "user";
})(StatementType = exports.StatementType || (exports.StatementType = {}));
var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["Collect"] = "COLLECT";
    SubmissionStatus["Completed"] = "COMPLETED";
    SubmissionStatus["ConnectionError"] = "CONNECTION_ERROR";
    SubmissionStatus["DelayCharge"] = "DELAY_CHARGE";
    SubmissionStatus["MailInError"] = "MAIL_IN_ERROR";
    SubmissionStatus["MailInEscalated"] = "MAIL_IN_ESCALATED";
    SubmissionStatus["MailInPending"] = "MAIL_IN_PENDING";
    SubmissionStatus["MailInSent"] = "MAIL_IN_SENT";
    SubmissionStatus["Pending"] = "PENDING";
})(SubmissionStatus = exports.SubmissionStatus || (exports.SubmissionStatus = {}));
var SubscriptionMigrationWaiverReason;
(function (SubscriptionMigrationWaiverReason) {
    SubscriptionMigrationWaiverReason["FinancialHardship"] = "FINANCIAL_HARDSHIP";
})(SubscriptionMigrationWaiverReason = exports.SubscriptionMigrationWaiverReason || (exports.SubscriptionMigrationWaiverReason = {}));
var SubscriptionPaymentMethod;
(function (SubscriptionPaymentMethod) {
    SubscriptionPaymentMethod["Ach"] = "ach";
    SubscriptionPaymentMethod["Amazon"] = "amazon";
    SubscriptionPaymentMethod["ApplePay"] = "apple_pay";
    SubscriptionPaymentMethod["Bachs"] = "bachs";
    SubscriptionPaymentMethod["Check"] = "check";
    SubscriptionPaymentMethod["CreditCard"] = "credit_card";
    SubscriptionPaymentMethod["Eft"] = "eft";
    SubscriptionPaymentMethod["GooglePay"] = "google_pay";
    SubscriptionPaymentMethod["MoneyOrder"] = "money_order";
    SubscriptionPaymentMethod["Other"] = "other";
    SubscriptionPaymentMethod["Paypal"] = "paypal";
    SubscriptionPaymentMethod["Roku"] = "roku";
    SubscriptionPaymentMethod["Sepadirectdebit"] = "sepadirectdebit";
    SubscriptionPaymentMethod["WireTransfer"] = "wire_transfer";
})(SubscriptionPaymentMethod = exports.SubscriptionPaymentMethod || (exports.SubscriptionPaymentMethod = {}));
/** transition actions for a subscription */
var SubscriptionTransitionAction;
(function (SubscriptionTransitionAction) {
    SubscriptionTransitionAction["AddPromotion"] = "ADD_PROMOTION";
    SubscriptionTransitionAction["Deactivate"] = "DEACTIVATE";
    SubscriptionTransitionAction["Downgrade"] = "DOWNGRADE";
    SubscriptionTransitionAction["Upgrade"] = "UPGRADE";
})(SubscriptionTransitionAction = exports.SubscriptionTransitionAction || (exports.SubscriptionTransitionAction = {}));
var SuitabilityAccountSubtype;
(function (SuitabilityAccountSubtype) {
    SuitabilityAccountSubtype["Individual"] = "INDIVIDUAL";
    SuitabilityAccountSubtype["RothIra"] = "ROTH_IRA";
    SuitabilityAccountSubtype["SepIra"] = "SEP_IRA";
    SuitabilityAccountSubtype["TraditionalIra"] = "TRADITIONAL_IRA";
})(SuitabilityAccountSubtype = exports.SuitabilityAccountSubtype || (exports.SuitabilityAccountSubtype = {}));
var SuitabilityAccountType;
(function (SuitabilityAccountType) {
    SuitabilityAccountType["Brokerage"] = "BROKERAGE";
    SuitabilityAccountType["Retirement"] = "RETIREMENT";
})(SuitabilityAccountType = exports.SuitabilityAccountType || (exports.SuitabilityAccountType = {}));
var SwitchMethod;
(function (SwitchMethod) {
    /** Used clickswitch */
    SwitchMethod["Clickswitch"] = "clickswitch";
    /** Used clickswitch and online */
    SwitchMethod["ClickswitchOnline"] = "clickswitchOnline";
    /** Used clickswitch, online, and PDF */
    SwitchMethod["ClickswitchOnlinePdf"] = "clickswitchOnlinePdf";
    /** Used clickswitch and PDF */
    SwitchMethod["ClickswitchPdf"] = "clickswitchPdf";
    /** None */
    SwitchMethod["None"] = "none";
    /** Used online */
    SwitchMethod["Online"] = "online";
    /** Used online and PDF */
    SwitchMethod["OnlinePdf"] = "onlinePdf";
    /** Used pdf */
    SwitchMethod["Pdf"] = "pdf";
    /** Unknown */
    SwitchMethod["Unknown"] = "unknown";
})(SwitchMethod = exports.SwitchMethod || (exports.SwitchMethod = {}));
var SwitchSource;
(function (SwitchSource) {
    SwitchSource["Acorns"] = "acorns";
    SwitchSource["ClickSwitch"] = "clickSwitch";
})(SwitchSource = exports.SwitchSource || (exports.SwitchSource = {}));
var SwitchState;
(function (SwitchState) {
    /** Attempted to setup direct deposit */
    SwitchState["Attempted"] = "attempted";
    /** User has not interacted with direct deposit in Acorns */
    SwitchState["NoInteraction"] = "noInteraction";
    /** Completed direct deposit setup */
    SwitchState["Switched"] = "switched";
    /** Viewed PDF screen or went to Online Portal */
    SwitchState["Viewed"] = "viewed";
})(SwitchState = exports.SwitchState || (exports.SwitchState = {}));
var SwitchStatus;
(function (SwitchStatus) {
    /** Deposit confirmed in Spend account */
    SwitchStatus["Completed"] = "completed";
    /** New for processing */
    SwitchStatus["New"] = "new";
    /** PDF downloaded */
    SwitchStatus["PdfDownloaded"] = "pdfDownloaded";
    /** PDF generated */
    SwitchStatus["PdfGenerated"] = "pdfGenerated";
    /** Ready for processing */
    SwitchStatus["Ready"] = "ready";
    /** Sent to ClickSwitch */
    SwitchStatus["Submitted"] = "submitted";
})(SwitchStatus = exports.SwitchStatus || (exports.SwitchStatus = {}));
var SwitchType;
(function (SwitchType) {
    /** Online */
    SwitchType["Online"] = "online";
    /** Default PDF */
    SwitchType["Pdf"] = "pdf";
    /** Submittable Generic */
    SwitchType["Submittable"] = "submittable";
    /** Submittable Custom */
    SwitchType["SubmittableCustom"] = "submittableCustom";
})(SwitchType = exports.SwitchType || (exports.SwitchType = {}));
var TaxApplicationStatus;
(function (TaxApplicationStatus) {
    TaxApplicationStatus["Cancelled"] = "CANCELLED";
    TaxApplicationStatus["NotStarted"] = "NOT_STARTED";
    TaxApplicationStatus["QuestionnaireCompleted"] = "QUESTIONNAIRE_COMPLETED";
    TaxApplicationStatus["QuestionnaireInProgress"] = "QUESTIONNAIRE_IN_PROGRESS";
    TaxApplicationStatus["ReadyToSubmit"] = "READY_TO_SUBMIT";
    TaxApplicationStatus["Submitted"] = "SUBMITTED";
})(TaxApplicationStatus = exports.TaxApplicationStatus || (exports.TaxApplicationStatus = {}));
var TaxFormType;
(function (TaxFormType) {
    TaxFormType["Form1099"] = "form1099";
    TaxFormType["Form1099Bdiv"] = "form1099BDIV";
    TaxFormType["Form1099Misc"] = "form1099MISC";
    TaxFormType["Form1099R"] = "form1099R";
    TaxFormType["Form1099R1"] = "form1099R1";
    TaxFormType["Form1099R2"] = "form1099R2";
    TaxFormType["Form1099R4"] = "form1099R4";
    TaxFormType["Form1099R7"] = "form1099R7";
    TaxFormType["Form1099R8"] = "form1099R8";
    TaxFormType["Form1099Re"] = "form1099RE";
    TaxFormType["Form1099Rj"] = "form1099RJ";
    TaxFormType["Form1099Rq"] = "form1099RQ";
    TaxFormType["Form1099Rt"] = "form1099RT";
    TaxFormType["Form5498"] = "form5498";
    TaxFormType["Other"] = "other";
})(TaxFormType = exports.TaxFormType || (exports.TaxFormType = {}));
var TaxReturnStatus;
(function (TaxReturnStatus) {
    TaxReturnStatus["Accepted"] = "ACCEPTED";
    TaxReturnStatus["AcceptedLegacy"] = "ACCEPTED_LEGACY";
    TaxReturnStatus["FiledPendingResponse"] = "FILED_PENDING_RESPONSE";
    TaxReturnStatus["NotFiled"] = "NOT_FILED";
    TaxReturnStatus["NotSubmitted"] = "NOT_SUBMITTED";
    TaxReturnStatus["Rejected"] = "REJECTED";
    TaxReturnStatus["Retryable"] = "RETRYABLE";
    TaxReturnStatus["Submitted"] = "SUBMITTED";
})(TaxReturnStatus = exports.TaxReturnStatus || (exports.TaxReturnStatus = {}));
var TfaNotification;
(function (TfaNotification) {
    TfaNotification["PushNotification"] = "PUSH_NOTIFICATION";
})(TfaNotification = exports.TfaNotification || (exports.TfaNotification = {}));
var TfaStatus;
(function (TfaStatus) {
    TfaStatus["Authorized"] = "AUTHORIZED";
    TfaStatus["Failed"] = "FAILED";
    TfaStatus["Pending"] = "PENDING";
    TfaStatus["Required"] = "REQUIRED";
})(TfaStatus = exports.TfaStatus || (exports.TfaStatus = {}));
var TfaType;
(function (TfaType) {
    TfaType["Email"] = "EMAIL";
    TfaType["Notification"] = "NOTIFICATION";
    TfaType["Pending"] = "PENDING";
    TfaType["Phone"] = "PHONE";
    TfaType["Question"] = "QUESTION";
})(TfaType = exports.TfaType || (exports.TfaType = {}));
/** Actions that must be taken to complete a downgrade workflow */
var TierDowngradeActionKey;
(function (TierDowngradeActionKey) {
    TierDowngradeActionKey["CloseEarlyAccount"] = "CLOSE_EARLY_ACCOUNT";
    TierDowngradeActionKey["CloseEmergencyFundAccount"] = "CLOSE_EMERGENCY_FUND_ACCOUNT";
    TierDowngradeActionKey["CloseInvestAccount"] = "CLOSE_INVEST_ACCOUNT";
    TierDowngradeActionKey["CloseLaterAccount"] = "CLOSE_LATER_ACCOUNT";
    TierDowngradeActionKey["CloseSelfDirectedInvest"] = "CLOSE_SELF_DIRECTED_INVEST";
    TierDowngradeActionKey["CloseSpendAccount"] = "CLOSE_SPEND_ACCOUNT";
})(TierDowngradeActionKey = exports.TierDowngradeActionKey || (exports.TierDowngradeActionKey = {}));
var TierKey;
(function (TierKey) {
    /** Hardship $1 tier for our winback campaign */
    TierKey["Assist"] = "ASSIST";
    /** Legacy $2 SPEND tier */
    TierKey["Bronze"] = "BRONZE";
    TierKey["Copper"] = "COPPER";
    /** Promotional tier for Cricket Wireless subscribers. */
    TierKey["Cricket"] = "CRICKET";
    TierKey["Gold"] = "GOLD";
    /** Promotional free tier for active military and veterans */
    TierKey["Military"] = "MILITARY";
    TierKey["Null"] = "NULL";
    TierKey["Platinum"] = "PLATINUM";
    TierKey["Silver"] = "SILVER";
})(TierKey = exports.TierKey || (exports.TierKey = {}));
var TierSubscriptionCreatedBy;
(function (TierSubscriptionCreatedBy) {
    /** Subscription created by the pre-launch backfill script */
    TierSubscriptionCreatedBy["Backfill"] = "BACKFILL";
    /** Flag to indicate user ought to be billed by the "legacy" billing system */
    TierSubscriptionCreatedBy["LegacyUser"] = "LEGACY_USER";
    /** Subscription record that was created as a result of a migration */
    TierSubscriptionCreatedBy["Migration"] = "MIGRATION";
    /** User auto-subscribed based on the status of their open accounts */
    TierSubscriptionCreatedBy["SubscribedByOpenAccounts"] = "SUBSCRIBED_BY_OPEN_ACCOUNTS";
    /** Subscription created via INTERNAL client request (either an admin or an internal process) */
    TierSubscriptionCreatedBy["System"] = "SYSTEM";
    /** Subscription created via EXTERNAL client request */
    TierSubscriptionCreatedBy["User"] = "USER";
})(TierSubscriptionCreatedBy = exports.TierSubscriptionCreatedBy || (exports.TierSubscriptionCreatedBy = {}));
/** account deactivation reasons */
var TierSubscriptionDeactivationReason;
(function (TierSubscriptionDeactivationReason) {
    TierSubscriptionDeactivationReason["AcornsCostsTooMuch"] = "ACORNS_COSTS_TOO_MUCH";
    TierSubscriptionDeactivationReason["CantAffordToInvestAtThisTime"] = "CANT_AFFORD_TO_INVEST_AT_THIS_TIME";
    TierSubscriptionDeactivationReason["ConcernedAboutTheMarket"] = "CONCERNED_ABOUT_THE_MARKET";
    TierSubscriptionDeactivationReason["DontWantToInvest"] = "DONT_WANT_TO_INVEST";
    TierSubscriptionDeactivationReason["NotEnoughControlOverMyInvestments"] = "NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS";
    TierSubscriptionDeactivationReason["NotSureHowAcornsWorks"] = "NOT_SURE_HOW_ACORNS_WORKS";
    TierSubscriptionDeactivationReason["NotTheRightTimeToInvest"] = "NOT_THE_RIGHT_TIME_TO_INVEST";
    TierSubscriptionDeactivationReason["Other"] = "OTHER";
    TierSubscriptionDeactivationReason["PoorInvestmentPerformance"] = "POOR_INVESTMENT_PERFORMANCE";
    TierSubscriptionDeactivationReason["SwitchingToAnotherService"] = "SWITCHING_TO_ANOTHER_SERVICE";
    TierSubscriptionDeactivationReason["ThisIsTemporaryIllBeBack"] = "THIS_IS_TEMPORARY_ILL_BE_BACK";
    TierSubscriptionDeactivationReason["TroubleConnectingMyBank"] = "TROUBLE_CONNECTING_MY_BANK";
    TierSubscriptionDeactivationReason["UnexpectedChargesToMyBank"] = "UNEXPECTED_CHARGES_TO_MY_BANK";
})(TierSubscriptionDeactivationReason = exports.TierSubscriptionDeactivationReason || (exports.TierSubscriptionDeactivationReason = {}));
/** Status of a tier subscription */
var TierSubscriptionStatus;
(function (TierSubscriptionStatus) {
    /** An active subscription */
    TierSubscriptionStatus["Active"] = "ACTIVE";
    /** A cancelled subscription */
    TierSubscriptionStatus["Inactive"] = "INACTIVE";
    /** In the process of either upgrading or downgrading a subscription */
    TierSubscriptionStatus["Transitioning"] = "TRANSITIONING";
})(TierSubscriptionStatus = exports.TierSubscriptionStatus || (exports.TierSubscriptionStatus = {}));
var TimeFrameFilter;
(function (TimeFrameFilter) {
    TimeFrameFilter["Month"] = "month";
    TimeFrameFilter["NinetyDays"] = "ninetyDays";
    TimeFrameFilter["ThirtyDays"] = "thirtyDays";
    TimeFrameFilter["Year"] = "year";
})(TimeFrameFilter = exports.TimeFrameFilter || (exports.TimeFrameFilter = {}));
var TradingSector;
(function (TradingSector) {
    TradingSector["BasicMaterials"] = "BASIC_MATERIALS";
    TradingSector["CommunicationServices"] = "COMMUNICATION_SERVICES";
    TradingSector["ConsumerCyclical"] = "CONSUMER_CYCLICAL";
    TradingSector["ConsumerDefensive"] = "CONSUMER_DEFENSIVE";
    TradingSector["Energy"] = "ENERGY";
    TradingSector["FinancialServices"] = "FINANCIAL_SERVICES";
    TradingSector["HealthCare"] = "HEALTH_CARE";
    TradingSector["Industrials"] = "INDUSTRIALS";
    TradingSector["RealEstate"] = "REAL_ESTATE";
    TradingSector["Technology"] = "TECHNOLOGY";
    TradingSector["Utilities"] = "UTILITIES";
})(TradingSector = exports.TradingSector || (exports.TradingSector = {}));
var TransactionCategory;
(function (TransactionCategory) {
    TransactionCategory["Fee"] = "FEE";
    TransactionCategory["Refund"] = "REFUND";
})(TransactionCategory = exports.TransactionCategory || (exports.TransactionCategory = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["Credit"] = "CREDIT";
    TransactionType["Debit"] = "DEBIT";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var TransferAction;
(function (TransferAction) {
    /** Initiate a one time deposit to the top level account. */
    TransferAction["OneTimeDeposit"] = "ONE_TIME_DEPOSIT";
    /** Initiate a one time withdrawal from the top level account. */
    TransferAction["OneTimeWithdrawal"] = "ONE_TIME_WITHDRAWAL";
    /** Initiate a recurring deposit to the top level account. */
    TransferAction["RecurringDeposit"] = "RECURRING_DEPOSIT";
})(TransferAction = exports.TransferAction || (exports.TransferAction = {}));
var TransferState;
(function (TransferState) {
    TransferState["Canceled"] = "canceled";
    TransferState["Completed"] = "completed";
    TransferState["Initiated"] = "initiated";
    TransferState["Transferring"] = "transferring";
})(TransferState = exports.TransferState || (exports.TransferState = {}));
var TransferableAccountTypeEnum;
(function (TransferableAccountTypeEnum) {
    TransferableAccountTypeEnum["Core"] = "core";
    TransferableAccountTypeEnum["Early"] = "early";
    TransferableAccountTypeEnum["External"] = "external";
    TransferableAccountTypeEnum["Later"] = "later";
    TransferableAccountTypeEnum["Save"] = "save";
    TransferableAccountTypeEnum["Spend"] = "spend";
})(TransferableAccountTypeEnum = exports.TransferableAccountTypeEnum || (exports.TransferableAccountTypeEnum = {}));
var Type;
(function (Type) {
    Type["Charge"] = "charge";
    Type["Credit"] = "credit";
})(Type = exports.Type || (exports.Type = {}));
var UsStateCodes;
(function (UsStateCodes) {
    /** Armed Forces America */
    UsStateCodes["Aa"] = "AA";
    /** Armed Forces Europe */
    UsStateCodes["Ae"] = "AE";
    /** Alaska */
    UsStateCodes["Ak"] = "AK";
    /** Alabama */
    UsStateCodes["Al"] = "AL";
    /** Armed Forces Pacific */
    UsStateCodes["Ap"] = "AP";
    /** Arkansas */
    UsStateCodes["Ar"] = "AR";
    /** American Samoa */
    UsStateCodes["As"] = "AS";
    /** Arizona */
    UsStateCodes["Az"] = "AZ";
    /** California */
    UsStateCodes["Ca"] = "CA";
    /** Colorado */
    UsStateCodes["Co"] = "CO";
    /** Connecticut */
    UsStateCodes["Ct"] = "CT";
    /** District Of Columbia */
    UsStateCodes["Dc"] = "DC";
    /** Delaware */
    UsStateCodes["De"] = "DE";
    /** Florida */
    UsStateCodes["Fl"] = "FL";
    /** Federated States Of Micronesia */
    UsStateCodes["Fm"] = "FM";
    /** Georgia */
    UsStateCodes["Ga"] = "GA";
    /** Guam */
    UsStateCodes["Gu"] = "GU";
    /** Hawaii */
    UsStateCodes["Hi"] = "HI";
    /** Iowa */
    UsStateCodes["Ia"] = "IA";
    /** Idaho */
    UsStateCodes["Id"] = "ID";
    /** Illinois */
    UsStateCodes["Il"] = "IL";
    /** Indiana */
    UsStateCodes["In"] = "IN";
    /** Kansas */
    UsStateCodes["Ks"] = "KS";
    /** Kentucky */
    UsStateCodes["Ky"] = "KY";
    /** Louisiana */
    UsStateCodes["La"] = "LA";
    /** Massachusetts */
    UsStateCodes["Ma"] = "MA";
    /** Maryland */
    UsStateCodes["Md"] = "MD";
    /** Maine */
    UsStateCodes["Me"] = "ME";
    /** Marshall Islands */
    UsStateCodes["Mh"] = "MH";
    /** Michigan */
    UsStateCodes["Mi"] = "MI";
    /** Minnesota */
    UsStateCodes["Mn"] = "MN";
    /** Missouri */
    UsStateCodes["Mo"] = "MO";
    /** Northern Mariana Islands */
    UsStateCodes["Mp"] = "MP";
    /** Mississippi */
    UsStateCodes["Ms"] = "MS";
    /** Montana */
    UsStateCodes["Mt"] = "MT";
    /** North Carolina */
    UsStateCodes["Nc"] = "NC";
    /** North Dakota */
    UsStateCodes["Nd"] = "ND";
    /** Nebraska */
    UsStateCodes["Ne"] = "NE";
    /** New Hampshire */
    UsStateCodes["Nh"] = "NH";
    /** New Jersey */
    UsStateCodes["Nj"] = "NJ";
    /** New Mexico */
    UsStateCodes["Nm"] = "NM";
    /** Nevada */
    UsStateCodes["Nv"] = "NV";
    /** New York */
    UsStateCodes["Ny"] = "NY";
    /** Ohio */
    UsStateCodes["Oh"] = "OH";
    /** Oklahoma */
    UsStateCodes["Ok"] = "OK";
    /** Oregon */
    UsStateCodes["Or"] = "OR";
    /** Pennsylvania */
    UsStateCodes["Pa"] = "PA";
    /** Puerto Rico */
    UsStateCodes["Pr"] = "PR";
    /** Palau */
    UsStateCodes["Pw"] = "PW";
    /** Rhode Island */
    UsStateCodes["Ri"] = "RI";
    /** South Carolina */
    UsStateCodes["Sc"] = "SC";
    /** South Dakota */
    UsStateCodes["Sd"] = "SD";
    /** Tennessee */
    UsStateCodes["Tn"] = "TN";
    /** Texas */
    UsStateCodes["Tx"] = "TX";
    /** Utah */
    UsStateCodes["Ut"] = "UT";
    /** Virginia */
    UsStateCodes["Va"] = "VA";
    /** U.S. Virgin Islands */
    UsStateCodes["Vi"] = "VI";
    /** Vermont */
    UsStateCodes["Vt"] = "VT";
    /** Washington */
    UsStateCodes["Wa"] = "WA";
    /** Wisconsin */
    UsStateCodes["Wi"] = "WI";
    /** West Virginia */
    UsStateCodes["Wv"] = "WV";
    /** Wyoming */
    UsStateCodes["Wy"] = "WY";
})(UsStateCodes = exports.UsStateCodes || (exports.UsStateCodes = {}));
var UserMatchStatus;
(function (UserMatchStatus) {
    UserMatchStatus["UserMatchStatusEligible"] = "USER_MATCH_STATUS_ELIGIBLE";
    UserMatchStatus["UserMatchStatusIneligibleCancelled"] = "USER_MATCH_STATUS_INELIGIBLE_CANCELLED";
    UserMatchStatus["UserMatchStatusIneligibleIncorrectTier"] = "USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER";
    UserMatchStatus["UserMatchStatusInvalid"] = "USER_MATCH_STATUS_INVALID";
})(UserMatchStatus = exports.UserMatchStatus || (exports.UserMatchStatus = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["ActionRequired"] = "actionRequired";
    VerificationStatus["ActionRequiredDueToFailure"] = "actionRequiredDueToFailure";
    VerificationStatus["Failure"] = "failure";
    VerificationStatus["Pending"] = "pending";
    VerificationStatus["Success"] = "success";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
var WaiverPromotion;
(function (WaiverPromotion) {
    /** Cricket Wireless Promotion */
    WaiverPromotion["Cricket"] = "CRICKET";
    /** Mighty Oak Card Promotion */
    WaiverPromotion["MightyOakCard"] = "MIGHTY_OAK_CARD";
})(WaiverPromotion = exports.WaiverPromotion || (exports.WaiverPromotion = {}));
var WaiverPromotion_V2;
(function (WaiverPromotion_V2) {
    WaiverPromotion_V2["Cricket"] = "CRICKET";
    WaiverPromotion_V2["MightyOakCard"] = "MIGHTY_OAK_CARD";
})(WaiverPromotion_V2 = exports.WaiverPromotion_V2 || (exports.WaiverPromotion_V2 = {}));
var ReferralStatusDetails;
(function (ReferralStatusDetails) {
    ReferralStatusDetails["AcornsEmployee"] = "ACORNS_EMPLOYEE";
    ReferralStatusDetails["CampaignExpired"] = "CAMPAIGN_EXPIRED";
    ReferralStatusDetails["InactiveSubscription"] = "INACTIVE_SUBSCRIPTION";
    ReferralStatusDetails["InvestAccountClosed"] = "INVEST_ACCOUNT_CLOSED";
    ReferralStatusDetails["ManualPayout"] = "MANUAL_PAYOUT";
    ReferralStatusDetails["UserSuspened"] = "USER_SUSPENED";
})(ReferralStatusDetails = exports.ReferralStatusDetails || (exports.ReferralStatusDetails = {}));
exports.ValidateCredentialsDocument = graphql_tag_1["default"](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation ValidateCredentials($udid: String!, $idToken: String!, $nonce: String!, $oauth: Boolean!) {\n  validateCredentials(\n    input: {udid: $udid, credentialsType: APPLE, oidcLoginInput: {idToken: $idToken, nonce: $nonce}}\n  ) {\n    __typename\n    ... on AuthSession {\n      __typename\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on ValidateCredentialsSuccess {\n      mfaToken\n      userId\n      authenticators {\n        id\n        lastUsedAt\n        lastAuthenticatedAt\n        lastUsedAt\n        name\n        type\n        updatedAt\n      }\n    }\n    ... on InvalidCredentialsException {\n      message\n    }\n    ... on DeviceBlockedException {\n      message\n    }\n    ... on LoginRateLimitedException {\n      message\n    }\n    ... on UserSuspendedException {\n      suspendedToken\n      message\n    }\n    ... on OidcCredentialsNotFoundException {\n      oidcNotFoundUserId: userId\n      oidcProvider\n    }\n  }\n}\n    "], ["\n    mutation ValidateCredentials($udid: String!, $idToken: String!, $nonce: String!, $oauth: Boolean!) {\n  validateCredentials(\n    input: {udid: $udid, credentialsType: APPLE, oidcLoginInput: {idToken: $idToken, nonce: $nonce}}\n  ) {\n    __typename\n    ... on AuthSession {\n      __typename\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on ValidateCredentialsSuccess {\n      mfaToken\n      userId\n      authenticators {\n        id\n        lastUsedAt\n        lastAuthenticatedAt\n        lastUsedAt\n        name\n        type\n        updatedAt\n      }\n    }\n    ... on InvalidCredentialsException {\n      message\n    }\n    ... on DeviceBlockedException {\n      message\n    }\n    ... on LoginRateLimitedException {\n      message\n    }\n    ... on UserSuspendedException {\n      suspendedToken\n      message\n    }\n    ... on OidcCredentialsNotFoundException {\n      oidcNotFoundUserId: userId\n      oidcProvider\n    }\n  }\n}\n    "])));
/**
 * __useValidateCredentialsMutation__
 *
 * To run a mutation, you first call `useValidateCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCredentialsMutation, { data, loading, error }] = useValidateCredentialsMutation({
 *   variables: {
 *      udid: // value for 'udid'
 *      idToken: // value for 'idToken'
 *      nonce: // value for 'nonce'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
function useValidateCredentialsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.ValidateCredentialsDocument, options);
}
exports.useValidateCredentialsMutation = useValidateCredentialsMutation;
exports.LogoutDocument = graphql_tag_1["default"](templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation Logout {\n  logout {\n    __typename\n  }\n}\n    "], ["\n    mutation Logout {\n  logout {\n    __typename\n  }\n}\n    "])));
/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
function useLogoutMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.LogoutDocument, options);
}
exports.useLogoutMutation = useLogoutMutation;
exports.AuthenticateDocument = graphql_tag_1["default"](templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    mutation Authenticate($input: AuthenticateInput!, $oauth: Boolean = false) {\n  authenticate(input: $input) {\n    __typename\n    ... on AuthSession {\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on InvalidCredentialsException {\n      message\n    }\n    ... on UserSuspendedException {\n      message\n      suspensionReasonValid\n      suspendedToken @skip(if: $oauth)\n    }\n    ... on DeviceBlockedException {\n      message\n    }\n    ... on UserLockedException {\n      message\n    }\n    ... on PhoneNumberOptedOutException {\n      message\n    }\n  }\n}\n    "], ["\n    mutation Authenticate($input: AuthenticateInput!, $oauth: Boolean = false) {\n  authenticate(input: $input) {\n    __typename\n    ... on AuthSession {\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on InvalidCredentialsException {\n      message\n    }\n    ... on UserSuspendedException {\n      message\n      suspensionReasonValid\n      suspendedToken @skip(if: $oauth)\n    }\n    ... on DeviceBlockedException {\n      message\n    }\n    ... on UserLockedException {\n      message\n    }\n    ... on PhoneNumberOptedOutException {\n      message\n    }\n  }\n}\n    "])));
/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
function useAuthenticateMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.AuthenticateDocument, options);
}
exports.useAuthenticateMutation = useAuthenticateMutation;
exports.EmailAddressValidationDocument = graphql_tag_1["default"](templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    query EmailAddressValidation($email: EmailAddress!) {\n  emailAddressValidation(email: $email) {\n    credentialsExist\n  }\n}\n    "], ["\n    query EmailAddressValidation($email: EmailAddress!) {\n  emailAddressValidation(email: $email) {\n    credentialsExist\n  }\n}\n    "])));
/**
 * __useEmailAddressValidationQuery__
 *
 * To run a query within a React component, call `useEmailAddressValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressValidationQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
function useEmailAddressValidationQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useQuery(exports.EmailAddressValidationDocument, options);
}
exports.useEmailAddressValidationQuery = useEmailAddressValidationQuery;
function useEmailAddressValidationLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useLazyQuery(exports.EmailAddressValidationDocument, options);
}
exports.useEmailAddressValidationLazyQuery = useEmailAddressValidationLazyQuery;
exports.ChallengeAuthenticateDocument = graphql_tag_1["default"](templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    mutation ChallengeAuthenticate($input: AuthenticateInput!, $challengeAnswerInput: ChallengeAnswerInput, $alternateAuthenticatorId: ID, $oauth: Boolean = false) {\n  authenticate(\n    input: $input\n    challengeAnswerInput: $challengeAnswerInput\n    alternateAuthenticatorId: $alternateAuthenticatorId\n  ) {\n    __typename\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on AuthSession {\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on AuthChallengeAnswerIncorrectException {\n      message\n    }\n    ... on AuthChallengeAnswerAttemptsExhaustedException {\n      message\n    }\n    ... on AuthChallengeExpiredException {\n      message\n    }\n    ... on UserLockedException {\n      message\n    }\n    ... on PhoneNumberOptedOutException {\n      message\n    }\n    ... on UserSuspendedException {\n      message\n      suspensionReasonValid\n      suspendedToken @skip(if: $oauth)\n    }\n  }\n}\n    "], ["\n    mutation ChallengeAuthenticate($input: AuthenticateInput!, $challengeAnswerInput: ChallengeAnswerInput, $alternateAuthenticatorId: ID, $oauth: Boolean = false) {\n  authenticate(\n    input: $input\n    challengeAnswerInput: $challengeAnswerInput\n    alternateAuthenticatorId: $alternateAuthenticatorId\n  ) {\n    __typename\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n      alternateAuthenticators {\n        id\n        type\n      }\n    }\n    ... on AuthSession {\n      id\n      token @skip(if: $oauth)\n      refreshToken @skip(if: $oauth)\n      identityId\n    }\n    ... on AuthChallengeAnswerIncorrectException {\n      message\n    }\n    ... on AuthChallengeAnswerAttemptsExhaustedException {\n      message\n    }\n    ... on AuthChallengeExpiredException {\n      message\n    }\n    ... on UserLockedException {\n      message\n    }\n    ... on PhoneNumberOptedOutException {\n      message\n    }\n    ... on UserSuspendedException {\n      message\n      suspensionReasonValid\n      suspendedToken @skip(if: $oauth)\n    }\n  }\n}\n    "])));
/**
 * __useChallengeAuthenticateMutation__
 *
 * To run a mutation, you first call `useChallengeAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeAuthenticateMutation, { data, loading, error }] = useChallengeAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      challengeAnswerInput: // value for 'challengeAnswerInput'
 *      alternateAuthenticatorId: // value for 'alternateAuthenticatorId'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
function useChallengeAuthenticateMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.ChallengeAuthenticateDocument, options);
}
exports.useChallengeAuthenticateMutation = useChallengeAuthenticateMutation;
exports.ReinitiateChallengeDocument = graphql_tag_1["default"](templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    mutation ReinitiateChallenge($input: ReinitiateSMSChallengeInput!) {\n  reinitiateChallenge(input: $input) {\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n    }\n    ... on AuthChallengeExpiredException {\n      message\n    }\n  }\n}\n    "], ["\n    mutation ReinitiateChallenge($input: ReinitiateSMSChallengeInput!) {\n  reinitiateChallenge(input: $input) {\n    ... on SMSAuthChallenge {\n      id\n      maskedPhoneNumber\n    }\n    ... on EmailAuthChallenge {\n      id\n      maskedEmail\n    }\n    ... on AuthChallengeExpiredException {\n      message\n    }\n  }\n}\n    "])));
/**
 * __useReinitiateChallengeMutation__
 *
 * To run a mutation, you first call `useReinitiateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinitiateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinitiateChallengeMutation, { data, loading, error }] = useReinitiateChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useReinitiateChallengeMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.ReinitiateChallengeDocument, options);
}
exports.useReinitiateChallengeMutation = useReinitiateChallengeMutation;
exports.ResetPasswordWithTokenDocument = graphql_tag_1["default"](templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    mutation ResetPasswordWithToken($password: String!, $passwordConfirmation: String!, $resetToken: String!, $last4Ssn: String) {\n  resetPasswordWithToken(\n    input: {password: $password, passwordConfirmation: $passwordConfirmation, resetToken: $resetToken, last4Ssn: $last4Ssn}\n  ) {\n    __typename\n    ... on ResetPasswordWithTokenSuccess {\n      userId\n    }\n    __typename\n    ... on InvalidPasswordResetTokenException {\n      invalidToken\n    }\n    __typename\n    ... on UserCredentialsNotFoundException {\n      message\n    }\n    __typename\n    ... on InvalidPasswordResetException {\n      errors\n    }\n  }\n}\n    "], ["\n    mutation ResetPasswordWithToken($password: String!, $passwordConfirmation: String!, $resetToken: String!, $last4Ssn: String) {\n  resetPasswordWithToken(\n    input: {password: $password, passwordConfirmation: $passwordConfirmation, resetToken: $resetToken, last4Ssn: $last4Ssn}\n  ) {\n    __typename\n    ... on ResetPasswordWithTokenSuccess {\n      userId\n    }\n    __typename\n    ... on InvalidPasswordResetTokenException {\n      invalidToken\n    }\n    __typename\n    ... on UserCredentialsNotFoundException {\n      message\n    }\n    __typename\n    ... on InvalidPasswordResetException {\n      errors\n    }\n  }\n}\n    "])));
/**
 * __useResetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithTokenMutation, { data, loading, error }] = useResetPasswordWithTokenMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      resetToken: // value for 'resetToken'
 *      last4Ssn: // value for 'last4Ssn'
 *   },
 * });
 */
function useResetPasswordWithTokenMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useMutation(exports.ResetPasswordWithTokenDocument, options);
}
exports.useResetPasswordWithTokenMutation = useResetPasswordWithTokenMutation;
exports.ValidatePasswordResetTokenDocument = graphql_tag_1["default"](templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    query validatePasswordResetToken($resetToken: String!) {\n  validatePasswordResetToken(resetToken: $resetToken) {\n    __typename\n    ... on InvalidPasswordResetTokenException {\n      invalidToken\n    }\n    ... on ValidatePasswordResetTokenSuccess {\n      displaySsnField\n    }\n  }\n}\n    "], ["\n    query validatePasswordResetToken($resetToken: String!) {\n  validatePasswordResetToken(resetToken: $resetToken) {\n    __typename\n    ... on InvalidPasswordResetTokenException {\n      invalidToken\n    }\n    ... on ValidatePasswordResetTokenSuccess {\n      displaySsnField\n    }\n  }\n}\n    "])));
/**
 * __useValidatePasswordResetTokenQuery__
 *
 * To run a query within a React component, call `useValidatePasswordResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordResetTokenQuery({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
function useValidatePasswordResetTokenQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useQuery(exports.ValidatePasswordResetTokenDocument, options);
}
exports.useValidatePasswordResetTokenQuery = useValidatePasswordResetTokenQuery;
function useValidatePasswordResetTokenLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useLazyQuery(exports.ValidatePasswordResetTokenDocument, options);
}
exports.useValidatePasswordResetTokenLazyQuery = useValidatePasswordResetTokenLazyQuery;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
